import L1 from "react";
var U = { exports: {} }, b = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V1;
function w5() {
  if (V1) return b;
  V1 = 1;
  var c = L1, j = Symbol.for("react.element"), z = Symbol.for("react.fragment"), H = Object.prototype.hasOwnProperty, k = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, D = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(M, w, B) {
    var m, u = {}, C = null, S = null;
    B !== void 0 && (C = "" + B), w.key !== void 0 && (C = "" + w.key), w.ref !== void 0 && (S = w.ref);
    for (m in w) H.call(w, m) && !D.hasOwnProperty(m) && (u[m] = w[m]);
    if (M && M.defaultProps) for (m in w = M.defaultProps, w) u[m] === void 0 && (u[m] = w[m]);
    return { $$typeof: j, type: M, key: C, ref: S, props: u, _owner: k.current };
  }
  return b.Fragment = z, b.jsx = y, b.jsxs = y, b;
}
var F = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var z1;
function x5() {
  return z1 || (z1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var c = L1, j = Symbol.for("react.element"), z = Symbol.for("react.portal"), H = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), M = Symbol.for("react.context"), w = Symbol.for("react.forward_ref"), B = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), C = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), K = Symbol.iterator, X1 = "@@iterator";
    function R1(a) {
      if (a === null || typeof a != "object")
        return null;
      var t = K && a[K] || a[X1];
      return typeof t == "function" ? t : null;
    }
    var L = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(a) {
      {
        for (var t = arguments.length, h = new Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)
          h[e - 1] = arguments[e];
        y1("error", a, h);
      }
    }
    function y1(a, t, h) {
      {
        var e = L.ReactDebugCurrentFrame, s = e.getStackAddendum();
        s !== "" && (t += "%s", h = h.concat([s]));
        var o = h.map(function(i) {
          return String(i);
        });
        o.unshift("Warning: " + t), Function.prototype.apply.call(console[a], console, o);
      }
    }
    var Z1 = !1, E1 = !1, b1 = !1, F1 = !1, k1 = !1, Q;
    Q = Symbol.for("react.module.reference");
    function D1(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === H || a === D || k1 || a === k || a === B || a === m || F1 || a === S || Z1 || E1 || b1 || typeof a == "object" && a !== null && (a.$$typeof === C || a.$$typeof === u || a.$$typeof === y || a.$$typeof === M || a.$$typeof === w || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === Q || a.getModuleId !== void 0));
    }
    function S1(a, t, h) {
      var e = a.displayName;
      if (e)
        return e;
      var s = t.displayName || t.name || "";
      return s !== "" ? h + "(" + s + ")" : h;
    }
    function l1(a) {
      return a.displayName || "Context";
    }
    function f(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case H:
          return "Fragment";
        case z:
          return "Portal";
        case D:
          return "Profiler";
        case k:
          return "StrictMode";
        case B:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case M:
            var t = a;
            return l1(t) + ".Consumer";
          case y:
            var h = a;
            return l1(h._context) + ".Provider";
          case w:
            return S1(a, a.render, "ForwardRef");
          case u:
            var e = a.displayName || null;
            return e !== null ? e : f(a.type) || "Memo";
          case C: {
            var s = a, o = s._payload, i = s._init;
            try {
              return f(i(o));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, Z = 0, c1, a1, t1, h1, e1, r1, i1;
    function s1() {
    }
    s1.__reactDisabledLog = !0;
    function P1() {
      {
        if (Z === 0) {
          c1 = console.log, a1 = console.info, t1 = console.warn, h1 = console.error, e1 = console.group, r1 = console.groupCollapsed, i1 = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: s1,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        Z++;
      }
    }
    function T1() {
      {
        if (Z--, Z === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, a, {
              value: c1
            }),
            info: A({}, a, {
              value: a1
            }),
            warn: A({}, a, {
              value: t1
            }),
            error: A({}, a, {
              value: h1
            }),
            group: A({}, a, {
              value: e1
            }),
            groupCollapsed: A({}, a, {
              value: r1
            }),
            groupEnd: A({}, a, {
              value: i1
            })
          });
        }
        Z < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = L.ReactCurrentDispatcher, I;
    function P(a, t, h) {
      {
        if (I === void 0)
          try {
            throw Error();
          } catch (s) {
            var e = s.stack.trim().match(/\n( *(at )?)/);
            I = e && e[1] || "";
          }
        return `
` + I + a;
      }
    }
    var W = !1, T;
    {
      var _1 = typeof WeakMap == "function" ? WeakMap : Map;
      T = new _1();
    }
    function o1(a, t) {
      if (!a || W)
        return "";
      {
        var h = T.get(a);
        if (h !== void 0)
          return h;
      }
      var e;
      W = !0;
      var s = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var o;
      o = q.current, q.current = null, P1();
      try {
        if (t) {
          var i = function() {
            throw Error();
          };
          if (Object.defineProperty(i.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(i, []);
            } catch (g) {
              e = g;
            }
            Reflect.construct(a, [], i);
          } else {
            try {
              i.call();
            } catch (g) {
              e = g;
            }
            a.call(i.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (g) {
            e = g;
          }
          a();
        }
      } catch (g) {
        if (g && e && typeof g.stack == "string") {
          for (var r = g.stack.split(`
`), d = e.stack.split(`
`), n = r.length - 1, v = d.length - 1; n >= 1 && v >= 0 && r[n] !== d[v]; )
            v--;
          for (; n >= 1 && v >= 0; n--, v--)
            if (r[n] !== d[v]) {
              if (n !== 1 || v !== 1)
                do
                  if (n--, v--, v < 0 || r[n] !== d[v]) {
                    var p = `
` + r[n].replace(" at new ", " at ");
                    return a.displayName && p.includes("<anonymous>") && (p = p.replace("<anonymous>", a.displayName)), typeof a == "function" && T.set(a, p), p;
                  }
                while (n >= 1 && v >= 0);
              break;
            }
        }
      } finally {
        W = !1, q.current = o, T1(), Error.prepareStackTrace = s;
      }
      var R = a ? a.displayName || a.name : "", V = R ? P(R) : "";
      return typeof a == "function" && T.set(a, V), V;
    }
    function O1(a, t, h) {
      return o1(a, !1);
    }
    function U1(a) {
      var t = a.prototype;
      return !!(t && t.isReactComponent);
    }
    function _(a, t, h) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return o1(a, U1(a));
      if (typeof a == "string")
        return P(a);
      switch (a) {
        case B:
          return P("Suspense");
        case m:
          return P("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case w:
            return O1(a.render);
          case u:
            return _(a.type, t, h);
          case C: {
            var e = a, s = e._payload, o = e._init;
            try {
              return _(o(s), t, h);
            } catch {
            }
          }
        }
      return "";
    }
    var E = Object.prototype.hasOwnProperty, n1 = {}, v1 = L.ReactDebugCurrentFrame;
    function O(a) {
      if (a) {
        var t = a._owner, h = _(a.type, a._source, t ? t.type : null);
        v1.setExtraStackFrame(h);
      } else
        v1.setExtraStackFrame(null);
    }
    function q1(a, t, h, e, s) {
      {
        var o = Function.call.bind(E);
        for (var i in a)
          if (o(a, i)) {
            var r = void 0;
            try {
              if (typeof a[i] != "function") {
                var d = Error((e || "React class") + ": " + h + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw d.name = "Invariant Violation", d;
              }
              r = a[i](t, i, e, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (n) {
              r = n;
            }
            r && !(r instanceof Error) && (O(s), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", e || "React class", h, i, typeof r), O(null)), r instanceof Error && !(r.message in n1) && (n1[r.message] = !0, O(s), x("Failed %s type: %s", h, r.message), O(null));
          }
      }
    }
    var I1 = Array.isArray;
    function $(a) {
      return I1(a);
    }
    function W1(a) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, h = t && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return h;
      }
    }
    function $1(a) {
      try {
        return w1(a), !1;
      } catch {
        return !0;
      }
    }
    function w1(a) {
      return "" + a;
    }
    function x1(a) {
      if ($1(a))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", W1(a)), w1(a);
    }
    var d1 = L.ReactCurrentOwner, Y1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, g1, m1;
    function G1(a) {
      if (E.call(a, "ref")) {
        var t = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function N1(a) {
      if (E.call(a, "key")) {
        var t = Object.getOwnPropertyDescriptor(a, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function J1(a, t) {
      typeof a.ref == "string" && d1.current;
    }
    function K1(a, t) {
      {
        var h = function() {
          g1 || (g1 = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        h.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: h,
          configurable: !0
        });
      }
    }
    function Q1(a, t) {
      {
        var h = function() {
          m1 || (m1 = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        h.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: h,
          configurable: !0
        });
      }
    }
    var l5 = function(a, t, h, e, s, o, i) {
      var r = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: j,
        // Built-in properties that belong on the element
        type: a,
        key: t,
        ref: h,
        props: i,
        // Record the component responsible for creating this element.
        _owner: o
      };
      return r._store = {}, Object.defineProperty(r._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(r, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: e
      }), Object.defineProperty(r, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.freeze && (Object.freeze(r.props), Object.freeze(r)), r;
    };
    function c5(a, t, h, e, s) {
      {
        var o, i = {}, r = null, d = null;
        h !== void 0 && (x1(h), r = "" + h), N1(t) && (x1(t.key), r = "" + t.key), G1(t) && (d = t.ref, J1(t, s));
        for (o in t)
          E.call(t, o) && !Y1.hasOwnProperty(o) && (i[o] = t[o]);
        if (a && a.defaultProps) {
          var n = a.defaultProps;
          for (o in n)
            i[o] === void 0 && (i[o] = n[o]);
        }
        if (r || d) {
          var v = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          r && K1(i, v), d && Q1(i, v);
        }
        return l5(a, r, d, s, e, d1.current, i);
      }
    }
    var Y = L.ReactCurrentOwner, p1 = L.ReactDebugCurrentFrame;
    function X(a) {
      if (a) {
        var t = a._owner, h = _(a.type, a._source, t ? t.type : null);
        p1.setExtraStackFrame(h);
      } else
        p1.setExtraStackFrame(null);
    }
    var G;
    G = !1;
    function N(a) {
      return typeof a == "object" && a !== null && a.$$typeof === j;
    }
    function u1() {
      {
        if (Y.current) {
          var a = f(Y.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function a5(a) {
      return "";
    }
    var f1 = {};
    function t5(a) {
      {
        var t = u1();
        if (!t) {
          var h = typeof a == "string" ? a : a.displayName || a.name;
          h && (t = `

Check the top-level render call using <` + h + ">.");
        }
        return t;
      }
    }
    function j1(a, t) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var h = t5(t);
        if (f1[h])
          return;
        f1[h] = !0;
        var e = "";
        a && a._owner && a._owner !== Y.current && (e = " It was passed a child from " + f(a._owner.type) + "."), X(a), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', h, e), X(null);
      }
    }
    function M1(a, t) {
      {
        if (typeof a != "object")
          return;
        if ($(a))
          for (var h = 0; h < a.length; h++) {
            var e = a[h];
            N(e) && j1(e, t);
          }
        else if (N(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var s = R1(a);
          if (typeof s == "function" && s !== a.entries)
            for (var o = s.call(a), i; !(i = o.next()).done; )
              N(i.value) && j1(i.value, t);
        }
      }
    }
    function h5(a) {
      {
        var t = a.type;
        if (t == null || typeof t == "string")
          return;
        var h;
        if (typeof t == "function")
          h = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === w || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === u))
          h = t.propTypes;
        else
          return;
        if (h) {
          var e = f(t);
          q1(h, a.props, "prop", e, a);
        } else if (t.PropTypes !== void 0 && !G) {
          G = !0;
          var s = f(t);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", s || "Unknown");
        }
        typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function e5(a) {
      {
        for (var t = Object.keys(a.props), h = 0; h < t.length; h++) {
          var e = t[h];
          if (e !== "children" && e !== "key") {
            X(a), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", e), X(null);
            break;
          }
        }
        a.ref !== null && (X(a), x("Invalid attribute `ref` supplied to `React.Fragment`."), X(null));
      }
    }
    var C1 = {};
    function A1(a, t, h, e, s, o) {
      {
        var i = D1(a);
        if (!i) {
          var r = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (r += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var d = a5();
          d ? r += d : r += u1();
          var n;
          a === null ? n = "null" : $(a) ? n = "array" : a !== void 0 && a.$$typeof === j ? (n = "<" + (f(a.type) || "Unknown") + " />", r = " Did you accidentally export a JSX literal instead of a component?") : n = typeof a, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", n, r);
        }
        var v = c5(a, t, h, s, o);
        if (v == null)
          return v;
        if (i) {
          var p = t.children;
          if (p !== void 0)
            if (e)
              if ($(p)) {
                for (var R = 0; R < p.length; R++)
                  M1(p[R], a);
                Object.freeze && Object.freeze(p);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              M1(p, a);
        }
        if (E.call(t, "key")) {
          var V = f(a), g = Object.keys(t).filter(function(v5) {
            return v5 !== "key";
          }), J = g.length > 0 ? "{key: someKey, " + g.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!C1[V + J]) {
            var n5 = g.length > 0 ? "{" + g.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, J, V, n5, V), C1[V + J] = !0;
          }
        }
        return a === H ? e5(v) : h5(v), v;
      }
    }
    function r5(a, t, h) {
      return A1(a, t, h, !0);
    }
    function i5(a, t, h) {
      return A1(a, t, h, !1);
    }
    var s5 = i5, o5 = r5;
    F.Fragment = H, F.jsx = s5, F.jsxs = o5;
  })()), F;
}
var H1;
function d5() {
  return H1 || (H1 = 1, process.env.NODE_ENV === "production" ? U.exports = w5() : U.exports = x5()), U.exports;
}
var l = d5();
const g5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16.5 10c0-2.469-2.031-4.5-4.5-4.5-2.5 0-4.5 2.031-4.5 4.5 0 .406.125 1 .469 1.813.312.75.781 1.624 1.312 2.5.906 1.437 1.938 2.812 2.719 3.812.75-1 1.781-2.375 2.688-3.813.53-.874 1-1.75 1.312-2.5.344-.812.5-1.406.5-1.812m1.5 0c0 2.75-3.656 7.594-5.281 9.625a.943.943 0 0 1-1.469 0C9.656 17.594 6 12.75 6 10c0-3.313 2.688-6 6-6 3.313 0 6 2.688 6 6m-5 0c0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1 .531 0 1-.438 1-1m-3.5 0c0-.875.469-1.688 1.25-2.156.75-.438 1.719-.438 2.5 0C14 8.312 14.5 9.125 14.5 10c0 .906-.5 1.719-1.25 2.188-.781.437-1.75.437-2.5 0A2.53 2.53 0 0 1 9.5 10" })
  }
), m5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.875 11.75c0 .21.164.375.375.375h7.5a.385.385 0 0 0 .375-.375v-7.5a.4.4 0 0 0-.375-.375h-7.5a.385.385 0 0 0-.375.375zM2.75 4.25c0-.82.656-1.5 1.5-1.5h7.5c.82 0 1.5.68 1.5 1.5v7.5c0 .844-.68 1.5-1.5 1.5h-7.5a1.48 1.48 0 0 1-1.5-1.5zM5 6.125c0-.305.234-.563.563-.563h.75v-.375c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563v.375h3a.57.57 0 0 1 .562.562.555.555 0 0 1-.563.563h-3v.375a.555.555 0 0 1-.562.562.54.54 0 0 1-.563-.563v-.375h-.75A.54.54 0 0 1 5 6.125m.563 4.313A.54.54 0 0 1 5 9.874c0-.305.234-.563.563-.563h3v-.374c0-.305.234-.563.562-.563a.57.57 0 0 1 .563.563v.374h.75a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.563h-.75v.374a.555.555 0 0 1-.562.563.54.54 0 0 1-.563-.563v-.374h-3Z" })
  }
), p5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.5 17c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5H7c-.281 0-.5.25-.5.5zM5 7c0-1.094.875-2 2-2h10c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2zm3 2.5a.74.74 0 0 1 .75-.75h1v-.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v.5h4a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-4v.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-.5h-1A.72.72 0 0 1 8 9.5m.75 5.75A.72.72 0 0 1 8 14.5a.74.74 0 0 1 .75-.75h4v-.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v.5h1a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-1v.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-.5z" })
  }
), u5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 17a.74.74 0 0 1 .75-.75h1.844c.312-1 1.281-1.75 2.406-1.75 1.094 0 2.063.75 2.375 1.75h7.875A.76.76 0 0 1 20 17a.74.74 0 0 1-.75.75h-7.875A2.485 2.485 0 0 1 9 19.5c-1.125 0-2.094-.719-2.406-1.75H4.75A.72.72 0 0 1 4 17m4 0c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1m6-5c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1m1-2.5c1.094 0 2.063.75 2.375 1.75h1.875A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-1.875A2.485 2.485 0 0 1 15 14.5c-1.125 0-2.094-.719-2.406-1.75H4.75A.72.72 0 0 1 4 12a.74.74 0 0 1 .75-.75h7.844c.312-1 1.281-1.75 2.406-1.75M10 8c.531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1m2.375-1.75h6.875A.76.76 0 0 1 20 7a.74.74 0 0 1-.75.75h-6.875A2.485 2.485 0 0 1 10 9.5c-1.125 0-2.094-.719-2.406-1.75H4.75A.72.72 0 0 1 4 7a.74.74 0 0 1 .75-.75h2.844C7.906 5.25 8.875 4.5 10 4.5c1.094 0 2.063.75 2.375 1.75" })
  }
), f5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M4 17c0-.531.438-1 1-1h1.688a2.7 2.7 0 0 0-.188 1c0 .375.063.719.188 1H5c-.563 0-1-.438-1-1m7.281 1c.125-.281.219-.625.219-1 0-.344-.094-.688-.219-1H19c.531 0 1 .469 1 1 0 .563-.469 1-1 1zM4 12c0-.531.438-1 1-1h7.688a2.7 2.7 0 0 0-.188 1c0 .375.063.719.188 1H5c-.563 0-1-.438-1-1m13.281 1c.125-.281.219-.625.219-1 0-.344-.094-.688-.219-1H19c.531 0 1 .469 1 1 0 .563-.469 1-1 1zM5 6h2.688A2.7 2.7 0 0 0 7.5 7c0 .375.063.719.188 1H5c-.563 0-1-.438-1-1 0-.531.438-1 1-1m7.281 2c.125-.281.219-.625.219-1 0-.344-.094-.688-.219-1H19c.531 0 1 .469 1 1 0 .563-.469 1-1 1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M8 17c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1m3.5 0c0 .906-.5 1.719-1.25 2.188-.781.437-1.75.437-2.5 0A2.53 2.53 0 0 1 6.5 17c0-.875.469-1.688 1.25-2.156.75-.438 1.719-.438 2.5 0 .75.469 1.25 1.281 1.25 2.156m2.5-5c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1m3.5 0c0 .906-.5 1.719-1.25 2.188-.781.437-1.75.437-2.5 0A2.53 2.53 0 0 1 12.5 12c0-.875.469-1.688 1.25-2.156.75-.438 1.719-.438 2.5 0 .75.469 1.25 1.281 1.25 2.156M10 8c.531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1m0-3.5c.875 0 1.688.5 2.156 1.25.438.781.438 1.75 0 2.5-.469.781-1.281 1.25-2.156 1.25a2.53 2.53 0 0 1-2.188-1.25c-.437-.75-.437-1.719 0-2.5C8.283 5 9.095 4.5 10 4.5"
        }
      )
    ]
  }
), j5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 17a.74.74 0 0 1 .75-.75h1.844c.312-1 1.281-1.75 2.406-1.75 1.094 0 2.063.75 2.375 1.75h7.875A.76.76 0 0 1 20 17a.74.74 0 0 1-.75.75h-7.875A2.485 2.485 0 0 1 9 19.5c-1.125 0-2.094-.719-2.406-1.75H4.75A.72.72 0 0 1 4 17m11-7.5c1.094 0 2.063.75 2.375 1.75h1.875A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-1.875A2.485 2.485 0 0 1 15 14.5c-1.125 0-2.094-.719-2.406-1.75H4.75A.72.72 0 0 1 4 12a.74.74 0 0 1 .75-.75h7.844c.312-1 1.281-1.75 2.406-1.75m-2.625-3.25h6.875A.76.76 0 0 1 20 7a.74.74 0 0 1-.75.75h-6.875A2.485 2.485 0 0 1 10 9.5c-1.125 0-2.094-.719-2.406-1.75H4.75A.72.72 0 0 1 4 7a.74.74 0 0 1 .75-.75h2.844C7.906 5.25 8.875 4.5 10 4.5c1.094 0 2.063.75 2.375 1.75" })
  }
), M5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2 18.75c0-.313.273-.625.625-.625h2.54c.312-1.406 1.562-2.5 3.085-2.5 1.484 0 2.773 1.094 3.047 2.5h10.078c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625H11.297c-.274 1.445-1.563 2.5-3.047 2.5a3.14 3.14 0 0 1-3.086-2.5H2.625A.617.617 0 0 1 2 18.75m4.375 0c0 .703.352 1.29.938 1.64.546.352 1.289.352 1.875 0 .546-.35.937-.937.937-1.64 0-.664-.39-1.25-.938-1.602-.585-.351-1.328-.351-1.874 0-.586.352-.938.938-.938 1.602m7.5-6.25c0 .703.352 1.29.938 1.64.546.352 1.289.352 1.874 0 .547-.35.938-.937.938-1.64 0-.664-.39-1.25-.938-1.602-.585-.351-1.328-.351-1.875 0-.585.352-.937.938-.937 1.602m1.875-3.125c1.484 0 2.773 1.094 3.047 2.5h2.578c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625h-2.578c-.274 1.445-1.563 2.5-3.047 2.5a3.14 3.14 0 0 1-3.086-2.5H2.625A.617.617 0 0 1 2 12.5c0-.313.273-.625.625-.625h10.04c.312-1.406 1.562-2.5 3.085-2.5M9.5 8.125c.664 0 1.25-.352 1.602-.938.351-.546.351-1.289 0-1.875-.352-.546-.938-.937-1.602-.937-.703 0-1.29.39-1.64.938-.352.585-.352 1.328 0 1.875a1.87 1.87 0 0 0 1.64.937m3.047-2.5h8.828c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625h-8.828c-.274 1.445-1.563 2.5-3.047 2.5a3.14 3.14 0 0 1-3.086-2.5H2.625A.617.617 0 0 1 2 6.25c0-.313.273-.625.625-.625h3.79c.312-1.406 1.562-2.5 3.085-2.5 1.484 0 2.773 1.094 3.047 2.5" })
  }
), C5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5c.438 0 .844.25 1.063.625l6.75 11.5c.218.406.218.875 0 1.25A1.19 1.19 0 0 1 18.75 19H5.25c-.469 0-.875-.219-1.094-.625a1.27 1.27 0 0 1 0-1.25l6.75-11.5A1.26 1.26 0 0 1 12 5m0 4a.74.74 0 0 0-.75.75v3.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-3.5A.76.76 0 0 0 12 9m1 7c0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1 .531 0 1-.438 1-1" })
  }
), A5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.906 6.125 6.97 17.5h11.28a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H5.75c-.281 0-.531-.125-.656-.344a.8.8 0 0 1-.032-.75l6.5-12.5a.793.793 0 0 1 1.032-.312.79.79 0 0 1 .312 1.03ZM12.562 9.5c.813.625 1.532 1.406 2.157 2.25l-1.281.781q-.704-.937-1.594-1.687zm2.5 6.75a9.7 9.7 0 0 0-.812-2.438l1.25-.78c.531 1 .906 2.093 1.094 3.218z" })
  }
), V5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m2.977 10.906 1.617 1.617c.14.141.398.141.539 0L12 5.656a.397.397 0 0 0 0-.539L10.383 3.5a.397.397 0 0 0-.54 0l-.913.914.703.703a.4.4 0 0 1 0 .54.397.397 0 0 1-.54 0l-.702-.704-.961.961.703.703a.4.4 0 0 1 0 .54.397.397 0 0 1-.54 0l-.702-.704-.961.961.703.703a.4.4 0 0 1 0 .54.397.397 0 0 1-.54 0l-.702-.704-.961.961.703.703a.4.4 0 0 1 0 .54.397.397 0 0 1-.54 0l-.702-.704-.914.914a.397.397 0 0 0 0 .54Zm.82 2.414L2.18 11.703a1.514 1.514 0 0 1 0-2.133l6.867-6.867a1.514 1.514 0 0 1 2.133 0l1.617 1.617a1.514 1.514 0 0 1 0 2.133L5.93 13.32a1.514 1.514 0 0 1-2.133 0" })
  }
), z5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m5.969 15.875 2.156 2.156a.53.53 0 0 0 .719 0L18 8.875a.53.53 0 0 0 0-.719L15.844 6a.53.53 0 0 0-.719 0l-1.219 1.219.938.937a.53.53 0 0 1 0 .719.53.53 0 0 1-.719 0l-.938-.938-1.28 1.282.937.937a.53.53 0 0 1 0 .719.53.53 0 0 1-.719 0l-.938-.938-1.28 1.282.937.937a.53.53 0 0 1 0 .719.53.53 0 0 1-.719 0l-.938-.938-1.28 1.282.937.937a.53.53 0 0 1 0 .719.53.53 0 0 1-.719 0l-.938-.938-1.218 1.22a.53.53 0 0 0 0 .718m1.093 3.219-2.156-2.157a2.02 2.02 0 0 1 0-2.843l9.157-9.156a2.02 2.02 0 0 1 2.843 0l2.157 2.156a2.02 2.02 0 0 1 0 2.843l-9.157 9.157a2.02 2.02 0 0 1-2.844 0" })
  }
), H5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 18.5h6.875a5.4 5.4 0 0 0 1.406 1.5H5c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407v1.375c-.563.156-1.063.375-1.5.687V9H11c-.563 0-1-.438-1-1V5.5H5c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5m7-3c0-1.594.844-3.063 2.25-3.875a4.46 4.46 0 0 1 4.5 0c1.375.813 2.25 2.281 2.25 3.875a4.54 4.54 0 0 1-2.25 3.906 4.46 4.46 0 0 1-4.5 0A4.47 4.47 0 0 1 12 15.5m6.594-1.344a.53.53 0 0 0-.719 0L16 16.062l-.906-.906a.53.53 0 0 0-.719 0 .53.53 0 0 0 0 .719l1.25 1.25a.53.53 0 0 0 .719 0l2.25-2.25a.53.53 0 0 0 0-.719" })
  }
), B5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M3 6c0-1.094.875-2 2-2h5v4c0 .563.438 1 1 1h4v1.219c-2.313.656-4 2.781-4 5.281 0 1.875.906 3.5 2.281 4.5H5c-1.125 0-2-.875-2-2z",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M15 9h-4c-.563 0-1-.438-1-1V4zm-3 6.5c0-1.594.844-3.063 2.25-3.875a4.46 4.46 0 0 1 4.5 0c1.375.813 2.25 2.281 2.25 3.875a4.54 4.54 0 0 1-2.25 3.906 4.46 4.46 0 0 1-4.5 0A4.47 4.47 0 0 1 12 15.5m6.594-1.344a.53.53 0 0 0-.719 0L16 16.062l-.906-.906a.53.53 0 0 0-.719 0 .53.53 0 0 0 0 .719l1.25 1.25a.53.53 0 0 0 .719 0l2.25-2.25a.53.53 0 0 0 0-.719"
        }
      )
    ]
  }
), L5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M4 3.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5V8h5.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-16a.5.5 0 0 1-.5-.5zM5 4v15h15V9h-5.5a.5.5 0 0 1-.5-.5V4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M7.127 5H6v1.127zM6 9.814V7.728L8.728 5h2.086zM6 13.5v-2.085L12.415 5H13v1.5zm0 3.687V15.1l7-7V10h.187zM8.874 18H6.788l8-8h2.086zm3.686 0h-2.085l8-8H19v1.56zm3.687 0H14.16L19 13.161v2.086zM19 16.848V18h-1.152z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), X5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.219 9.719 17.438 5.5H14.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h4.469a.74.74 0 0 1 .75.75v4.5c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75V6.562l-4.219 4.22a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063M10.78 14.28 6.531 18.5H9.25a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-4.5a.72.72 0 0 1-.75-.75v-4.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v2.719l4.219-4.219c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031Z" })
  }
), R5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.969 12c0 .437-.344.781-.75.781H7.594l4.156 3.938a.746.746 0 0 1 .031 1.062c-.281.313-.75.313-1.062.031l-5.5-5.25A.75.75 0 0 1 5 12c0-.188.063-.375.219-.531l5.5-5.25c.312-.282.781-.282 1.062.03a.746.746 0 0 1-.031 1.063L7.594 11.25h10.625a.74.74 0 0 1 .75.75" })
  }
), y5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M19.281 5.781 15.031 10h2.719a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-4.5a.72.72 0 0 1-.75-.75v-4.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v2.719l4.219-4.219c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031M4.72 18.22 8.937 14H6.25a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h4.469a.74.74 0 0 1 .75.75v4.5c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75v-2.688l-4.219 4.22a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063Z" })
  }
), Z5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.063 8.422 8.936 12.36c-.234.21-.585.21-.796-.024s-.211-.586.023-.797l3.117-2.976H3.312A.54.54 0 0 1 2.75 8c0-.305.234-.562.563-.562h7.968L8.164 4.484a.56.56 0 0 1-.023-.796.56.56 0 0 1 .796-.024l4.126 3.938A.58.58 0 0 1 13.25 8c0 .164-.07.305-.188.422Z" })
  }
), E5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m13.25 6.219 5.5 5.25c.156.156.25.343.25.562 0 .188-.094.375-.25.531l-5.5 5.25a.746.746 0 0 1-1.063-.03.746.746 0 0 1 .032-1.063l4.156-3.938H5.75a.74.74 0 0 1-.75-.75c0-.437.313-.75.75-.75h10.625l-4.156-3.969a.746.746 0 0 1-.031-1.062c.28-.313.75-.313 1.062-.031" })
  }
), b5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15.594 7.844C14.625 7.03 13.375 6.5 12 6.5A5.49 5.49 0 0 0 6.5 12c0 3.063 2.438 5.5 5.5 5.5a5.45 5.45 0 0 0 3.281-1.094.75.75 0 0 1 1.063.157.75.75 0 0 1-.157 1.062C15.031 18.5 13.563 19 12 19c-3.875 0-7-3.125-7-7 0-3.844 3.125-7 7-7 1.781 0 3.406.688 4.656 1.781l.938-.937c.218-.219.5-.313.781-.313C19 5.5 19.5 6 19.5 6.625v3.625a.74.74 0 0 1-.75.75h-3.656A1.07 1.07 0 0 1 14 9.906c0-.281.094-.562.313-.781zM18 7.562 16.031 9.5H18z" })
  }
), F5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17.25 17.5H6.75a.72.72 0 0 0-.75.75c0 .438.313.75.75.75h10.5a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75m-1.813-7-2.687 2.875V5.781c0-.437-.344-.781-.75-.781-.438 0-.75.344-.75.781v7.594L8.531 10.5A.73.73 0 0 0 8 10.281a.85.85 0 0 0-.531.188c-.313.281-.313.75-.032 1.062l4 4.25a.755.755 0 0 0 1.094 0l4-4.25c.282-.312.282-.781-.031-1.062s-.781-.281-1.063.031" })
  }
), k5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M20.203 4.125v15.75c0 .656.469 1.125 1.125 1.125s1.172-.469 1.172-1.125V4.125c0-.61-.516-1.125-1.172-1.125a1.14 1.14 0 0 0-1.125 1.125m-10.5 2.719 4.313 4.078H2.625C1.969 10.875 1.5 11.39 1.5 12c0 .656.469 1.125 1.125 1.125h11.39l-4.312 4.078a1.1 1.1 0 0 0-.328.797c0 .281.094.563.281.797.422.469 1.125.469 1.594.047l6.375-6c.469-.422.469-1.219 0-1.64l-6.375-6c-.469-.423-1.172-.423-1.594.046s-.422 1.172.047 1.594" })
  }
), D5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.063 2.75h7.875a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562H4.064a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562Zm4.335 3.188 3 3.187c.211.234.211.586-.023.797-.234.21-.586.21-.797-.024L8.563 7.742v4.946A.555.555 0 0 1 8 13.25a.54.54 0 0 1-.563-.563V7.742L5.399 9.898c-.21.235-.562.235-.796.024-.235-.211-.235-.563-.024-.797l3-3.188A.59.59 0 0 1 8 5.75c.14 0 .305.07.398.188" })
  }
), S5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.75 6.531h10.5a.76.76 0 0 0 .75-.75c0-.437-.344-.781-.75-.781H6.75c-.438 0-.75.344-.75.781 0 .407.313.75.75.75m1.781 7 2.719-2.875v7.594c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-7.594l2.688 2.875a.75.75 0 0 0 .562.219.83.83 0 0 0 .5-.188.746.746 0 0 0 .031-1.062l-4-4.281c-.281-.281-.812-.281-1.094 0l-4 4.281a.746.746 0 0 0 .032 1.063.774.774 0 0 0 1.062-.032" })
  }
), P5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 4c.531 0 1 .469 1 1v.625c2.281.438 4 2.469 4 4.875v.813c0 1.406.469 2.78 1.344 3.906l.468.562c.188.25.22.563.094.813a.73.73 0 0 1-.656.406H5.75a.74.74 0 0 1-.688-.406.78.78 0 0 1 .094-.813l.469-.562C6.5 14.094 7 12.719 7 11.313V10.5c0-2.406 1.719-4.438 4-4.875V5c0-.531.438-1 1-1m0 3c-1.938 0-3.5 1.594-3.5 3.5v.813A7.65 7.65 0 0 1 7.25 15.5h9.469c-.813-1.25-1.219-2.688-1.219-4.188V10.5C15.5 8.594 13.906 7 12 7m2 11c0 .531-.219 1.063-.594 1.438A1.96 1.96 0 0 1 12 20c-.531 0-1.063-.188-1.438-.563C10.188 19.063 10 18.532 10 18z" })
  }
), T5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M12 4c.531 0 1 .469 1 1v.625c2.281.438 4 2.469 4 4.875v.813c0 1.406.469 2.78 1.344 3.906l.468.562c.188.25.22.563.094.813a.73.73 0 0 1-.656.406H5.75a.74.74 0 0 1-.688-.406.78.78 0 0 1 .094-.813l.469-.562C6.5 14.094 7 12.719 7 11.313V10.5c0-2.406 1.719-4.438 4-4.875V5c0-.531.438-1 1-1m0 3c-1.938 0-3.5 1.594-3.5 3.5v.813A7.65 7.65 0 0 1 7.25 15.5h9.469c-.813-1.25-1.219-2.688-1.219-4.188V10.5C15.5 8.594 13.906 7 12 7m2 11c0 .531-.219 1.063-.594 1.438A1.96 1.96 0 0 1 12 20c-.531 0-1.063-.188-1.438-.563C10.188 19.063 10 18.532 10 18z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M20 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0" })
    ]
  }
), _5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M7.656 8h2.813c2.469-4.094 6.312-4.25 8.625-3.812a.86.86 0 0 1 .718.718c.438 2.313.282 6.157-3.812 8.625v2.813c0 .781-.438 1.531-1.125 1.937l-2.75 1.625c-.25.157-.531.157-.75 0-.25-.125-.375-.375-.375-.656v-3.562c0-.72-.281-1.407-.781-1.907s-1.188-.78-1.906-.78H4.75c-.281 0-.531-.126-.656-.376-.157-.219-.157-.5 0-.75l1.625-2.75A2.28 2.28 0 0 1 7.656 8m9.594 0c0-.437-.25-.844-.625-1.062a1.27 1.27 0 0 0-1.25 0A1.19 1.19 0 0 0 14.75 8c0 .469.219.875.625 1.094a1.27 1.27 0 0 0 1.25 0A1.26 1.26 0 0 0 17.25 8"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#F2D30A",
          fillRule: "evenodd",
          d: "M9.187 18.688C8.125 19.78 6.062 19.968 4.875 20A.82.82 0 0 1 4 19.125c.031-1.188.218-3.25 1.312-4.313a2.754 2.754 0 0 1 3.875 0 2.754 2.754 0 0 1 0 3.876M7.72 17.563a.87.87 0 0 0 0-1.282.87.87 0 0 0-1.282 0c-.312.313-.406.875-.437 1.282 0 .25.188.437.438.437.406-.031.968-.125 1.28-.438Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), O5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "currentColor",
    viewBox: "0 0 30 30",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M22.21 20.179a.975.975 0 0 1 1.487.827v3.909c0 .709-.576 1.285-1.285 1.285H8.085A1.287 1.287 0 0 1 6.8 24.915v-3.912a.974.974 0 0 1 1.486-.824l1.523.945c.175.11.393.11.569 0l1.254-.778a1.96 1.96 0 0 1 2.077 0l1.255.778c.176.11.393.11.57 0l1.253-.778a1.96 1.96 0 0 1 2.078 0l1.254.778c.176.11.393.11.57 0zm-4.1 1.382a.54.54 0 0 0-.568 0l-1.255.778a1.97 1.97 0 0 1-1.038.299c-.36 0-.72-.1-1.039-.298l-1.255-.78a.54.54 0 0 0-.568 0l-1.255.779a1.96 1.96 0 0 1-2.077 0l-.825-.51v2.94h14.037v-2.94l-.825.51a1.96 1.96 0 0 1-2.077 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M19.807 13.8a.716.716 0 0 1 0 1.43H10.69a.716.716 0 0 1 0-1.43zm0-3.03a.716.716 0 0 1 0 1.43H10.69a.715.715 0 0 1 0-1.43z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19.04 3.8c.198 0 .379.082.508.213l3.94 3.94c.129.13.199.3.206.475l.001.003.002.027v9.512l-.011.118a.97.97 0 0 1-.449.678l-1.777 1.103a1.99 1.99 0 0 1-2.112 0l-1.22-.757a.57.57 0 0 0-.604 0l-1.22.757a2 2 0 0 1-1.988.07l-.124-.07-1.22-.757a.57.57 0 0 0-.603 0l-1.22.757a1.99 1.99 0 0 1-2.112 0L7.26 18.766a.97.97 0 0 1-.448-.678l-.011-.121v-.02L6.8 5.085c0-.709.576-1.285 1.285-1.285zM8.23 17.686l1.561.968a.57.57 0 0 0 .604 0l1.22-.758a1.99 1.99 0 0 1 2.112 0l1.22.758a.57.57 0 0 0 .604 0l1.22-.758a1.99 1.99 0 0 1 2.112 0l1.219.758a.57.57 0 0 0 .604 0l1.56-.968V9.174h-2.658a1.287 1.287 0 0 1-1.285-1.285V5.23H8.23zm11.524-9.943h1.5l-1.5-1.5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), U5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m4.156 4.125 1.5 1c.344.25.438.719.219 1.063-.25.343-.719.437-1.063.187l-1.5-1a.717.717 0 0 1-.187-1.031.75.75 0 0 1 1.031-.219m16.5 1.25-1.5 1a.717.717 0 0 1-1.031-.188c-.25-.343-.156-.812.188-1.062l1.5-1a.795.795 0 0 1 1.062.219.75.75 0 0 1-.219 1.031M2.75 9h2a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2A.72.72 0 0 1 2 9.75.74.74 0 0 1 2.75 9m16.5 0h2a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75M5.656 14.375l-1.5 1a.717.717 0 0 1-1.031-.188c-.25-.343-.156-.812.188-1.062l1.5-1a.795.795 0 0 1 1.062.219.75.75 0 0 1-.219 1.031m13.5-1.219 1.5 1a.75.75 0 0 1 .219 1.031.795.795 0 0 1-1.063.22l-1.5-1c-.343-.25-.437-.72-.187-1.063a.717.717 0 0 1 1.031-.188M16 9.5c0-2.188-1.813-4-4-4-2.219 0-4 1.813-4 4 0 .875.25 1.656.688 2.281.124.188.25.375.406.563.406.562.875 1.219 1.25 1.875.312.594.5 1.219.562 1.781h-1.5c-.094-.375-.187-.719-.375-1.063a13.5 13.5 0 0 0-1.094-1.624l-.468-.657A5.47 5.47 0 0 1 6.5 9.5C6.5 6.469 8.938 4 12 4c3.031 0 5.5 2.469 5.5 5.5a5.5 5.5 0 0 1-1 3.156l-.469.656c-.375.532-.781 1.063-1.093 1.626A3.3 3.3 0 0 0 14.594 16h-1.531c.093-.563.25-1.188.562-1.781.375-.656.844-1.313 1.25-1.875a6 6 0 0 0 .406-.563A3.96 3.96 0 0 0 16 9.5m-5.5 0c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5C9.5 8.125 10.594 7 12 7c.25 0 .5.25.5.5 0 .281-.25.5-.5.5a1.5 1.5 0 0 0-1.5 1.5m4 8c0 1.406-1.125 2.5-2.5 2.5a2.47 2.47 0 0 1-2.5-2.5V17h5z" })
  }
), q5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M12.774 3c.118 0 .234.027.34.078l6.924 3.298a.78.78 0 0 1 .462.7v8.797l-.008.11a.78.78 0 0 1-.438.592v.001l-7.989 3.846a.78.78 0 0 1-.678 0l-6.925-3.287A.79.79 0 0 1 4 16.419V7.627l.008-.11a.78.78 0 0 1 .437-.593l7.99-3.846a.8.8 0 0 1 .34-.078ZM5.57 15.927l5.36 2.556v-6.916L5.57 9.006zm6.925-4.381v6.93l6.424-3.096V8.445zM6.433 7.694l5.277 2.503 2.418-1.176L8.993 6.46zm4.36-2.092 5.117 2.56 2.11-1.016-5.244-2.499z",
        clipRule: "evenodd"
      }
    )
  }
), I5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.313 2.563V3.5h3.375v-.938c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563V3.5h.937c.82 0 1.5.68 1.5 1.5v7.5c0 .844-.68 1.5-1.5 1.5h-7.5a1.48 1.48 0 0 1-1.5-1.5V5c0-.82.656-1.5 1.5-1.5h.938v-.938c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563M3.874 6.5v6c0 .21.164.375.375.375h7.5a.385.385 0 0 0 .375-.375v-6z" })
  }
), W5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9.75 4.75V6h4.5V4.75A.74.74 0 0 1 15 4a.76.76 0 0 1 .75.75V6H17c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2V8c0-1.094.875-2 2-2h1.25V4.75A.74.74 0 0 1 9 4a.76.76 0 0 1 .75.75M6.5 10v8c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5v-8z" })
  }
), $5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M3.25 15a.25.25 0 0 1 .25.25v.9H21v-.9a.25.25 0 1 1 .5 0v2.5c0 .69-.56 1.25-1.25 1.25h-16C3.56 19 3 18.44 3 17.75v-2.5a.25.25 0 0 1 .25-.25M21 16.65H3.5v1.1c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M2.85 15.25a.4.4 0 0 1 .8 0V16h17.2v-.75a.4.4 0 0 1 .8 0v2.5a1.4 1.4 0 0 1-1.4 1.4h-16a1.4 1.4 0 0 1-1.4-1.4zm.8 1.55v.95a.6.6 0 0 0 .6.6h16a.6.6 0 0 0 .6-.6v-.95z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "m19.363 13.864.002-.597-7.214.008-.007.006-.002.53a.2.2 0 0 1-.311.166l-1.589-1.063a.2.2 0 0 1-.003-.33l1.585-1.114a.2.2 0 0 1 .315.164l.002.633h.01l7.211-.014-.006-.563a.2.2 0 0 1 .311-.169l1.59 1.065a.2.2 0 0 1 .004.33l-1.583 1.112a.2.2 0 0 1-.315-.164" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M3 8.25c0-2.255 1.845-4.1 4.1-4.1s4.1 1.845 4.1 4.1-1.845 4.1-4.1 4.1A4.11 4.11 0 0 1 3 8.25m4.1-3.5a3.51 3.51 0 0 0-3.5 3.5c0 1.924 1.576 3.5 3.5 3.5s3.5-1.576 3.5-3.5-1.576-3.5-3.5-3.5",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M2.85 8.25A4.26 4.26 0 0 1 7.1 4a4.26 4.26 0 0 1 4.25 4.25A4.26 4.26 0 0 1 7.1 12.5a4.26 4.26 0 0 1-4.25-4.25M7.1 4.9a3.36 3.36 0 0 0-3.35 3.35A3.36 3.36 0 0 0 7.1 11.6a3.36 3.36 0 0 0 3.35-3.35A3.36 3.36 0 0 0 7.1 4.9m1.8 1.715a.45.45 0 1 1 .636.637l-2.918 2.917a.45.45 0 0 1-.636 0L4.664 8.852a.45.45 0 0 1 .636-.636l1 1 2.6-2.6ZM3.4 16.55v1.2c0 .47.38.85.85.85h7.85v-2.05z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Y5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.5 7c0-.531-.313-1-.75-1.281-.469-.282-1.063-.282-1.5 0-.469.281-.75.75-.75 1.281 0 .563.281 1.031.75 1.313.438.28 1.031.28 1.5 0 .438-.282.75-.75.75-1.313m-.625 2.875A2.8 2.8 0 0 1 12 10c-.313 0-.625-.031-.906-.125l-2.156 3.719c.906.437 1.968.656 3.062.656 2.656 0 5-1.438 6.281-3.625a.716.716 0 0 1 1-.25c.375.188.5.656.282 1A8.71 8.71 0 0 1 12 15.75a8.8 8.8 0 0 1-3.844-.875l-2.781 4.781c-.188.344-.656.469-1.031.25a.753.753 0 0 1-.25-1.031l2.781-4.75a8.7 8.7 0 0 1-2.469-2.75.7.7 0 0 1 .282-1c.343-.219.812-.094 1.03.25.47.875 1.157 1.594 1.938 2.188l2.157-3.72A3.07 3.07 0 0 1 9 7a3 3 0 0 1 6 0 3.1 3.1 0 0 1-.844 2.094l1.656 2.844c-.374.312-.812.562-1.28.78zm7 9a.75.75 0 0 1-.25 1.031.75.75 0 0 1-1.031-.25l-2.282-3.906c.438-.219.875-.469 1.282-.75z" })
  }
), G5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.219 5h3.531c.781 0 1.438.5 1.688 1.219l.25.781H18c1.094 0 2 .906 2 2v8c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2V9c0-1.094.875-2 2-2h2.281l.281-.781.688.218-.688-.218A1.745 1.745 0 0 1 10.22 5Zm-.25 1.688L9.53 8c-.094.313-.375.5-.719.5H6c-.281 0-.5.25-.5.5v8c0 .281.219.5.5.5h12c.25 0 .5-.219.5-.5V9c0-.25-.25-.5-.5-.5h-2.844c-.344 0-.625-.188-.719-.5L14 6.687a.27.27 0 0 0-.25-.187h-3.531a.27.27 0 0 0-.25.188M12 16.5a3.44 3.44 0 0 1-3.031-1.75c-.656-1.063-.656-2.406 0-3.5A3.5 3.5 0 0 1 12 9.5c1.25 0 2.375.688 3 1.75.656 1.094.656 2.438 0 3.5a3.43 3.43 0 0 1-3 1.75M10 13c0 .719.375 1.375 1 1.75.594.344 1.375.344 2 0 .594-.375 1-1.031 1-1.75 0-.688-.406-1.344-1-1.719-.625-.344-1.406-.344-2 0A2.02 2.02 0 0 0 10 13" })
  }
), N5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#FAE2CC",
          d: "M8.012 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6 6.01 6.01 0 0 1 5.203-3 6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6 5.96 5.96 0 0 1-5.18 3m0-9a.555.555 0 0 0-.563.563v2.625c0 .328.235.562.563.562a.555.555 0 0 0 .562-.563V5.563A.57.57 0 0 0 8.012 5m-.75 5.25c0 .422.328.75.75.75.398 0 .75-.328.75-.75a.77.77 0 0 0-.75-.75.755.755 0 0 0-.75.75"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#E37612",
          d: "M8.012 9.5c.398 0 .75.352.75.75 0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75m0-4.5a.57.57 0 0 1 .562.563v2.625a.555.555 0 0 1-.562.562.54.54 0 0 1-.563-.563V5.563c0-.305.235-.563.563-.563"
        }
      )
    ]
  }
), J5 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "#FAE2CC",
            d: "M8 0C3.562 0 0 3.594 0 8c0 4.438 3.563 8 8 8 4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8m-.75 4.75A.74.74 0 0 1 8 4a.76.76 0 0 1 .75.75v4A.74.74 0 0 1 8 9.5a.72.72 0 0 1-.75-.75zM8 12.5a.98.98 0 0 1-1-.969.98.98 0 0 1 1-.969c.531 0 .969.438.969.97A.974.974 0 0 1 8 12.5"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "#E37612",
            d: "M8 9.5a.74.74 0 0 0 .75-.75v-4A.76.76 0 0 0 8 4a.74.74 0 0 0-.75.75v4c0 .438.313.75.75.75m0 1.063a.98.98 0 0 0-1 .968.98.98 0 0 0 1 .969.974.974 0 0 0 .969-.969.974.974 0 0 0-.969-.969Z"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), K5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.5 5.75v11c0 .438.313.75.75.75h13a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-13C5 19 4 18 4 16.75v-11A.74.74 0 0 1 4.75 5a.76.76 0 0 1 .75.75m8.5 3a.74.74 0 0 1 .75-.75h3.469a.74.74 0 0 1 .75.75v3.5c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75v-1.688L14 14.033a.684.684 0 0 1-1.031 0l-2.469-2.47-1.969 1.97c-.312.312-.781.312-1.062 0a.684.684 0 0 1 0-1.032l2.5-2.5c.281-.313.75-.313 1.062 0L13.5 12.47l2.938-2.97H14.75a.72.72 0 0 1-.75-.75" })
  }
), Q5 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 3.125c-1.758 0-3.352.938-4.242 2.438a4.89 4.89 0 0 0 0 4.875A4.88 4.88 0 0 0 8 12.874a4.87 4.87 0 0 0 4.219-2.438 4.89 4.89 0 0 0 0-4.874c-.89-1.5-2.485-2.438-4.219-2.438ZM8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m2.648-7.102-3 3c-.234.235-.585.235-.796 0l-1.5-1.5a.513.513 0 0 1 0-.773c.21-.234.562-.234.796 0L7.25 8.727l2.602-2.602c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .773" })
  }
), l0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5.5c-2.344 0-4.469 1.25-5.656 3.25a6.52 6.52 0 0 0 0 6.5A6.51 6.51 0 0 0 12 18.5c2.313 0 4.438-1.219 5.625-3.25a6.52 6.52 0 0 0 0-6.5C16.437 6.75 14.312 5.5 12 5.5M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m3.531-9.469-4 4c-.312.313-.781.313-1.062 0l-2-2a.684.684 0 0 1 0-1.031c.281-.313.75-.313 1.062 0L11 12.969 14.469 9.5c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031" })
  }
), c0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m2.648-7.102h-.023c.234-.21.234-.562 0-.796a.55.55 0 0 0-.773 0L7.25 8.727 6.148 7.625c-.234-.234-.585-.234-.796 0a.513.513 0 0 0 0 .773l1.5 1.5c.21.235.562.235.796 0z" })
  }
), a0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m3.531-9.469H15.5c.313-.281.313-.75 0-1.062a.736.736 0 0 0-1.031 0L11 12.969 9.531 11.5c-.312-.313-.781-.313-1.062 0a.684.684 0 0 0 0 1.031l2 2c.281.313.75.313 1.062 0z" })
  }
), t0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.086 4.414c.21.234.21.586 0 .797l-6.188 6.187c-.234.235-.585.235-.796 0L2.914 8.211a.513.513 0 0 1 0-.774.513.513 0 0 1 .773 0l2.79 2.79 5.812-5.813a.554.554 0 0 1 .774 0z" })
  }
), h0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.781 7.219c.282.312.282.781 0 1.062l-8.25 8.25c-.312.313-.781.313-1.062 0l-4.25-4.25a.684.684 0 0 1 0-1.031.684.684 0 0 1 1.031 0l3.719 3.719 7.75-7.75a.736.736 0 0 1 1.031 0z" })
  }
), e0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m7.102 11.398-4.5-4.5c-.235-.21-.235-.562 0-.796.21-.211.562-.211.796 0L7.5 10.227l4.102-4.102c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .773l-4.523 4.5a.513.513 0 0 1-.773 0" })
  }
), r0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m18.5 10.562-5.969 5.72c-.187.155-.375.218-.531.218a.85.85 0 0 1-.531-.188l-6-5.75A.746.746 0 0 1 5.437 9.5.746.746 0 0 1 6.5 9.469l5.5 5.25 5.469-5.25a.746.746 0 0 1 1.062.03.746.746 0 0 1-.031 1.063" })
  }
), i0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8 14.5a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2.5a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6 5.96 5.96 0 0 1-5.18 3m2.836-6.352a.55.55 0 0 0 0-.773c-.234-.234-.586-.234-.797 0L8 9.415l-2.04-2.04c-.233-.234-.585-.234-.796 0a.513.513 0 0 0 0 .773l2.438 2.438c.21.234.562.234.773 0z",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M7.602 10.586 5.164 8.148a.513.513 0 0 1 0-.773c.211-.234.563-.234.797 0L8 9.415l2.04-2.04c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .773l-2.461 2.438a.513.513 0 0 1-.773 0"
        }
      )
    ]
  }
), s0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m3.781-8.469a.736.736 0 0 0 0-1.031c-.312-.313-.781-.313-1.062 0L12 13.219 9.281 10.5c-.312-.313-.781-.313-1.062 0a.684.684 0 0 0 0 1.031l3.25 3.25a.684.684 0 0 0 1.031 0z",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "m11.469 14.781-3.25-3.25a.684.684 0 0 1 0-1.031c.281-.313.75-.313 1.062 0L12 13.219l2.719-2.719c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031l-3.281 3.25a.684.684 0 0 1-1.031 0" })
    ]
  }
), o0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 11 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.192 9.94 2.567 7.313a.42.42 0 0 1 0-.615.42.42 0 0 1 .616 0l2.324 2.31 2.31-2.31a.42.42 0 0 1 .616 0 .42.42 0 0 1 0 .615L5.808 9.94a.42.42 0 0 1-.616 0" })
  }
), n0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 16 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.969 1.734c.187.141.234.329.234.516 0 .188-.047.375-.187.516L3.484 12l8.485 9.281a.7.7 0 0 1-.047 1.032.7.7 0 0 1-1.031-.047l-9-9.75a.68.68 0 0 1 0-.985l9-9.75c.328-.328.796-.328 1.078-.047" })
  }
), v0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 10 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m1.602 7.602 4.5-4.477c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .773L2.773 8l4.102 4.125a.513.513 0 0 1 0 .773.513.513 0 0 1-.773 0l-4.5-4.5c-.235-.21-.235-.562 0-.796" })
  }
), w0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 12 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m7.438 18.531-5.72-5.969A.86.86 0 0 1 1.5 12c0-.156.063-.344.188-.5l5.717-5.97A.746.746 0 0 1 8.47 5.5c.312.281.312.75.031 1.062L3.281 12l5.25 5.5a.746.746 0 0 1-.031 1.062.746.746 0 0 1-1.063-.03Z" })
  }
), x0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M20 12a8.02 8.02 0 0 1-4 6.938c-2.5 1.437-5.531 1.437-8 0A7.95 7.95 0 0 1 4 12a7.94 7.94 0 0 1 4-6.906c2.469-1.438 5.5-1.438 8 0C18.469 6.53 20 9.156 20 12m-7.531-3.781L9.219 11.5a.684.684 0 0 0 0 1.031l3.25 3.25a.684.684 0 0 0 1.031 0c.313-.281.313-.75 0-1.062L10.781 12 13.5 9.281c.313-.281.313-.75 0-1.062a.736.736 0 0 0-1.031 0",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M9.219 12.531a.684.684 0 0 1 0-1.031l3.25-3.281a.736.736 0 0 1 1.031 0c.313.312.313.781 0 1.062L10.781 12l2.719 2.719c.313.312.313.781 0 1.062a.684.684 0 0 1-1.031 0z" })
    ]
  }
), d0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 10 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.398 7.602c.211.234.211.585 0 .796l-4.5 4.5c-.234.235-.586.235-.796 0a.513.513 0 0 1 0-.773l4.101-4.102-4.101-4.125a.513.513 0 0 1 0-.773.513.513 0 0 1 .773 0z" })
  }
), g0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 12 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m4.531 5.5 5.719 5.969c.125.156.219.343.219.53a.74.74 0 0 1-.219.5l-5.719 5.97a.746.746 0 0 1-1.062.03c-.313-.28-.313-.75-.032-1.062l5.25-5.468-5.25-5.438A.746.746 0 0 1 3.47 5.47a.746.746 0 0 1 1.062.03Z" })
  }
), m0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M4 12a7.94 7.94 0 0 1 4-6.906c2.469-1.438 5.5-1.438 8 0C18.469 6.53 20 9.156 20 12a8.02 8.02 0 0 1-4 6.938c-2.5 1.437-5.531 1.437-8 0A7.95 7.95 0 0 1 4 12m7.531 3.781 3.25-3.25c.281-.281.281-.75 0-1.062l-3.25-3.219c-.312-.313-.781-.313-1.062 0-.313.281-.313.75 0 1.063l2.719 2.718-2.72 2.719a.684.684 0 0 0 0 1.031c.282.313.75.313 1.063 0",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M14.781 11.469c.281.312.281.781 0 1.062l-3.25 3.25c-.312.313-.781.313-1.062 0a.684.684 0 0 1 0-1.031l2.719-2.719-2.72-2.719c-.312-.312-.312-.78 0-1.062.282-.313.75-.313 1.063 0z" })
    ]
  }
), p0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.102 4.602a.55.55 0 0 1 .773 0l4.523 4.5c.211.234.211.585 0 .796-.234.235-.585.235-.796 0L7.5 5.797 3.398 9.898c-.234.235-.586.235-.796 0a.513.513 0 0 1 0-.773z" })
  }
), u0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m5.469 13.469 5.968-5.719c.188-.156.376-.25.563-.25.188 0 .344.063.5.188l5.969 5.718c.312.313.312.781.031 1.063-.281.312-.75.312-1.063.031L12 9.312l-5.5 5.25a.746.746 0 0 1-1.063-.03c-.28-.313-.28-.782.032-1.063" })
  }
), f0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.67 9.54a.566.566 0 0 1 .66.919l-4.174 3a.57.57 0 0 1-.678-.015l-3.827-3a.565.565 0 1 1 .698-.889l3.49 2.738 3.83-2.752Zm0-3.08a.566.566 0 0 0 .66-.919l-4.174-3a.57.57 0 0 0-.678.015l-3.827 3a.565.565 0 0 0 .698.889l3.49-2.738 3.83 2.752Z" })
  }
), j0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.425 14.518a.75.75 0 0 1 .995-.14l.061.047 4.322 3.614 4.74-3.634a.75.75 0 1 1 .913 1.19l-5.217 4a.75.75 0 0 1-.937-.02l-4.783-4-.056-.052a.75.75 0 0 1-.038-1.005m4.877-10.093a.75.75 0 0 1 .937-.02l5.217 4a.75.75 0 1 1-.912 1.19L11.803 5.96 7.48 9.575l-.061.046a.75.75 0 0 1-.957-1.145l.056-.051z" })
  }
), M0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8 14.5a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2.5a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6 5.96 5.96 0 0 1-5.18 3m2.836-5.648L8.375 6.414a.55.55 0 0 0-.773 0L5.164 8.852c-.234.234-.234.585 0 .796.211.235.563.235.797 0L8 7.61l2.04 2.04c.21.234.562.234.796 0 .21-.211.21-.563 0-.797Z",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M7.602 6.414c.21-.21.562-.21.773 0l2.46 2.438c.212.234.212.585 0 .796-.233.235-.585.235-.796 0L8 7.61 5.96 9.65c-.233.234-.585.234-.796 0-.234-.211-.234-.563 0-.797z"
        }
      )
    ]
  }
), C0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m3.781-7.531L12.5 9.219a.736.736 0 0 0-1.031 0l-3.25 3.25c-.313.312-.313.781 0 1.062.281.313.75.313 1.062 0L12 10.812l2.719 2.72c.281.312.75.312 1.062 0 .281-.282.281-.75 0-1.063",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M11.469 9.219a.736.736 0 0 1 1.031 0l3.281 3.25c.281.312.281.781 0 1.062-.312.313-.781.313-1.062 0L12 10.812l-2.719 2.72c-.312.312-.781.312-1.062 0-.313-.282-.313-.75 0-1.063z" })
    ]
  }
), A0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m7.102 12.898-4.5-4.5c-.235-.21-.235-.562 0-.796.21-.211.562-.211.796 0L7.5 11.727l4.102-4.102c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .773l-4.523 4.5a.513.513 0 0 1-.773 0m-4.5-9c-.235-.21-.235-.562 0-.796.21-.211.562-.211.796 0L7.5 7.227l4.102-4.102c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .773l-4.523 4.5a.513.513 0 0 1-.773 0z" })
  }
), V0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m7.898 3.102 4.477 4.523a.513.513 0 0 1 0 .773.513.513 0 0 1-.773 0L7.477 4.297 3.375 8.398a.513.513 0 0 1-.773 0c-.235-.21-.235-.562 0-.796l4.5-4.5c.21-.211.562-.211.796 0m4.5 9-.023.023a.513.513 0 0 1 0 .773.513.513 0 0 1-.773 0L7.477 8.797l-4.102 4.101a.513.513 0 0 1-.773 0c-.235-.21-.235-.562 0-.796l4.5-4.5c.21-.211.562-.211.796 0z" })
  }
), z0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "currentColor",
    viewBox: "0 0 30 30",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M25 15c0-5.523-4.477-10-10-10S5 9.477 5 15s4.477 10 10 10v2C8.373 27 3 21.627 3 15S8.373 3 15 3s12 5.373 12 12-5.373 12-12 12v-2c5.523 0 10-4.477 10-10" }),
      /* @__PURE__ */ l.jsx("path", { d: "m12.329 10.312 7.1 4.26a.5.5 0 0 1 0 .857l-7.1 4.26a.5.5 0 0 1-.758-.43V10.74a.5.5 0 0 1 .758-.428" })
    ]
  }
), H0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m16.781 8.281-3.75 3.75 3.719 3.719a.684.684 0 0 1 0 1.031.684.684 0 0 1-1.031 0l-3.75-3.718L8.25 16.78a.684.684 0 0 1-1.031 0c-.313-.281-.313-.75 0-1.062L10.937 12 7.22 8.281c-.313-.281-.313-.75 0-1.062.281-.282.75-.282 1.062 0L12 10.969l3.719-3.719c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031" })
  }
), B0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ...c,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "#E31C1C", clipPath: "url(#a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M0 15C0 6.738 6.68 0 15 0c8.262 0 15 6.738 15 15 0 8.32-6.738 15-15 15-8.32 0-15-6.68-15-15m10.254-2.754L13.008 15l-2.754 2.754c-.586.586-.586 1.465 0 1.992a1.283 1.283 0 0 0 1.934 0l2.753-2.754 2.813 2.754a1.283 1.283 0 0 0 1.933 0c.586-.527.586-1.406 0-1.992L16.934 15l2.753-2.754c.586-.527.586-1.406 0-1.992a1.38 1.38 0 0 0-1.933 0l-2.813 2.812-2.754-2.812a1.38 1.38 0 0 0-1.933 0c-.586.586-.586 1.465 0 1.992",
            opacity: 0.25
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M12.246 10.254 15 13.008l2.754-2.754a1.38 1.38 0 0 1 1.933 0c.586.586.586 1.465 0 1.992L16.934 15l2.753 2.754c.586.586.586 1.465 0 1.992a1.283 1.283 0 0 1-1.933 0L15 16.992l-2.754 2.754c-.586.586-1.465.586-1.992 0-.586-.527-.586-1.406 0-1.992L13.008 15l-2.754-2.754c-.586-.527-.586-1.406 0-1.992.527-.527 1.406-.527 1.992 0" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h30v30H0z" }) }) })
    ]
  }
), L0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16.688 8.719 13.405 12l3.281 3.313a.964.964 0 0 1 0 1.406.964.964 0 0 1-1.406 0L12 13.437 8.687 16.72a.964.964 0 0 1-1.406 0 .964.964 0 0 1 0-1.407L10.563 12 7.28 8.719a.964.964 0 0 1 0-1.406.964.964 0 0 1 1.407 0L12 10.592l3.281-3.28a.964.964 0 0 1 1.406 0 .964.964 0 0 1 0 1.406Z" })
  }
), X0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m5.781 5.219 5.719 5.75 5.719-5.719c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031l-5.75 5.75 5.719 5.719a.684.684 0 0 1 0 1.031.684.684 0 0 1-1.031 0l-5.75-5.718L5.75 18.78a.684.684 0 0 1-1.031 0c-.313-.281-.313-.75 0-1.062L10.437 12 4.72 6.281c-.313-.281-.313-.75 0-1.062.281-.282.75-.282 1.062 0Z" })
  }
), R0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.063 7.813C12.374 7.03 11.374 6.5 10.25 6.5a3.74 3.74 0 0 0-3.75 3.75v.031c0 .625-.406 1.188-1 1.406a2.97 2.97 0 0 0-2 2.813 3 3 0 0 0 3 3h11.406c1.438-.063 2.594-1.281 2.594-2.75a2.71 2.71 0 0 0-1.656-2.5c-.625-.281-1-.938-.875-1.625 0-.125.031-.25.031-.375C18 9.031 16.969 8 15.75 8c-.344 0-.656.094-.938.219a1.55 1.55 0 0 1-1.75-.406ZM18 19H6.5C4 19 2 17 2 14.5c0-1.938 1.25-3.625 3-4.219v-.031C5 7.375 7.344 5 10.25 5c1.563 0 3 .719 3.969 1.844A3.55 3.55 0 0 1 15.75 6.5a3.76 3.76 0 0 1 3.75 3.75c0 .219-.031.406-.063.625 1.5.656 2.563 2.156 2.563 3.875A4.25 4.25 0 0 1 18 19m-9.031-5.219a.684.684 0 0 1 0-1.031c.281-.313.75-.313 1.062 0l1.219 1.219V9.75A.74.74 0 0 1 12 9a.76.76 0 0 1 .75.75v4.219l1.219-1.219a.684.684 0 0 1 1.031 0 .684.684 0 0 1 0 1.031l-2.5 2.5a.684.684 0 0 1-1.031 0z" })
  }
), y0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M14.25 4.063c.531.156.844.687.688 1.218l-4 14c-.157.532-.688.844-1.22.688-.53-.157-.843-.688-.687-1.219l4-14c.156-.531.688-.844 1.219-.687m2.531 3.75a.964.964 0 0 1 1.407 0l3.5 3.5a.964.964 0 0 1 0 1.406l-3.5 3.5a.964.964 0 0 1-1.407 0 .964.964 0 0 1 0-1.407L19.563 12 16.78 9.219a.964.964 0 0 1 0-1.406Zm-9.593 0a.964.964 0 0 1 0 1.406L4.405 12l2.782 2.813a.964.964 0 0 1 0 1.406.964.964 0 0 1-1.407 0l-3.5-3.5a.964.964 0 0 1 0-1.406l3.5-3.5a.964.964 0 0 1 1.407 0Z" })
  }
), Z0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M11.624 14.997a3.374 3.374 0 1 0 0-6.747 3.374 3.374 0 0 0 0 6.747m0-5.225a.37.37 0 0 1 .37.37v1.112h1.111a.37.37 0 0 1 0 .74h-1.111v1.111a.37.37 0 1 1-.74 0v-1.11h-1.112a.37.37 0 0 1 0-.741h1.111v-1.112a.37.37 0 0 1 .37-.37Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M5.938 6.688c0-1.125.914-2.063 2.062-2.063a2.08 2.08 0 0 1 2.063 2.063 2.05 2.05 0 0 1-.537 1.385q-.355.21-.66.486A2.05 2.05 0 0 1 8 8.75a2.05 2.05 0 0 1-2.063-2.063ZM8.088 9.5h-.932a3.48 3.48 0 0 0-2.93 1.617c-.702-.844-1.1-1.922-1.1-3.117 0-2.672 2.18-4.875 4.875-4.875 2.568 0 4.703 2.035 4.865 4.565.408.128.788.318 1.13.558A6.01 6.01 0 0 0 8 2C4.672 2 2 4.695 2 8a5.98 5.98 0 0 0 6.248 5.995 4.1 4.1 0 0 1-.558-1.13 4.87 4.87 0 0 1-2.62-.95 2.32 2.32 0 0 1 2.086-1.29h.466A4.1 4.1 0 0 1 8.089 9.5ZM7.064 6.687c0 .54.398.938.937.938a.925.925 0 0 0 .938-.938A.94.94 0 0 0 8 5.75a.925.925 0 0 0-.938.938Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), E0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M17 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-7.5a.5.5 0 0 1 .5.5v1.5H19a.5.5 0 0 1 0 1h-1.5V19a.5.5 0 0 1-1 0v-1.5H15a.5.5 0 0 1 0-1h1.5V15a.5.5 0 0 1 .5-.5",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.25 10.25c0-1.5 1.219-2.75 2.75-2.75 1.5 0 2.75 1.25 2.75 2.75 0 .489-.127.945-.35 1.34a6 6 0 0 0-1.815 1.347A2.7 2.7 0 0 1 12 13a2.734 2.734 0 0 1-2.75-2.75M11.803 14h-.928c-1.625 0-3.063.844-3.906 2.156C6.03 15.031 5.5 13.594 5.5 12c0-3.563 2.906-6.5 6.5-6.5 3.284 0 6.036 2.495 6.447 5.676.55.136 1.072.348 1.55.625C19.893 7.486 16.34 4 12 4c-4.438 0-8 3.594-8 8a7.975 7.975 0 0 0 7.801 7.998 6 6 0 0 1-.625-1.548 6.47 6.47 0 0 1-3.082-1.231 3.09 3.09 0 0 1 2.781-1.719h.314a6 6 0 0 1 .614-1.5m-1.053-3.75c0 .719.531 1.25 1.25 1.25.688 0 1.25-.531 1.25-1.25C13.25 9.562 12.687 9 12 9c-.719 0-1.25.563-1.25 1.25",
          clipRule: "evenodd"
        }
      )
    ]
  }
), b0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11 3.875v8.25h3a.385.385 0 0 0 .375-.375v-7.5A.4.4 0 0 0 14 3.875zm-1.125 0h-3.75v8.25h3.75zM5 12.125v-8.25H2a.385.385 0 0 0-.375.375v7.5c0 .21.164.375.375.375zM.5 4.25c0-.82.656-1.5 1.5-1.5h12c.82 0 1.5.68 1.5 1.5v7.5c0 .844-.68 1.5-1.5 1.5H2a1.48 1.48 0 0 1-1.5-1.5z" })
  }
), F0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16 6.5v11h4c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5zm-1.5 0h-5v11h5zM8 17.5v-11H4c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5zM2 7c0-1.094.875-2 2-2h16c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H4c-1.125 0-2-.875-2-2z" })
  }
), k0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9.25 16.031c.813.313 1.75.469 2.75.469 3.875 0 6.5-2.5 6.5-5 0-2.469-2.625-5-6.5-5-3.906 0-6.5 2.531-6.5 5 0 1 .375 1.969 1.094 2.813.281.28.406.687.375 1.093-.032.563-.188 1.094-.344 1.531a5.8 5.8 0 0 0 1.219-.687 1.52 1.52 0 0 1 1.406-.219M4.812 17.25c.313-.5.594-1.188.657-1.969C4.53 14.22 4 12.937 4 11.5 4 7.937 7.563 5 12 5c4.406 0 8 2.938 8 6.5 0 3.594-3.594 6.5-8 6.5a10 10 0 0 1-3.25-.531c-.375.25-1 .625-1.719.937-.468.219-1 .407-1.562.5 0 0-.032.032-.063.032-.125.03-.281.03-.406.062h-.031c-.157 0-.313.031-.469.031a.48.48 0 0 1-.469-.312c-.093-.188-.031-.407.094-.563.125-.125.25-.281.375-.406.031-.094.094-.156.125-.219l.031-.031c.063-.063.094-.156.157-.25Zm7.938-3h-.031c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75v-3.438l-.969.97a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063l2.25-2.25a.736.736 0 0 1 1.031 0l2.25 2.25c.313.312.313.781 0 1.062a.684.684 0 0 1-1.031 0l-.969-.969z" })
  }
), D0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 18v.031c-1.188 0-2.281-.218-3.281-.562a9.6 9.6 0 0 1-1.688.937c-.75.344-1.656.625-2.531.625a.48.48 0 0 1-.469-.312c-.093-.188-.031-.407.094-.563.031 0 .031-.031.063-.031.03-.063.093-.125.156-.188.125-.156.281-.406.468-.687.313-.5.594-1.188.657-1.969C4.53 14.22 4 12.937 4 11.5 4 7.937 7.563 5 12 5c4.406 0 8 2.938 8 6.5 0 3.594-3.594 6.5-8 6.5m.75-3.75v-3.688l.969.97c.281.312.75.312 1.062 0 .281-.282.281-.75 0-1.063l-2.25-2.25c-.312-.281-.781-.281-1.062 0l-2.25 2.25c-.313.312-.313.781 0 1.062.281.313.75.313 1.062 0l.969-.969v3.688c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75" })
  }
), S0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.5 9a2.53 2.53 0 0 1-2.188-1.25c-.437-.75-.437-1.719 0-2.5C4.782 4.5 5.595 4 6.5 4c.875 0 1.688.5 2.156 1.25.438.781.438 1.75 0 2.5C8.187 8.531 7.375 9 6.5 9M18 9a2.53 2.53 0 0 1-2.188-1.25c-.437-.75-.437-1.719 0-2.5C16.282 4.5 17.095 4 18 4c.875 0 1.688.5 2.156 1.25.438.781.438 1.75 0 2.5C19.688 8.531 18.875 9 18 9M2 13.344C2 11.5 3.469 10 5.313 10h1.343c.5 0 .969.125 1.407.313C8 10.53 8 10.78 8 11c0 1.219.5 2.281 1.344 3H2.656A.64.64 0 0 1 2 13.344M14.656 14h-.031A3.9 3.9 0 0 0 16 11a5 5 0 0 0-.063-.688A3.3 3.3 0 0 1 17.314 10h1.343C20.5 10 22 11.5 22 13.344c0 .375-.313.656-.688.656zM12 9.5c-.563 0-1.031.313-1.313.75-.28.469-.28 1.063 0 1.5.282.469.75.75 1.313.75.531 0 1-.281 1.281-.75.281-.438.281-1.031 0-1.5C13 9.812 12.531 9.5 12 9.5m0 4.5a3.03 3.03 0 0 1-2.625-1.5c-.531-.906-.531-2.063 0-3C9.938 8.594 10.906 8 12 8c1.063 0 2.031.594 2.594 1.5.531.938.531 2.094 0 3-.563.938-1.531 1.5-2.594 1.5m-1.844 2.5c-1.25 0-2.281.875-2.594 2h8.844c-.312-1.125-1.343-2-2.593-2zm0-1.5h3.656A4.19 4.19 0 0 1 18 19.188c0 .468-.375.812-.844.812H6.813A.807.807 0 0 1 6 19.187C6 16.875 7.844 15 10.156 15" })
  }
), P0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M7 12H3v-1h4zm0-2H3V9h4zm0-2H3V7h4zm0-2H3V5h4zm0-2H3V3h4zm4 8h-1v-1h1zm2 0h-1v-1h1zm-2-2h-1V9h1zm2 0h-1V9h1zm-2-2h-1V7h1zm2 0h-1V7h1z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M9 5h5.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5zm-7 9h6V2H2zm7 0h5V6H9z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), T0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.75 4a2.75 2.75 0 0 1 2.267 4.305l.508.553a3.997 3.997 0 0 1 5.889 1.058l.66-.384a2 2 0 1 1 .5.867l-.748.434a4 4 0 0 1-6.108 4.451l-.42.483c.434.45.702 1.06.702 1.733a2.5 2.5 0 1 1-1.53-2.305l.505-.58A3.98 3.98 0 0 1 8 12c0-.914.307-1.755.822-2.429l-.512-.558A2.75 2.75 0 1 1 6.75 4M18 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-10.5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m10.5 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-6-8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m6-1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m-11.25-3a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" })
  }
), _0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.75 4a2.75 2.75 0 0 1 2.267 4.305l.508.553a3.997 3.997 0 0 1 5.889 1.058l.66-.384a2 2 0 1 1 .5.867l-.748.434a4 4 0 0 1-6.108 4.451l-.42.483c.434.45.702 1.06.702 1.733a2.5 2.5 0 1 1-1.53-2.305l.505-.58A3.98 3.98 0 0 1 8 12c0-.914.307-1.755.822-2.429l-.512-.558A2.75 2.75 0 1 1 6.75 4M18 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4" })
  }
), O0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m3.898 3.664 2.04 2.063c.234.234.234.585 0 .796a.513.513 0 0 1-.774 0L4.063 5.422v4.266a.91.91 0 0 0 .937.937h3.188a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562h-3.21a2.066 2.066 0 0 1-2.063-2.063V5.423l-1.102 1.1a.513.513 0 0 1-.773 0c-.234-.21-.234-.562 0-.796l2.063-2.063c.21-.21.562-.21.796 0m3.914.586H11a2.08 2.08 0 0 1 2.063 2.063v4.289l1.1-1.102c.211-.234.563-.234.797 0a.55.55 0 0 1 0 .773l-2.063 2.063c-.234.234-.585.234-.796 0l-2.063-2.063a.513.513 0 0 1 0-.773c.211-.234.563-.234.797 0l1.101 1.102v-4.29A.94.94 0 0 0 11 5.375H7.812a.54.54 0 0 1-.562-.563c0-.304.234-.562.563-.562Z" })
  }
), U0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.75 9.875a.385.385 0 0 0 .375-.375V4.719l-1.594-1.594H7.25a.385.385 0 0 0-.375.375v6c0 .21.164.375.375.375zM7.25 11a1.48 1.48 0 0 1-1.5-1.5v-6c0-.82.656-1.5 1.5-1.5h3.281c.281 0 .586.14.797.352l1.57 1.57c.211.21.352.515.352.797V9.5c0 .844-.68 1.5-1.5 1.5zm-3-6H5v1.125h-.75a.385.385 0 0 0-.375.375v6c0 .21.164.375.375.375h4.5a.385.385 0 0 0 .375-.375v-.75h1.125v.75c0 .844-.68 1.5-1.5 1.5h-4.5a1.48 1.48 0 0 1-1.5-1.5v-6c0-.82.656-1.5 1.5-1.5" })
  }
), q0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17 14.5c.25 0 .5-.219.5-.5V7.625L15.375 5.5H11c-.281 0-.5.25-.5.5v8c0 .281.219.5.5.5zM11 16c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h4.375c.375 0 .781.188 1.063.469l2.093 2.093c.282.282.469.688.469 1.063V14c0 1.125-.906 2-2 2zM7 8h1v1.5H7c-.281 0-.5.25-.5.5v8c0 .281.219.5.5.5h6c.25 0 .5-.219.5-.5v-1H15v1c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2v-8c0-1.094.875-2 2-2" })
  }
), I0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.562 2.563v1.171c.633.07 1.22.188 1.665.282a.565.565 0 1 1-.258 1.101c-.727-.164-1.782-.375-2.672-.281q-.668.035-1.055.281a1.08 1.08 0 0 0-.469.727c-.07.258-.023.445.047.562.047.14.188.258.399.399.445.28 1.125.445 1.898.656l.07.023c.727.188 1.547.399 2.18.774.328.187.61.469.797.844.211.375.234.82.164 1.289-.164.843-.773 1.382-1.523 1.664-.375.14-.797.234-1.243.258v1.124A.555.555 0 0 1 8 14a.54.54 0 0 1-.563-.563V12.29c-.093-.023-.164-.023-.234-.047-.586-.07-1.617-.305-2.25-.586-.281-.14-.422-.469-.281-.75a.55.55 0 0 1 .726-.281c.516.21 1.43.445 1.946.516.843.117 1.547.046 2.062-.141.492-.188.75-.469.797-.82.07-.258.024-.446-.047-.563-.047-.14-.187-.281-.398-.398-.446-.281-1.102-.469-1.899-.656l-.07-.024c-.727-.187-1.547-.398-2.18-.773-.304-.211-.609-.47-.797-.844a2 2 0 0 1-.14-1.29c.117-.679.469-1.148.96-1.452.47-.305 1.032-.422 1.571-.47.07-.022.14-.022.234-.022V2.562C7.437 2.259 7.672 2 8 2a.57.57 0 0 1 .562.563" })
  }
), W0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.063 5.594c-.032-.032-.094-.032-.157 0L5.97 7.844 12 10.219l6-2.375zM5.5 15.812c0 .126.063.22.156.25l5.594 2.125v-6.656L5.5 9.281zm7.25 2.376 5.563-2.125a.27.27 0 0 0 .187-.25V9.28l-5.75 2.25v6.656Zm-1.375-14a1.64 1.64 0 0 1 1.219 0l6.25 2.375A1.76 1.76 0 0 1 20 8.219v7.594c0 .75-.469 1.374-1.156 1.656l-6.25 2.375a1.64 1.64 0 0 1-1.219 0l-6.25-2.375C4.437 17.187 4 16.562 4 15.812V8.22c0-.75.438-1.406 1.125-1.656l6.25-2.375Z" })
  }
), $0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M1.5 13v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1H3A1.5 1.5 0 0 1 1.5 13m7.5.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm4.5-.5v-1a.5.5 0 0 1 1 0v1a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5m-12-4V7a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0m12 0V7a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0m-12-5V3A1.5 1.5 0 0 1 3 1.5h1a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0m12 0V3a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1 0-1h1A1.5 1.5 0 0 1 14.5 3v1a.5.5 0 0 1-1 0M9 1.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1 0-1zm1.988 4.426L8.645 8.27l2.324 2.324a.428.428 0 0 1 0 .644.428.428 0 0 1-.645 0L7.98 8.914l-2.324 2.324a.428.428 0 0 1-.644 0c-.196-.175-.196-.468 0-.664L7.336 8.25 5.012 5.926c-.196-.176-.196-.469 0-.664a.484.484 0 0 1 .664 0L8 7.605l2.324-2.324c.176-.195.469-.195.664 0a.46.46 0 0 1 0 .645" })
  }
), Y0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2.375 20v-1.066a.625.625 0 1 1 1.25 0V20c0 .207.168.375.375.375h1.066a.625.625 0 1 1 0 1.25H4A1.625 1.625 0 0 1 2.375 20m8.025.375a.625.625 0 0 1 0 1.25H8.267a.625.625 0 0 1 0-1.25zm5.333 0a.625.625 0 0 1 0 1.25H13.6a.625.625 0 0 1 0-1.25zM20.375 20v-1.066a.625.625 0 1 1 1.25 0V20c0 .898-.727 1.625-1.625 1.625h-1.066a.625.625 0 1 1 0-1.25H20a.375.375 0 0 0 .375-.375m-18-4.267V13.6a.625.625 0 0 1 1.25 0v2.133a.625.625 0 0 1-1.25 0m18 0V13.6a.625.625 0 0 1 1.25 0v2.133a.625.625 0 0 1-1.25 0m-18-5.333V8.267a.625.625 0 0 1 1.25 0V10.4a.625.625 0 0 1-1.25 0m18 0V8.267a.625.625 0 0 1 1.25 0V10.4a.625.625 0 0 1-1.25 0m-18-5.334V4c0-.897.728-1.625 1.625-1.625h1.066a.625.625 0 0 1 0 1.25H4A.375.375 0 0 0 3.625 4v1.066a.625.625 0 0 1-1.25 0m18 0V4A.375.375 0 0 0 20 3.625h-1.066a.625.625 0 1 1 0-1.25H20c.898 0 1.625.728 1.625 1.625v1.066a.625.625 0 1 1-1.25 0M10.4 2.375a.625.625 0 0 1 0 1.25H8.267a.625.625 0 0 1 0-1.25zm5.333 0a.625.625 0 0 1 0 1.25H13.6a.625.625 0 0 1 0-1.25zm-.147 7.335-2.813 2.813 2.79 2.79a.513.513 0 0 1 0 .773.513.513 0 0 1-.774 0l-2.812-2.79-2.79 2.79a.513.513 0 0 1-.773 0c-.234-.211-.234-.563 0-.797l2.79-2.789-2.79-2.79c-.234-.21-.234-.562 0-.796.211-.21.563-.21.797 0L12 11.727l2.79-2.79c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .774Z" })
  }
), G0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.25 6.5h-2.5a.246.246 0 0 0-.25.25v2.5c0 .156.094.25.25.25h2.5c.125 0 .25-.094.25-.25v-2.5a.27.27 0 0 0-.25-.25M4.75 5h2.5C8.188 5 9 5.813 9 6.75v.5h6v-.5c0-.938.781-1.75 1.75-1.75h2.5c.938 0 1.75.813 1.75 1.75v2.5c0 .969-.813 1.75-1.75 1.75h-2.5c-.969 0-1.75-.781-1.75-1.75v-.5H9v.5c0 .25-.063.469-.156.688l2.375 3.156c.156-.063.344-.094.531-.094h2.5c.938 0 1.75.813 1.75 1.75v2.5c0 .969-.813 1.75-1.75 1.75h-2.5c-.969 0-1.75-.781-1.75-1.75v-2.5c0-.219.031-.438.125-.656L7.75 10.938c-.156.062-.344.062-.5.062h-2.5C3.781 11 3 10.219 3 9.25v-2.5C3 5.812 3.781 5 4.75 5m9.5 9.5h-2.5a.247.247 0 0 0-.25.25v2.5c0 .156.094.25.25.25h2.5c.125 0 .25-.094.25-.25v-2.5a.27.27 0 0 0-.25-.25m2.5-8a.247.247 0 0 0-.25.25v2.5c0 .156.094.25.25.25h2.5c.125 0 .25-.094.25-.25v-2.5a.27.27 0 0 0-.25-.25z" })
  }
), N0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 7c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v2c0 1.125-.906 2-2 2H8.75v3c0 .719.531 1.25 1.25 1.25h1V15c0-1.094.875-2 2-2h5c1.094 0 2 .906 2 2v2c0 1.125-.906 2-2 2h-5c-1.125 0-2-.875-2-2v-.25h-1A2.734 2.734 0 0 1 7.25 14v-3H6c-1.125 0-2-.875-2-2zm14 7.5h-5c-.281 0-.5.25-.5.5v2c0 .281.219.5.5.5h5c.25 0 .5-.219.5-.5v-2c0-.25-.25-.5-.5-.5" })
  }
), J0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.563 2.563v6.351l2.226-2.226c.211-.235.563-.235.797 0a.55.55 0 0 1 0 .773l-3.211 3.187a.513.513 0 0 1-.773 0L4.414 7.461a.513.513 0 0 1 0-.774c.211-.234.563-.234.797 0l2.226 2.227V2.563A.557.557 0 0 1 8 2a.57.57 0 0 1 .563.563M5 9.125l1.125 1.125H3.5a.385.385 0 0 0-.375.375V12.5c0 .21.164.375.375.375h9a.385.385 0 0 0 .375-.375v-1.875a.4.4 0 0 0-.375-.375H9.852l1.125-1.125H12.5c.82 0 1.5.68 1.5 1.5V12.5c0 .844-.68 1.5-1.5 1.5h-9A1.48 1.48 0 0 1 2 12.5v-1.875c0-.82.656-1.5 1.5-1.5zm7.125 2.438a.555.555 0 0 1-.563.562.54.54 0 0 1-.562-.563c0-.304.234-.562.563-.562a.57.57 0 0 1 .562.563" })
  }
), K0 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.75 4.75v8.469l2.969-2.969c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031l-4.281 4.25a.684.684 0 0 1-1.031 0l-4.25-4.25a.684.684 0 0 1 0-1.031c.281-.313.75-.313 1.062 0l2.969 2.969V4.75A.74.74 0 0 1 12 4a.76.76 0 0 1 .75.75M8 13.5 9.5 15H6c-.281 0-.5.25-.5.5V18c0 .281.219.5.5.5h12c.25 0 .5-.219.5-.5v-2.5c0-.25-.25-.5-.5-.5h-3.531l1.5-1.5H18c1.094 0 2 .906 2 2V18c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2v-2.5c0-1.094.875-2 2-2zm9.5 3.25a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75" })
  }
), Q0 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "m9.563 15 1.718 1.719a.964.964 0 0 0 1.406 0L14.408 15H18c1.094 0 2 .906 2 2v1c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2v-1c0-1.094.875-2 2-2zm7.187 2.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75.74.74 0 0 0-.75.75"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M12 4c.531 0 1 .469 1 1v8.594l2.281-2.281a.964.964 0 0 1 1.406 0 .964.964 0 0 1 0 1.406l-4 4a.964.964 0 0 1-1.406 0l-4-4a.964.964 0 0 1 0-1.406.964.964 0 0 1 1.407 0L11 13.592V5c0-.531.438-1 1-1"
        }
      )
    ]
  }
), l2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13 5v7.594l2.281-2.281a.964.964 0 0 1 1.406 0 .964.964 0 0 1 0 1.406l-4 4a.964.964 0 0 1-1.406 0l-4-4a.964.964 0 0 1 0-1.406.964.964 0 0 1 1.407 0L11 12.592V5c0-.531.438-1 1-1 .531 0 1 .469 1 1M6 15h3.156l1.406 1.438a2.02 2.02 0 0 0 2.844 0L14.812 15H18c1.094 0 2 .906 2 2v1c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2v-1c0-1.094.875-2 2-2m11.5 1.75a.74.74 0 0 0-.75.75c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75" })
  }
), c2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M15.34 4.38a1.5 1.5 0 0 0-.997-.38H6.5c-1.103 0-2 .898-2 2v12c0 1.103.897 2 2 2H18c1.103 0 1.5-.897 1.5-2V8.759a1.5 1.5 0 0 0-.502-1.12zM18 18a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 6 18V6a.5.5 0 0 1 .5-.5h8V8a1 1 0 0 0 1 1H18zM7 11h1V9H7V8h1V7h1v1h2V7h1v1h1v1h-1v2h2v-1h1v1h2v1h-2v2h2v1h-2v2h-1v-2h-2v2h-1v-2H9v2H8v-2H7v-1h1v-2H7zm2 3h2v-2H9zm3 0h2v-2h-2zm-1-3V9H9v2z",
        clipRule: "evenodd"
      }
    )
  }
), a2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.477 6.182A2.425 2.425 0 0 1 10.91 3.75h6.91c1.33 0 2.431 1.1 2.431 2.432v6.909a2.425 2.425 0 0 1-2.432 2.432h-4.523v-1.41h4.523c.564 0 1.023-.446 1.023-1.022V6.18c0-.552-.47-1.022-1.023-1.022H10.91c-.576 0-1.023.458-1.023 1.023v4.522h-1.41zm2.091 2.454c0-.389.316-.704.705-.704h4.09c.39 0 .705.315.705.704v4.091a.705.705 0 0 1-1.409 0v-2.39l-4.79 4.791a.705.705 0 0 1-.997-.996l4.79-4.791h-2.39a.705.705 0 0 1-.704-.705M3.75 10.91a2.425 2.425 0 0 1 2.432-2.432h1.25v1.41h-1.25c-.576 0-1.023.458-1.023 1.022v6.91a.995.995 0 0 0 1.023 1.022h6.909c.564 0 1.023-.447 1.023-1.023v-1.25h1.409v1.25a2.425 2.425 0 0 1-2.432 2.432H6.18a2.404 2.404 0 0 1-2.431-2.432V10.91Z",
        clipRule: "evenodd"
      }
    )
  }
), t2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.25 15.625a.64.64 0 0 0 .625-.625V7.031l-2.656-2.656H10.75a.64.64 0 0 0-.625.625v10c0 .352.273.625.625.625zm-7.5 1.875a2.47 2.47 0 0 1-2.5-2.5V5c0-1.367 1.094-2.5 2.5-2.5h5.469c.468 0 .976.234 1.328.586l2.617 2.617c.352.352.586.86.586 1.328V15c0 1.406-1.133 2.5-2.5 2.5zm-5-10H7v1.875H5.75a.64.64 0 0 0-.625.625v10c0 .352.273.625.625.625h7.5a.64.64 0 0 0 .625-.625v-1.25h1.875V20c0 1.406-1.133 2.5-2.5 2.5h-7.5a2.47 2.47 0 0 1-2.5-2.5V10c0-1.367 1.094-2.5 2.5-2.5" })
  }
), h2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.336 3.383h-.024a.55.55 0 0 0-.773 0l-.703.68 1.101 1.101.68-.703c.211-.211.211-.563 0-.797zm-5.438 4.64c-.07.047-.117.141-.14.235l-.399 1.36 1.383-.376a.5.5 0 0 0 .235-.14l3.164-3.165-1.079-1.078zm3.844-5.437a1.67 1.67 0 0 1 2.367 0l.305.305a1.67 1.67 0 0 1 0 2.367l-4.64 4.64a1.86 1.86 0 0 1-.727.422l-2.344.657a.48.48 0 0 1-.539-.141.53.53 0 0 1-.164-.54l.68-2.343c.07-.281.234-.539.422-.726zm-6.68.914h2.625a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H4.063a.925.925 0 0 0-.937.938v6.375c0 .539.398.937.938.937h6.375a.925.925 0 0 0 .937-.938V9.313c0-.305.234-.563.563-.563a.57.57 0 0 1 .562.563v2.624A2.066 2.066 0 0 1 10.437 14H4.064A2.05 2.05 0 0 1 2 11.937V5.564C2 4.438 2.914 3.5 4.063 3.5Z" })
  }
), e2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17.781 5.844h-.031a.736.736 0 0 0-1.031 0l-.938.906 1.469 1.469.906-.938c.282-.281.282-.75 0-1.062zm-7.25 6.187c-.094.063-.156.188-.187.313l-.531 1.812 1.843-.5a.65.65 0 0 0 .313-.187l4.219-4.219-1.438-1.438zm5.125-7.25a2.226 2.226 0 0 1 3.156 0l.407.407a2.226 2.226 0 0 1 0 3.156L13.03 14.53c-.25.25-.594.438-.969.563l-3.124.875a.64.64 0 0 1-.72-.188.71.71 0 0 1-.218-.719l.906-3.124a2.15 2.15 0 0 1 .563-.97l6.187-6.187ZM6.75 6h3.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-3.5c-.719 0-1.25.563-1.25 1.25v8.5c0 .719.531 1.25 1.25 1.25h8.5c.688 0 1.25-.531 1.25-1.25v-3.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v3.5c0 1.531-1.25 2.75-2.75 2.75h-8.5A2.734 2.734 0 0 1 4 17.25v-8.5C4 7.25 5.219 6 6.75 6" })
  }
), r2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M3.188 4.376c0-.631.52-1.188 1.188-1.188h14.257c.63 0 1.188.557 1.188 1.188v6.312l-2.525-2.525a1.55 1.55 0 0 0-2.116 0l-4.864 4.9-2.524-2.524a1.55 1.55 0 0 0-2.116 0l-2.488 2.525zm0 11.88v-1.522l3.341-3.341a.29.29 0 0 1 .409 0l2.524 2.487-3.564 3.565H4.376c-.668 0-1.188-.52-1.188-1.189m12.846-7.24a.29.29 0 0 1 .408 0l3.379 3.342v.841q.46.314.846.66.177.155.342.316V4.376c0-1.3-1.077-2.376-2.376-2.376H4.376A2.37 2.37 0 0 0 2 4.376v11.88a2.346 2.346 0 0 0 2.376 2.377H9.35a7 7 0 0 1-.206-.419l-.01-.024-.01-.025a1.8 1.8 0 0 1-.123-.72H7.57l8.465-8.428Zm-.909 9.974a1.654 1.654 0 0 1 0-2.863 1.67 1.67 0 0 1 1.65 0c.498.308.825.84.825 1.423a1.7 1.7 0 0 1-.825 1.44 1.67 1.67 0 0 1-1.65 0M5.565 5.796c0-.502.266-.945.712-1.211.416-.266.98-.266 1.426 0 .415.266.712.709.712 1.211 0 .532-.297.975-.712 1.241-.446.266-1.01.266-1.426 0a1.41 1.41 0 0 1-.713-1.24Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M20.014 14.74c-.98-.858-2.336-1.578-4.004-1.578-1.689 0-3.044.72-4.024 1.578-.98.837-1.627 1.85-1.94 2.552a.66.66 0 0 0 0 .487c.313.682.96 1.695 1.94 2.552s2.335 1.558 4.024 1.558c1.668 0 3.024-.701 4.004-1.558s1.626-1.87 1.94-2.552a.66.66 0 0 0 0-.487c-.314-.702-.96-1.715-1.94-2.552M18.5 17.5c0 .9-.488 1.722-1.25 2.172-.781.45-1.738.45-2.5 0A2.49 2.49 0 0 1 13.5 17.5c0-.88.469-1.703 1.25-2.153a2.48 2.48 0 0 1 2.5 0A2.53 2.53 0 0 1 18.5 17.5",
          clipRule: "evenodd"
        }
      )
    ]
  }
), i2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.484 2.469a1.514 1.514 0 0 1 2.133 0l.914.914a1.514 1.514 0 0 1 0 2.133L12.406 6.64 9.36 3.594zM8.82 4.133l3.047 3.047-5.46 5.46a2.04 2.04 0 0 1-.868.516L2.703 14a.53.53 0 0 1-.539-.164.48.48 0 0 1-.14-.54l.82-2.835c.094-.328.281-.633.515-.867z" })
  }
), s2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.125 15.281c.125-.437.375-.844.688-1.156l9.5-9.5a2.02 2.02 0 0 1 2.843 0l1.219 1.219c.094.093.188.218.25.312a1.994 1.994 0 0 1-.25 2.532l-9.5 9.5c-.031.03-.094.062-.125.125a3.3 3.3 0 0 1-1.031.562l-2.438.719L4.938 20a.71.71 0 0 1-.72-.219.64.64 0 0 1-.187-.718l.375-1.344zm1.438.438-.22.719-.5 1.718 1.72-.5.718-.218c.219-.063.375-.157.532-.313l7.156-7.156L14.03 8.03l-7.156 7.156c-.031 0-.031.032-.062.063-.125.125-.188.281-.25.469Z" })
  }
), o2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6 7.5c-.281 0-.5.25-.5.5v.719l5.375 4.406a1.744 1.744 0 0 0 2.219 0L18.5 8.719V8c0-.25-.25-.5-.5-.5zm-.5 3.156V16c0 .281.219.5.5.5h12c.25 0 .5-.219.5-.5v-5.344l-4.438 3.625c-1.218 1-2.937 1-4.124 0zM4 8c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v8c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2z" })
  }
), n2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M4 7.5c0 .5.219.938.594 1.219l6.781 5.094a.986.986 0 0 0 1.219 0l6.781-5.094C19.75 8.438 20 8 20 7.5V16c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M5.5 6h13c.813 0 1.5.688 1.5 1.5 0 .5-.25.938-.625 1.219l-6.781 5.094a.986.986 0 0 1-1.219 0L4.594 8.718A1.5 1.5 0 0 1 4 7.5 1.5 1.5 0 0 1 5.5 6"
        }
      )
    ]
  }
), v2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.523 9.477c-.234.234-.234.585 0 .796l1.688 1.688c.094.117.234.164.398.164h2.532a.55.55 0 0 0 .398-.164l1.524-1.524-3.75-3.75zm4.407-6a1.67 1.67 0 0 1 2.367 0l2.976 2.976a1.67 1.67 0 0 1 0 2.367l-3.328 3.305h3.492a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H5.586c-.445 0-.867-.164-1.172-.492L2.727 11.07a1.63 1.63 0 0 1 0-2.367z" })
  }
), w2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.031 13.969c-.312.312-.312.781 0 1.062l2.25 2.25c.125.157.313.219.531.219h3.376a.73.73 0 0 0 .53-.219l2.032-2.031-5-5zm5.875-8a2.226 2.226 0 0 1 3.156 0l3.97 3.968a2.226 2.226 0 0 1 0 3.157L14.593 17.5h4.656a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H8.781c-.594 0-1.156-.219-1.562-.656l-2.25-2.25a2.17 2.17 0 0 1 0-3.157z" })
  }
), x2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5.5c-2.344 0-4.469 1.25-5.656 3.25a6.52 6.52 0 0 0 0 6.5A6.51 6.51 0 0 0 12 18.5c2.313 0 4.438-1.219 5.625-3.25a6.52 6.52 0 0 0 0-6.5C16.437 6.75 14.312 5.5 12 5.5M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m0-12a.76.76 0 0 1 .75.75v3.5A.74.74 0 0 1 12 13a.72.72 0 0 1-.75-.75v-3.5A.74.74 0 0 1 12 8m1 7c0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1" })
  }
), d2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#D4E8FF",
          d: "M8.012 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6 6.01 6.01 0 0 1 5.203-3 6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6 5.96 5.96 0 0 1-5.18 3m0-9a.555.555 0 0 0-.563.563v2.625c0 .328.235.562.563.562a.555.555 0 0 0 .562-.563V5.563A.57.57 0 0 0 8.012 5m-.75 5.25c0 .422.328.75.75.75.398 0 .75-.328.75-.75a.77.77 0 0 0-.75-.75.755.755 0 0 0-.75.75"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M8.012 9.5c.398 0 .75.352.75.75 0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75m0-4.5a.57.57 0 0 1 .562.563v2.625a.555.555 0 0 1-.562.562.54.54 0 0 1-.563-.563V5.563c0-.305.235-.563.563-.563"
        }
      )
    ]
  }
), g2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m0-9a.555.555 0 0 0-.563.563v2.625c0 .328.235.562.563.562a.555.555 0 0 0 .563-.563V5.563A.57.57 0 0 0 8 5m-.75 5.25c0 .422.328.75.75.75.398 0 .75-.328.75-.75A.77.77 0 0 0 8 9.5a.755.755 0 0 0-.75.75" })
  }
), m2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "#D4E8FF",
            d: "M8 0C3.562 0 0 3.594 0 8c0 4.438 3.563 8 8 8 4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8m-.75 4.75A.74.74 0 0 1 8 4a.76.76 0 0 1 .75.75v4A.74.74 0 0 1 8 9.5a.72.72 0 0 1-.75-.75zM8 12.5a.98.98 0 0 1-1-.969.98.98 0 0 1 1-.969c.531 0 .969.438.969.97A.974.974 0 0 1 8 12.5"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "#398AE7",
            d: "M8 9.5a.74.74 0 0 0 .75-.75v-4A.76.76 0 0 0 8 4a.74.74 0 0 0-.75.75v4c0 .438.313.75.75.75m0 1.063a.98.98 0 0 0-1 .968.98.98 0 0 0 1 .969.974.974 0 0 0 .969-.969.974.974 0 0 0-.969-.969Z"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), p2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m0-9a.555.555 0 0 0-.563.563v2.625c0 .328.235.562.563.562a.555.555 0 0 0 .563-.563V5.563A.57.57 0 0 0 8 5m-.75 5.25c0 .422.328.75.75.75.398 0 .75-.328.75-.75A.77.77 0 0 0 8 9.5a.755.755 0 0 0-.75.75",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8.563 5.563v2.625A.555.555 0 0 1 8 8.75a.54.54 0 0 1-.563-.563V5.563A.557.557 0 0 1 8 5a.57.57 0 0 1 .563.563M8 11a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75"
        }
      )
    ]
  }
), u2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#E37612",
          d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m0-12a.74.74 0 0 0-.75.75v3.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-3.5A.76.76 0 0 0 12 8m-1 7c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#E37612",
          d: "M12.75 8.75v3.5A.74.74 0 0 1 12 13a.72.72 0 0 1-.75-.75v-3.5A.74.74 0 0 1 12 8a.76.76 0 0 1 .75.75M12 16c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1"
        }
      )
    ]
  }
), f2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m0-12a.74.74 0 0 0-.75.75v3.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-3.5A.76.76 0 0 0 12 8m-1 7c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M12.75 8.75v3.5A.74.74 0 0 1 12 13a.72.72 0 0 1-.75-.75v-3.5A.74.74 0 0 1 12 8a.76.76 0 0 1 .75.75M12 16c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1" })
    ]
  }
), j2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.75 6.656 5.562 16.813c-.062.093-.062.156-.062.25 0 .25.188.437.438.437H18.03c.25 0 .469-.188.469-.438 0-.093-.031-.156-.094-.25L12.22 6.656A.235.235 0 0 0 12 6.5c-.125 0-.188.063-.25.156m-1.281-.781A1.8 1.8 0 0 1 12 5c.594 0 1.188.344 1.5.875l6.188 10.156c.187.313.312.657.312 1.032C20 18.125 19.125 19 18.031 19H5.938A1.947 1.947 0 0 1 4 17.062q0-.562.281-1.03L10.47 5.874ZM13 15.5c0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1m-.25-5.75v3a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-3A.74.74 0 0 1 12 9a.76.76 0 0 1 .75.75" })
  }
), M2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 2.75c.328 0 .633.188.797.469l5.062 8.625a.95.95 0 0 1 0 .937.89.89 0 0 1-.796.469H2.937c-.351 0-.656-.164-.82-.469a.95.95 0 0 1 0-.937L7.18 3.219A.95.95 0 0 1 8 2.75m0 3a.555.555 0 0 0-.563.563v2.625c0 .328.235.562.563.562a.555.555 0 0 0 .563-.563V6.313A.57.57 0 0 0 8 5.75M8.75 11a.77.77 0 0 0-.75-.75.755.755 0 0 0-.75.75c0 .422.328.75.75.75.398 0 .75-.328.75-.75" })
  }
), C2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5c.438 0 .844.25 1.063.625l6.75 11.5c.218.406.218.875 0 1.25A1.19 1.19 0 0 1 18.75 19H5.25c-.469 0-.875-.219-1.094-.625a1.27 1.27 0 0 1 0-1.25l6.75-11.5A1.26 1.26 0 0 1 12 5m0 4a.74.74 0 0 0-.75.75v3.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-3.5A.76.76 0 0 0 12 9m1 7c0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1 .531 0 1-.438 1-1" })
  }
), A2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17.719 4.219a.736.736 0 0 1 1.031 0l1 1c.313.312.313.781 0 1.062L17.031 9l1.219 1.219a.84.84 0 0 1 .188.844c-.125.28-.407.437-.72.437H13.25a.72.72 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .438-.688.9.9 0 0 1 .843.157L15 6.937zM6.25 12.5h4.5a.76.76 0 0 1 .75.75v4.5a.79.79 0 0 1-.469.719c-.281.093-.625.031-.812-.188L9 17.063 6.281 19.78c-.312.313-.781.313-1.062 0l-1-1a.684.684 0 0 1 0-1.031l2.718-2.719-1.218-1.25c-.219-.187-.282-.531-.188-.812a.79.79 0 0 1 .719-.469Z" })
  }
), V2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9.625 12.5v-1.875h1.125V12.5c0 .844-.68 1.5-1.5 1.5h-6a1.48 1.48 0 0 1-1.5-1.5v-9c0-.82.656-1.5 1.5-1.5h3.867c.399 0 .774.164 1.055.445l2.133 2.133c.28.281.445.656.445 1.055V8H9.625V5.75H7.75A.74.74 0 0 1 7 5V3.125H3.25a.385.385 0 0 0-.375.375v9c0 .21.164.375.375.375h6a.385.385 0 0 0 .375-.375m3.586-5.46 1.875 1.874c.21.234.21.586 0 .797l-1.875 1.875c-.234.234-.586.234-.797 0-.234-.211-.234-.563 0-.797l.914-.914H6.813a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562h6.515l-.914-.914c-.234-.211-.234-.563 0-.797.211-.21.563-.21.797 0Z" })
  }
), z2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M15.5 18v-2.5H17V18c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V12h-1.5V9H13c-.563 0-1-.438-1-1V5.5H7c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5h8c.25 0 .5-.219.5-.5m4.781-7.281 2.5 2.5c.282.312.282.781 0 1.062l-2.5 2.5c-.312.313-.781.313-1.062 0-.313-.281-.313-.75 0-1.062l1.218-1.219H11.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h8.688l-1.22-1.219c-.312-.281-.312-.75 0-1.062.282-.281.75-.281 1.063 0" }),
      /* @__PURE__ */ l.jsx("path", { d: "M1.203 20.57V9.16c0-1.049.85-1.899 1.898-1.899a.75.75 0 0 1 0 1.5.4.4 0 0 0-.398.399v11.41c0 .414.335.75.75.75h8.546a.75.75 0 0 1 0 1.5H3.454a2.25 2.25 0 0 1-2.25-2.25Z" })
    ]
  }
), H2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.26 11.602C3.942 8.327 6.793 6 10 6c3.206 0 6.057 2.327 6.74 5.602a.5.5 0 0 0 .98-.204C16.943 7.673 13.693 5 10 5s-6.943 2.673-7.72 6.398a.5.5 0 0 0 .98.204M10 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-2.5 3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" })
  }
), B2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 6.5c-2.063 0-3.719.938-5 2.125A11.2 11.2 0 0 0 4.531 12c.438.938 1.25 2.281 2.469 3.406 1.281 1.188 2.938 2.094 5 2.094 2.031 0 3.688-.906 4.969-2.094 1.218-1.125 2.062-2.469 2.468-3.406-.406-.938-1.25-2.25-2.437-3.375C15.687 7.437 14.031 6.5 12 6.5M5.969 7.531C7.437 6.156 9.469 5 12 5c2.5 0 4.531 1.156 6 2.531s2.438 2.969 2.906 4.094c.094.25.094.531 0 .781C20.438 13.5 19.47 15.125 18 16.5c-1.469 1.375-3.5 2.5-6 2.5-2.531 0-4.563-1.125-6.031-2.5-1.469-1.375-2.438-3-2.907-4.094a1.12 1.12 0 0 1 0-.781C3.532 10.5 4.5 8.875 5.97 7.531ZM12 14.5c1.375 0 2.5-1.094 2.5-2.5 0-1.375-1.125-2.5-2.5-2.5h-.063c.032.188.063.344.063.5 0 1.125-.906 2-2 2-.188 0-.344 0-.5-.063V12c0 1.406 1.094 2.5 2.5 2.5M12 8c1.406 0 2.719.781 3.438 2a3.98 3.98 0 0 1 0 4A3.96 3.96 0 0 1 12 16c-1.438 0-2.75-.75-3.469-2a3.98 3.98 0 0 1 0-4A4.04 4.04 0 0 1 12 8" })
  }
), L2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "currentColor",
    viewBox: "0 0 30 30",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.484 9.375C5.47 11.25 4.11 13.5 3.5 15c.61 1.5 1.969 3.75 3.984 5.625C9.5 22.5 12.172 24 15.5 24c3.281 0 5.953-1.5 7.969-3.375S26.844 16.5 27.5 15c-.656-1.5-2.016-3.75-4.031-5.625C21.453 7.5 18.78 6 15.5 6c-3.328 0-6 1.5-8.016 3.375M15.5 4.5c3.75 0 6.797 1.734 9 3.797 2.203 2.015 3.656 4.453 4.36 6.14.14.376.14.797 0 1.172-.704 1.641-2.157 4.079-4.36 6.141s-5.25 3.75-9 3.75c-3.797 0-6.844-1.688-9.047-3.75s-3.656-4.5-4.36-6.14a1.68 1.68 0 0 1 0-1.172c.704-1.688 2.157-4.126 4.36-6.141C8.656 6.234 11.703 4.5 15.5 4.5M11 15c0 1.64.844 3.094 2.25 3.938 1.36.796 3.094.796 4.5 0C19.11 18.093 20 16.64 20 15c0-1.594-.89-3.047-2.25-3.89-1.406-.797-3.14-.797-4.5 0C11.844 11.952 11 13.405 11 15m10.5 0c0 2.156-1.172 4.125-3 5.203-1.875 1.078-4.172 1.078-6 0A5.97 5.97 0 0 1 9.5 15a5.95 5.95 0 0 1 3-5.156c1.828-1.078 4.125-1.078 6 0 1.828 1.078 3 3.047 3 5.156" })
  }
), X2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.32 7.813C3.64 9.374 2.508 11.25 2 12.5c.508 1.25 1.64 3.125 3.32 4.688S9.227 20 12 20c2.734 0 4.96-1.25 6.64-2.813 1.68-1.562 2.813-3.437 3.36-4.687-.547-1.25-1.68-3.125-3.36-4.688S14.735 5 12 5C9.227 5 7 6.25 5.32 7.813M12 3.75c3.125 0 5.664 1.445 7.5 3.164 1.836 1.68 3.047 3.711 3.633 5.117a1.4 1.4 0 0 1 0 .977c-.586 1.367-1.797 3.398-3.633 5.117S15.125 21.25 12 21.25c-3.164 0-5.703-1.406-7.54-3.125-1.835-1.719-3.046-3.75-3.632-5.117a1.4 1.4 0 0 1 0-.977c.586-1.406 1.797-3.437 3.633-5.117C6.297 5.195 8.836 3.75 12 3.75M8.25 12.5c0 1.367.703 2.578 1.875 3.281 1.133.664 2.578.664 3.75 0 1.133-.703 1.875-1.914 1.875-3.281 0-1.328-.742-2.54-1.875-3.242-1.172-.664-2.617-.664-3.75 0C8.953 9.96 8.25 11.172 8.25 12.5m8.75 0c0 1.797-.977 3.438-2.5 4.336-1.563.898-3.477.898-5 0A4.97 4.97 0 0 1 7 12.5c0-1.758.938-3.398 2.5-4.297 1.523-.898 3.438-.898 5 0 1.523.899 2.5 2.54 2.5 4.297" })
  }
), R2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 3.125c-1.758 0-3.352.938-4.242 2.438a4.89 4.89 0 0 0 0 4.875A4.88 4.88 0 0 0 8 12.874a4.87 4.87 0 0 0 4.219-2.438 4.89 4.89 0 0 0 0-4.874c-.89-1.5-2.485-2.438-4.219-2.438ZM8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m-.938-4.125h.563v-1.5h-.563a.54.54 0 0 1-.562-.563c0-.304.234-.562.563-.562h1.125a.57.57 0 0 1 .562.563v2.062h.188a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562H7.063a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562ZM8 6.5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75" })
  }
), y2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2.854 2.146a.5.5 0 1 0-.708.708l3.5 3.498a8.1 8.1 0 0 0-3.366 5.046.5.5 0 1 0 .98.204 7.1 7.1 0 0 1 3.107-4.528L7.953 8.66a3.5 3.5 0 1 0 4.886 4.886l4.307 4.308a.5.5 0 0 0 .708-.708zm9.265 10.68A2.5 2.5 0 1 1 8.673 9.38l3.446 3.447Zm-1.995-4.824 3.374 3.374a3.5 3.5 0 0 0-3.374-3.374M10 6c-.57 0-1.129.074-1.666.213l-.803-.803A7.7 7.7 0 0 1 10 5c3.693 0 6.942 2.673 7.72 6.398a.5.5 0 0 1-.98.204C16.058 8.327 13.207 6 10 6" })
  }
), Z2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m3.188 4.188 3.5 2.718C8.094 5.844 9.844 5 12 5c2.5 0 4.531 1.156 6 2.531 1.469 1.344 2.438 2.97 2.906 4.094.094.25.094.531 0 .781-.406 1-1.25 2.438-2.5 3.688l3.282 2.594c.343.25.406.718.125 1.03-.25.345-.72.407-1.032.126l-18.5-14.5c-.344-.25-.406-.719-.125-1.031.25-.344.719-.407 1.031-.125Zm4.718 3.687L9.344 9c.719-.625 1.625-1 2.656-1 2.188 0 4 1.813 4 4 0 .688-.156 1.313-.469 1.844l1.688 1.312c1.093-1.062 1.843-2.28 2.218-3.156-.406-.937-1.25-2.25-2.468-3.375C15.687 7.438 14.03 6.5 12 6.5c-1.594 0-2.938.563-4.094 1.375m6.407 5.031A2.25 2.25 0 0 0 14.5 12c0-1.375-1.125-2.5-2.5-2.5h-.063c.032.188.063.344.063.5 0 .344-.094.625-.219.906zM15.937 18A8.2 8.2 0 0 1 12 19c-2.531 0-4.563-1.125-6.031-2.5-1.469-1.375-2.438-3-2.907-4.094a1.12 1.12 0 0 1 0-.78 12.5 12.5 0 0 1 1.532-2.563L5.75 10a9.8 9.8 0 0 0-1.219 2c.438.938 1.25 2.281 2.469 3.406 1.281 1.188 2.938 2.094 5 2.094.938 0 1.813-.187 2.625-.531L15.938 18Zm-2.75-2.156A5 5 0 0 1 11.97 16c-2.188 0-4-1.781-4-4 0-.062.031-.156.031-.25l1.75 1.375a2.42 2.42 0 0 0 1.688 1.313l1.75 1.406Z" })
  }
), E2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "currentColor",
    viewBox: "0 0 30 30",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ l.jsx("path", { d: "m1.172 3.188 28.547 22.5c.281.234.375.75.093 1.03-.234.329-.703.423-1.03.141L.281 4.36c-.329-.234-.423-.75-.141-1.03.234-.329.75-.423 1.03-.142Zm27.187 12.421c-.468 1.125-1.312 2.672-2.53 4.172l-1.173-.937A17.2 17.2 0 0 0 27 15c-.656-1.5-2.016-3.75-4.031-5.625C20.953 7.5 18.28 6 15 6c-1.875 0-3.563.516-5.016 1.266L8.72 6.234C10.5 5.204 12.563 4.5 15 4.5c3.75 0 6.797 1.734 9 3.797 2.203 2.015 3.656 4.453 4.36 6.14.14.376.14.797 0 1.172ZM4.125 10.266l1.172.937A15.1 15.1 0 0 0 3 15c.61 1.5 1.969 3.75 3.984 5.625C9 22.5 11.672 24 15 24c1.828 0 3.516-.469 4.969-1.219l1.265 1.032C19.5 24.843 17.391 25.5 15 25.5c-3.797 0-6.844-1.688-9.047-3.75s-3.656-4.5-4.36-6.14a1.68 1.68 0 0 1 0-1.172c.47-1.126 1.313-2.672 2.532-4.172M15 21c-3.328 0-6-2.672-6-6 0-.281 0-.563.047-.844l1.453 1.125c.14 2.39 2.11 4.219 4.5 4.219.234 0 .516 0 .75-.047l1.453 1.125A5.9 5.9 0 0 1 15 21m6-6v.047c0 .281-.047.562-.094.844l-1.453-1.125c-.14-2.391-2.062-4.22-4.453-4.22-.281 0-.563 0-.797.048L12.75 9.469C13.453 9.188 14.203 9 15 9c3.281 0 6 2.719 6 6" }) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { d: "M0 0h30v30H0z" }) }) })
    ]
  }
), b2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M20 12c0 4.094-3.094 7.469-7.031 7.969v-5.5h2.156L15.563 12h-2.594v-.844c0-1.312.5-1.812 1.812-1.812.406 0 .719.031.906.031V7.187c-.343-.125-1.218-.218-1.718-.218-2.688 0-3.906 1.281-3.906 4V12H8.405v2.469h1.656v5.312A8.01 8.01 0 0 1 4 12c0-4.406 3.563-8 8-8 4.406 0 8 3.594 8 8" })
  }
), F2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.625 17.781a.95.95 0 0 1-1.063.125A.97.97 0 0 1 5 17V7c0-.375.219-.719.563-.906.343-.157.75-.094 1.062.156L12 10.719v2.594zM13 15V7c0-.375.219-.719.563-.906.343-.157.75-.094 1.062.156l6 5c.219.188.375.469.375.75 0 .313-.156.594-.375.781l-6 5a.95.95 0 0 1-1.063.125A.97.97 0 0 1 13 17z" })
  }
), k2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16 18.5c.25 0 .5-.219.5-.5V9H14c-.563 0-1-.438-1-1V5.5H8c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5zM6 6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V18c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2z" })
  }
), D2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.5 18v-2.5H15V18c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V12h-1.5V9H11c-.563 0-1-.438-1-1V5.5H5c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5h8c.25 0 .5-.219.5-.5m4.781-7.281 2.5 2.5c.282.312.282.781 0 1.062l-2.5 2.5c-.312.313-.781.313-1.062 0-.313-.281-.313-.75 0-1.062l1.218-1.219H9.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h8.688l-1.22-1.219c-.312-.281-.312-.75 0-1.062.282-.281.75-.281 1.063 0" })
  }
), S2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15 20v-3.125h1.25V20c0 1.406-1.133 2.5-2.5 2.5h-10a2.47 2.47 0 0 1-2.5-2.5V5c0-1.367 1.094-2.5 2.5-2.5h6.094c.469 0 .976.234 1.328.586l4.492 4.492c.352.352.586.86.586 1.328V12.5H15V10h-4.375A1.85 1.85 0 0 1 8.75 8.125V3.75h-5c-.703 0-1.25.586-1.25 1.25v15c0 .703.547 1.25 1.25 1.25h10c.664 0 1.25-.547 1.25-1.25m-.04-11.25c-.038-.078-.077-.195-.155-.273l-4.532-4.532c-.078-.078-.195-.117-.273-.156v4.336c0 .352.273.625.625.625h4.336Zm4.845 2.07 3.75 3.75a.66.66 0 0 1 0 .899l-3.75 3.75a.66.66 0 0 1-.899 0 .66.66 0 0 1 0-.899l2.696-2.695H9.375A.617.617 0 0 1 8.75 15c0-.313.273-.625.625-.625h12.227l-2.696-2.656a.66.66 0 0 1 0-.899.66.66 0 0 1 .899 0" })
  }
), P2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2.5 3.5C2.5 2.68 3.156 2 4 2h3.75v3c0 .422.328.75.75.75h3v3.375H6.625c-.844 0-1.5.68-1.5 1.5V14H4a1.48 1.48 0 0 1-1.5-1.5zm9 1.5h-3V2zm-4.875 5.25h.75c.703 0 1.313.61 1.313 1.313 0 .726-.61 1.312-1.313 1.312H7v.75c0 .21-.188.375-.375.375a.37.37 0 0 1-.375-.375v-3c0-.188.164-.375.375-.375m.75 1.875a.555.555 0 0 0 .563-.563.57.57 0 0 0-.563-.562H7v1.125zm2.25-1.875h.75c.61 0 1.125.516 1.125 1.125v1.5c0 .633-.516 1.125-1.125 1.125h-.75a.37.37 0 0 1-.375-.375v-3c0-.188.164-.375.375-.375m.75 3a.385.385 0 0 0 .375-.375v-1.5a.4.4 0 0 0-.375-.375H10v2.25zm1.875-2.625c0-.188.164-.375.375-.375h1.125c.188 0 .375.188.375.375 0 .21-.188.375-.375.375H13v.75h.75c.188 0 .375.188.375.375 0 .21-.188.375-.375.375H13v1.125c0 .21-.188.375-.375.375a.37.37 0 0 1-.375-.375z" })
  }
), T2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10 15.5h7c.25 0 .5-.219.5-.5V8H16c-.563 0-1-.438-1-1V5.5h-5c-.281 0-.5.25-.5.5v9c0 .281.219.5.5.5m7 1.5h-7c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l1.844 1.843c.375.375.594.875.594 1.407V15c0 1.125-.906 2-2 2M5.75 7a.76.76 0 0 1 .75.75v8a2.734 2.734 0 0 0 2.75 2.75h6a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-6A4.215 4.215 0 0 1 5 15.75v-8A.74.74 0 0 1 5.75 7" })
  }
), _2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2 3.734a.97.97 0 0 1 .96-.984h10.056a.99.99 0 0 1 .984.984.94.94 0 0 1-.234.61L9.875 9.148V12.5a.76.76 0 0 1-.773.75.72.72 0 0 1-.47-.164l-2.155-1.711a.91.91 0 0 1-.352-.727v-1.5L2.211 4.344A.92.92 0 0 1 2 3.734m1.29.141 3.82 4.71a.57.57 0 0 1 .14.352v1.618l1.5 1.195V8.937a.53.53 0 0 1 .117-.351l3.844-4.711H3.289Z" })
  }
), O2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 6.313C4 5.593 4.563 5 5.281 5h13.407A1.32 1.32 0 0 1 20 6.313c0 .312-.125.593-.313.812L14.5 13.531V18c0 .563-.469 1-1.031 1a.96.96 0 0 1-.625-.219L9.969 16.5a1.21 1.21 0 0 1-.469-.969v-2L4.281 7.125A1.22 1.22 0 0 1 4 6.312Zm1.719.187 5.093 6.281a.75.75 0 0 1 .188.469v2.156L13 17v-3.75c0-.156.031-.313.156-.469L18.281 6.5z" })
  }
), U2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M2.375 9.29c0-.696.793-1.06 1.317-.664l.101.09 5.518 5.705a.825.825 0 0 1-.021 1.167l-5.517 5.329a.825.825 0 0 1-1.398-.593zm1.25 10.032 4.49-4.338-4.49-4.645zM21 20.323V9.29a.2.2 0 0 0-.344-.139l-5.517 5.706a.2.2 0 0 0 .005.283l5.517 5.328a.2.2 0 0 0 .339-.143Z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M21.625 9.29c0-.742-.902-1.107-1.418-.574l-5.517 5.706a.825.825 0 0 0 .02 1.167l5.517 5.328a.825.825 0 0 0 1.398-.594zM18.45 1.132a.3.3 0 0 1 .518.037l2.064 4.261a.3.3 0 0 1-.292.43l-4.722-.343a.3.3 0 0 1-.226-.468l.814-1.2a.297.297 0 0 0-.12-.436c-2.127-.988-4.13-1.554-6.094-1.189-2.225.415-4.715 1.56-7.061 3.63a.5.5 0 0 1-.662-.75C5.097 2.964 7.747 1.7 10.21 1.24c2.27-.422 4.555.234 6.925 1.37a.3.3 0 0 0 .381-.101l.935-1.378Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M18.384 1.014a.426.426 0 0 1 .697.101l2.064 4.26a.425.425 0 0 1-.414.61l-4.722-.343a.425.425 0 0 1-.32-.664l.813-1.199a.172.172 0 0 0-.068-.253c-2.12-.983-4.093-1.537-6.019-1.178-2.063.384-4.363 1.405-6.563 3.225l-.439.374a.625.625 0 1 1-.826-.937l.46-.394C5.362 2.7 7.855 1.552 10.185 1.118c2.31-.43 4.624.24 7.002 1.38.08.04.175.013.224-.059l.936-1.378zm.471.21a.175.175 0 0 0-.27-.058l-.031.036-.936 1.378a.43.43 0 0 1-.538.145c-2.36-1.133-4.617-1.776-6.849-1.36-2.285.425-4.738 1.552-7.024 3.444l-.455.388a.375.375 0 0 0 .496.563l.444-.38c2.231-1.844 4.569-2.886 6.677-3.279 2.004-.372 4.035.208 6.17 1.199.237.11.316.405.17.62l-.813 1.2a.175.175 0 0 0 .131.272l4.722.343c.134.01.229-.13.17-.25z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M11.375 23v-1h1.25v1a.625.625 0 1 1-1.25 0m1.25-4v2h-1.25v-2zm0-3v2h-1.25v-2zm0-3v2h-1.25v-2zm0-3v2h-1.25v-2zm0-3v2h-1.25V7zm-1.25-2a.625.625 0 1 1 1.25 0v1h-1.25z" })
    ]
  }
), q2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M1.5 8.764c0-1.145 1.36-1.714 2.176-.961l.077.076 5.783 6.229a1.3 1.3 0 0 1-.033 1.803L3.72 21.695c-.82.82-2.22.239-2.22-.92V8.765Zm2 10.321 4.111-4.111L3.5 10.546zm18-10.321v12.012a.3.3 0 0 1-.512.212l-5.784-5.784a.3.3 0 0 1-.007-.416L20.98 8.56a.3.3 0 0 1 .52.204" }),
      /* @__PURE__ */ l.jsx("path", { d: "M22.5 8.764c0-1.145-1.36-1.714-2.176-.961l-.077.076-5.783 6.229a1.3 1.3 0 0 0 .033 1.803l5.783 5.784c.82.82 2.22.239 2.22-.92V8.765Zm-2 10.321-4.111-4.111 4.111-4.428zM11 22.5v-1.063h2V22.5a1 1 0 1 1-2 0m2-5.313v2.125h-2v-2.125zm0-4.25v2.126h-2v-2.126zm0-4.25v2.126h-2V8.687zM11 5.5a1 1 0 1 1 2 0v1.063h-2z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M12 1c2.618 0 5.517 1.08 7.47 2.117l-.94 1.766C16.72 3.92 14.157 3 12 3 8.265 3 5.47 4.397 3.6 5.8a1 1 0 1 1-1.2-1.6C4.53 2.603 7.735 1 12 1" }),
      /* @__PURE__ */ l.jsx("path", { d: "m17.28 7 3.67-.59.278-.045a.74.74 0 0 0 .622-.86l-.635-3.948a.78.78 0 0 0-.572-.605c-.292-.048-.622.068-.777.283L18.778 2.74l-2.227 3.08a.84.84 0 0 0-.051.863c.168.258.47.368.78.318Z" })
    ]
  }
), I2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M5.269 10.836v6.452l3.239-3.165-3.24-3.287ZM3.75 9.486c0-.846 1.054-1.262 1.654-.652l4.577 4.643a.926.926 0 0 1-.013 1.318l-4.576 4.472c-.606.592-1.642.172-1.642-.665zm16.48 0c0-.846-1.053-1.262-1.654-.652L14 13.477a.926.926 0 0 0 .013 1.318l4.576 4.472c.606.592 1.642.172 1.642-.665zM12 5.25a.75.75 0 0 1 .75.75v.938h-1.5V6a.75.75 0 0 1 .75-.75m-.75 5.438V8.812h1.5v1.876zm0 3.75v-1.876h1.5v1.876zm0 3.75v-1.875h1.5v1.875zm0 2.812v-.938h1.5V21a.75.75 0 0 1-1.5 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M17.275 2.618a.353.353 0 0 1 .61.044L19.6 6.204a.353.353 0 0 1-.343.506l-3.925-.285a.353.353 0 0 1-.266-.55l.676-.998a.143.143 0 0 0-.057-.21c-1.762-.818-3.402-1.278-5.003-.98-1.829.34-3.881 1.284-5.819 2.992a.52.52 0 1 1-.687-.779c2.03-1.79 4.25-2.85 6.316-3.234 1.92-.358 3.843.198 5.82 1.147.066.032.145.01.186-.05z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M17.172 2.548a.478.478 0 0 1 .826.06l1.715 3.541a.478.478 0 0 1-.465.686l-3.925-.286a.478.478 0 0 1-.36-.745l.676-.997a.02.02 0 0 0-.007-.027c-1.754-.814-3.364-1.261-4.927-.97-1.805.336-3.837 1.268-5.76 2.963a.644.644 0 0 1-.852-.967C6.14 4.002 8.378 2.932 10.47 2.542c1.959-.364 3.912.205 5.897 1.158a.02.02 0 0 0 .029-.007l.777-1.145Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), W2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.786 3.75.11.008a.74.74 0 0 1 .306.118l3.214 2.143a.75.75 0 0 1-.832 1.248L8.559 5.25H5.25v13.5h4.929v-6H8.25a.75.75 0 0 1 0-1.5h5.357a.75.75 0 0 1 0 1.5H11.68v6h7.071v-6h-1.929a.75.75 0 0 1 0-1.5h1.929v-6H14.68a.75.75 0 0 1 0-1.5h4.82a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75z" })
  }
), $2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M14.256 10.646a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M3.25 2.75h5.672c.398 0 .797.164 1.078.445L11.805 5c.28.281.445.68.445 1.078v.46a4.13 4.13 0 0 0-4.225 2.641A1.5 1.5 0 0 0 7 8.75c-.54 0-1.031.305-1.313.75a1.55 1.55 0 0 0 0 1.5c.282.469.774.75 1.313.75.3 0 .593-.096.84-.268.137.66.43 1.264.841 1.768H3.25a1.48 1.48 0 0 1-1.5-1.5v-7.5c0-.82.656-1.5 1.5-1.5m0 2.25v1.5c0 .422.328.75.75.75h4.5c.398 0 .75-.328.75-.75V5a.77.77 0 0 0-.75-.75H4a.755.755 0 0 0-.75.75m12.006 5.646a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0M13.83 9.26a.375.375 0 0 1 0 .53l-2.235 2.234a.375.375 0 0 1-.53 0l-1.13-1.13a.375.375 0 0 1 .53-.531l.865.865L13.3 9.26a.375.375 0 0 1 .53 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Y2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2 4.25c0-.82.656-1.5 1.5-1.5h3.094c.445 0 .867.188 1.195.516l.984.984H12.5c.82 0 1.5.68 1.5 1.5v6c0 .844-.68 1.5-1.5 1.5h-9a1.48 1.48 0 0 1-1.5-1.5zm1.5-.375a.385.385 0 0 0-.375.375v7.5c0 .21.164.375.375.375h9a.385.385 0 0 0 .375-.375v-6a.4.4 0 0 0-.375-.375H8.703a.96.96 0 0 1-.656-.258L6.992 4.04a.67.67 0 0 0-.398-.164z" })
  }
), G2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 7c0-1.094.875-2 2-2h4.125c.594 0 1.156.25 1.594.688L13.03 7H18c1.094 0 2 .906 2 2v8c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2zm2-.5c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5h12c.25 0 .5-.219.5-.5V9c0-.25-.25-.5-.5-.5h-5.063c-.312 0-.656-.125-.874-.344L10.655 6.72c-.156-.125-.344-.219-.531-.219z" })
  }
), N2 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M1 11.875v-6.75C1 3.977 1.926 3 3.125 3v1C2.492 4 2 4.516 2 5.125v6.75A1.11 1.11 0 0 0 3.125 13h9.75c.61 0 1.125-.492 1.125-1.125v-5.25A1.14 1.14 0 0 0 12.875 5.5v-1A2.14 2.14 0 0 1 15 6.625v5.25A2.125 2.125 0 0 1 12.875 14h-9.75A2.11 2.11 0 0 1 1 11.875M7.29 3l1.5 1.5h4.085v1h-4.5L6.875 4h-3.75V3h4.164Z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#D9D9D9",
          d: "M12.875 5.5h-4.5L6.875 4h-3.75C2.492 4 2 4.516 2 5.125v6.75A1.11 1.11 0 0 0 3.125 13h9.75c.61 0 1.125-.492 1.125-1.125v-5.25A1.14 1.14 0 0 0 12.875 5.5"
        }
      )
    ]
  }
), J2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15 19H5c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2h3.656c.531 0 1.031.219 1.406.594l.844.843c.375.375.875.563 1.406.563H16c1.094 0 2 .906 2 2v1h-1.5V9c0-.25-.25-.5-.5-.5h-3.688c-.937 0-1.812-.344-2.468-1L9 6.656a.5.5 0 0 0-.344-.156H5c-.281 0-.5.25-.5.5v8.188L6.625 11.5c.188-.313.5-.5.875-.5H20c.344 0 .688.188.844.5.187.313.187.719 0 1.031l-3.5 6c-.188.282-.5.469-.844.469z" })
  }
), K2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.5 2.75h3.094c.445 0 .867.188 1.195.516l.984.984H12.5c.82 0 1.5.68 1.5 1.5v6c0 .844-.68 1.5-1.5 1.5h-9a1.48 1.48 0 0 1-1.5-1.5v-7.5c0-.82.656-1.5 1.5-1.5m-.375 1.5v7.5c0 .21.164.375.375.375h1.875c0-1.031.82-1.875 1.875-1.875h1.5a1.88 1.88 0 0 1 1.875 1.875H12.5a.385.385 0 0 0 .375-.375v-6a.4.4 0 0 0-.375-.375H8.703a.96.96 0 0 1-.656-.258L6.992 4.04a.67.67 0 0 0-.398-.164H3.5a.385.385 0 0 0-.375.375ZM9.5 8c0 .54-.305 1.031-.75 1.313a1.55 1.55 0 0 1-1.5 0A1.52 1.52 0 0 1 6.5 8c0-.516.281-1.008.75-1.29a1.55 1.55 0 0 1 1.5 0c.445.282.75.774.75 1.29" })
  }
), Q2 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6 5h4.125c.594 0 1.156.25 1.594.688L13.03 7H18c1.094 0 2 .906 2 2v8c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2m-.5 2v10c0 .281.219.5.5.5h2.5c0-1.375 1.094-2.5 2.5-2.5h2c1.375 0 2.5 1.125 2.5 2.5H18c.25 0 .5-.219.5-.5V9c0-.25-.25-.5-.5-.5h-5.063c-.312 0-.656-.125-.874-.344L10.655 6.72c-.156-.125-.344-.219-.531-.219H6c-.281 0-.5.25-.5.5Zm8.5 5c0 .719-.406 1.375-1 1.75-.625.344-1.406.344-2 0A2.03 2.03 0 0 1 10 12a2.02 2.02 0 0 1 1-1.719c.594-.344 1.375-.344 2 0 .594.375 1 1.031 1 1.719" })
  }
), l4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 6.5c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5h14c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5zM3 7c0-1.094.875-2 2-2h14c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2zm3 8.25a.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75m4 0a.74.74 0 0 1 .75-.75h3.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-3.5a.72.72 0 0 1-.75-.75" })
  }
), c4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 4h5v4c0 .563.438 1 1 1h4v9c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2m6 0 4 4h-4zM8.5 6c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm0 2c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm.5 3c-.563 0-1 .469-1 1v2c0 .563.438 1 1 1h6c.531 0 1-.438 1-1v-2c0-.531-.469-1-1-1zm0 1h6v2H9zm4.5 5c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5z" })
  }
), a4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M14.75 4h4.5a.76.76 0 0 1 .75.75v4.5a.79.79 0 0 1-.469.719c-.281.094-.625.031-.812-.188L17.5 8.562l-2.719 2.72c-.312.312-.781.312-1.062 0l-1-1a.684.684 0 0 1 0-1.032l2.719-2.719-1.22-1.25c-.218-.187-.28-.531-.187-.812A.79.79 0 0 1 14.75 4m-5.5 16h-4.5a.72.72 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .438-.688.9.9 0 0 1 .843.157L6.5 15.438l2.719-2.72a.736.736 0 0 1 1.031 0l1 1c.313.313.313.782 0 1.063L8.531 17.5l1.219 1.219a.84.84 0 0 1 .188.843c-.126.282-.407.438-.72.438z" })
  }
), t4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9.793 12.793a1 1 0 0 1 1.497 1.32l-.083.094L6.414 19H9a1 1 0 0 1 .117 1.993L9 21H4a1 1 0 0 1-.993-.883L3 20v-5a1 1 0 0 1 1.993-.117L5 15v2.586zM20 3a1 1 0 0 1 .993.883L21 4v5a1 1 0 0 1-1.993.117L19 9V6.414l-4.793 4.793a1 1 0 0 1-1.497-1.32l.083-.094L17.586 5H15a1 1 0 0 1-.117-1.993L15 3z" })
  }
), h4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 12.875c.164 0 .633-.164 1.102-1.125.21-.422.398-.914.515-1.5H6.36c.141.586.305 1.078.516 1.5.492.96.938 1.125 1.125 1.125Zm-1.828-3.75h3.633a9 9 0 0 0 0-2.25H6.172c-.047.375-.047.75-.047 1.125 0 .398 0 .773.047 1.125m.187-3.375h3.258a6 6 0 0 0-.515-1.477c-.47-.96-.938-1.148-1.102-1.148-.188 0-.633.188-1.125 1.148-.21.422-.375.915-.516 1.477m4.57 1.125c.048.375.048.75.048 1.125 0 .398 0 .773-.047 1.125h1.804q.141-.528.141-1.125 0-.562-.14-1.125zm1.383-1.125a4.82 4.82 0 0 0-2.296-2.18c.328.61.586 1.36.75 2.18zm-7.101 0c.164-.82.422-1.57.75-2.18a4.82 4.82 0 0 0-2.297 2.18zM3.242 6.875c-.07.375-.117.75-.117 1.125 0 .398.023.773.117 1.125h1.805C5 8.773 5 8.398 5 8c0-.375 0-.75.047-1.125zm6.774 5.578a4.76 4.76 0 0 0 2.296-2.203h-1.546c-.164.844-.422 1.594-.75 2.203m-4.055 0c-.328-.61-.586-1.36-.75-2.203H3.664a4.76 4.76 0 0 0 2.297 2.203M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14" })
  }
), e4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 18.5c.219 0 .844-.219 1.469-1.5a7.9 7.9 0 0 0 .687-2H9.812c.188.781.407 1.438.688 2 .656 1.281 1.25 1.5 1.5 1.5m-2.438-5h4.844a12 12 0 0 0 0-3H9.562C9.5 11 9.5 11.5 9.5 12c0 .531 0 1.031.063 1.5Zm.25-4.5h4.344a8 8 0 0 0-.687-1.969C12.844 5.75 12.219 5.5 12 5.5c-.25 0-.844.25-1.5 1.531-.281.563-.5 1.219-.688 1.969m6.094 1.5c.063.5.063 1 .063 1.5 0 .531 0 1.031-.063 1.5h2.406q.188-.703.188-1.5 0-.75-.188-1.5zM17.75 9a6.43 6.43 0 0 0-3.063-2.906c.438.812.782 1.812 1 2.906zM8.281 9c.219-1.094.563-2.094 1-2.906A6.43 6.43 0 0 0 6.22 9h2.06Zm-2.625 1.5c-.093.5-.156 1-.156 1.5 0 .531.031 1.031.156 1.5h2.407C8 13.031 8 12.531 8 12c0-.5 0-1 .063-1.5zm9.032 7.438A6.35 6.35 0 0 0 17.75 15h-2.063c-.218 1.125-.562 2.125-1 2.938Zm-5.407 0c-.437-.813-.781-1.813-1-2.938H6.22a6.35 6.35 0 0 0 3.062 2.938ZM12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20" })
  }
), r4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.969 6.031c-.563 0-.969.438-.969 1v9.97c0 .562.438 1 1 1 .531 0 1-.438 1-1V7.03c0-.562-.469-1-1.031-1Zm7.375.22-6 4.968c-.25.219-.344.5-.344.781 0 .313.094.594.344.781l6 4.97c.656.53 1.625.093 1.625-.75V7c0-.845-.969-1.282-1.625-.75Z" })
  }
), i4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 5.5c0-.25.219-.5.5-.5h1.781c.282 0 .5.25.5.5v1.813c0 .28-.218.5-.5.5H5.5a.494.494 0 0 1-.5-.5zm0 3.75c0-.281.219-.5.5-.5h1.781c.282 0 .5.219.5.5v1.813c0 .25-.218.5-.5.5H5.5c-.281 0-.5-.25-.5-.5zm.5 3.219h1.781c.282 0 .5.25.5.5v1.812c0 .281-.218.5-.5.5H5.5a.494.494 0 0 1-.5-.5V12.97c0-.25.219-.5.5-.5Zm-.5 4.25c0-.282.219-.5.5-.5h1.781c.282 0 .5.218.5.5V18.5c0 .281-.218.5-.5.5H5.5a.494.494 0 0 1-.5-.5zM8.719 5.5c0-.25.219-.5.5-.5h1.812c.25 0 .5.25.5.5v1.813c0 .28-.25.5-.5.5H9.22a.494.494 0 0 1-.5-.5V5.5Zm0 3.75c0-.281.219-.5.5-.5h1.812c.25 0 .5.219.5.5v1.813c0 .25-.25.5-.5.5H9.22c-.281 0-.5-.25-.5-.5V9.25Zm.5 3.219h1.812c.25 0 .5.25.5.5v1.812c0 .281-.25.5-.5.5H9.22a.494.494 0 0 1-.5-.5V12.97c0-.25.219-.5.5-.5Zm-.5 4.25c0-.282.219-.5.5-.5h1.812c.25 0 .5.218.5.5V18.5c0 .281-.25.5-.5.5H9.22a.494.494 0 0 1-.5-.5v-1.781ZM12.938 5h1.812c.281 0 .5.25.5.5v1.813c0 .28-.219.5-.5.5h-1.813c-.25 0-.5-.22-.5-.5V5.5c0-.25.25-.5.5-.5Zm0 3.75h1.812c.281 0 .5.219.5.5v1.813c0 .25-.219.5-.5.5h-1.813c-.25 0-.5-.25-.5-.5V9.25c0-.281.25-.5.5-.5Zm-.5 4.219c0-.25.25-.5.5-.5h1.812c.281 0 .5.25.5.5v1.812c0 .281-.219.5-.5.5h-1.813c-.25 0-.5-.219-.5-.5V12.97Zm.5 3.25h1.812c.281 0 .5.218.5.5V18.5c0 .281-.219.5-.5.5h-1.813c-.25 0-.5-.219-.5-.5v-1.781c0-.282.25-.5.5-.5ZM16.188 5.5c0-.25.218-.5.5-.5H18.5c.25 0 .5.25.5.5v1.813c0 .28-.25.5-.5.5h-1.813a.494.494 0 0 1-.5-.5zm0 3.75c0-.281.218-.5.5-.5H18.5c.25 0 .5.219.5.5v1.813c0 .25-.25.5-.5.5h-1.813c-.28 0-.5-.25-.5-.5zm.5 3.219H18.5c.25 0 .5.25.5.5v1.812c0 .281-.25.5-.5.5h-1.813a.494.494 0 0 1-.5-.5V12.97c0-.25.22-.5.5-.5Zm-.5 4.25c0-.282.218-.5.5-.5H18.5c.25 0 .5.218.5.5V18.5c0 .281-.25.5-.5.5h-1.813a.494.494 0 0 1-.5-.5z" })
  }
), s4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.25 6.5a.555.555 0 0 1-.563.563H3.313A.54.54 0 0 1 2.75 6.5c0-.305.234-.563.563-.563h9.374a.57.57 0 0 1 .563.563m0 3a.555.555 0 0 1-.563.563H3.313A.54.54 0 0 1 2.75 9.5c0-.305.234-.563.563-.563h9.374a.57.57 0 0 1 .563.563" })
  }
), o4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M19 10c0 .281-.25.5-.5.5h-13A.494.494 0 0 1 5 10c0-.25.219-.5.5-.5h13c.25 0 .5.25.5.5m0 4c0 .281-.25.5-.5.5h-13A.494.494 0 0 1 5 14c0-.25.219-.5.5-.5h13c.25 0 .5.25.5.5" })
  }
), n4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6 5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75m0 3.75A.74.74 0 0 1 5.25 8c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75m.75 3c0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75M9 5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75m.75 3c0 .422-.352.75-.75.75A.74.74 0 0 1 8.25 8c0-.398.328-.75.75-.75.398 0 .75.352.75.75M9 12.5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75" })
  }
), v4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10 8c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1m0 5c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1m1 4c0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1m3-9c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1m1 4c0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1m-1 6c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1" })
  }
), w4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.5 6.031 8.906 7.625a3 3 0 0 0-1.312.719l-.813.719c-.343.28-.75.437-1.187.437H3.75A.72.72 0 0 1 3 8.75.74.74 0 0 1 3.75 8h1.844c.062 0 .125 0 .187-.063l.813-.718C7.469 6.437 8.594 6 9.75 6h.344c.125 0 .25.031.406.031M13.781 6a4.64 4.64 0 0 1 3.063 1.188l.937.843h2.469a.74.74 0 0 1 .75.75.76.76 0 0 1-.75.75H17.5a.74.74 0 0 1-.5-.219l-1.156-1c-.563-.53-1.313-.78-2.063-.78-.812 0-1.562.28-2.156.843l-2.188 2.063a.767.767 0 0 0 .032 1.124c.281.25.719.25 1-.03l2.25-2.063a.774.774 0 0 1 1.062.031.774.774 0 0 1-.031 1.063l-.031.03 2.312 2.313c.313.313.532.719.625 1.094h3.594a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-3.781c-.094.219-.25.438-.438.594-.531.531-1.25.75-1.968.625-.094.25-.25.437-.438.625a2.43 2.43 0 0 1-3.156.281 2.015 2.015 0 0 1-2.688-.156l-.812-.844-.219-.219-1.125-1.093a1 1 0 0 0-.719-.282H3.75a.74.74 0 0 1-.75-.75c0-.437.313-.75.75-.75h1.156c.688 0 1.313.25 1.782.719l1.125 1.125.218.219.844.812c.188.219.5.219.688 0 .062-.031.093-.093.124-.156a.77.77 0 0 1 .532-.5c.25-.031.531.031.687.219l.344.312a.906.906 0 0 0 1.313 0c.156-.156.25-.375.28-.593 0-.282.157-.532.407-.626a.78.78 0 0 1 .781.063.764.764 0 0 0 .969-.094c.281-.281.281-.75 0-1.062l-2.375-2.375-1.125 1.031c-.844.813-2.156.813-3.031.031-1-.875-1-2.406-.063-3.312l2.188-2.063C11.469 6.47 12.594 6 13.78 6Z" })
  }
), x4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.333 12.809a.35.35 0 0 0 .167.04V14l-.153-.008a1.5 1.5 0 0 1-.566-.175zm1.278.04V14H4.5v-1.15zm3.5 0V14H6.89v-1.15h2.22Zm2.389 0V14h-1.111v-1.15zm.718.968A1.5 1.5 0 0 1 11.5 14v-1.15a.35.35 0 0 0 .167-.041zM3 12.5v-.952h1.15v.952q.001.095.041.167l-.504.274v.001l-.505.276A1.5 1.5 0 0 1 3 12.5m10 0c0 .26-.066.505-.183.718l-.505-.276-.503-.275a.35.35 0 0 0 .04-.167v-.952H13zM4.15 8.548v1.904H3V8.548zm8.85 0v1.904h-1.15V8.548zm-8.85-3v1.904H3V5.548zm8.85 0v1.904h-1.15V5.548zM3 3.5c0-.26.065-.505.182-.719l.506.277.503.275a.34.34 0 0 0-.04.167v.952H3zm10 .952h-1.15V3.5a.35.35 0 0 0-.041-.167l1.008-.552c.117.214.183.459.183.719zM5.611 3.15H4.5a.34.34 0 0 0-.167.041l-.552-1.01a1.5 1.5 0 0 1 .566-.173L4.5 2h1.111zM11.5 2c.26 0 .505.065.718.182l-.261.48-.29.53a.34.34 0 0 0-.167-.042h-1.111V2zM9.111 3.15H6.89V2h2.22v1.15ZM5 4.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 6zm0 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5z" })
  }
), d4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.5 12c0-2.313-1.25-4.438-3.25-5.625a6.52 6.52 0 0 0-6.5 0C6.719 7.563 5.5 9.688 5.5 12a6.51 6.51 0 0 0 3.25 5.656 6.52 6.52 0 0 0 6.5 0c2-1.187 3.25-3.312 3.25-5.656M4 12a7.94 7.94 0 0 1 4-6.906c2.469-1.438 5.5-1.438 8 0C18.469 6.53 20 9.156 20 12a8.02 8.02 0 0 1-4 6.938c-2.5 1.437-5.531 1.437-8 0A7.95 7.95 0 0 1 4 12m5.281-2.813A1.745 1.745 0 0 1 10.937 8h1.813c1.094 0 2 .906 2 2 0 .688-.406 1.344-1 1.688l-1 .593c-.031.406-.344.719-.75.719a.72.72 0 0 1-.75-.75v-.406c0-.281.125-.531.375-.656L13 10.405a.49.49 0 0 0 .25-.406c0-.281-.219-.469-.5-.469h-1.813a.235.235 0 0 0-.218.156l-.031.032a.734.734 0 0 1-.938.469.78.78 0 0 1-.469-.97zM11 15c0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1" })
  }
), g4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9 9a.74.74 0 0 1-.75.75A.72.72 0 0 1 7.5 9c0-2.188 1.781-4 4-4h.969c2.219 0 4 1.813 4 4v.156a3.77 3.77 0 0 1-1.657 3.125l-1.624 1.094a.98.98 0 0 0-.438.813v.062A.74.74 0 0 1 12 15a.72.72 0 0 1-.75-.75v-.063c0-.812.406-1.593 1.094-2.062l1.625-1.094A2.2 2.2 0 0 0 15 9.156V9c0-1.375-1.125-2.5-2.5-2.5h-1A2.487 2.487 0 0 0 9 9m3 10c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1" })
  }
), m4 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M9.75 5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H6.687l5.5 5.5a.53.53 0 0 1 0 .719.53.53 0 0 1-.718 0L6 6.719V10c0 .281-.25.5-.5.5A.494.494 0 0 1 5 10V5.5c0-.25.219-.5.5-.5z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M7 18c-.563 0-1-.438-1-1v-5H5v5c0 1.125.875 2 2 2h10c1.094 0 2-.875 2-2V7c0-1.094-.906-2-2-2h-5v1h5c.531 0 1 .469 1 1v10c0 .563-.469 1-1 1z" })
    ]
  }
), p4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.5 7.344A8.02 8.02 0 0 1 12 4c4.406 0 8 3.594 8 8 0 4.438-3.594 8-8 8a7.97 7.97 0 0 1-4.438-1.313.717.717 0 0 1-.187-1.03.75.75 0 0 1 1.031-.22c1.031.688 2.25 1.063 3.594 1.063 3.563 0 6.5-2.906 6.5-6.5 0-3.563-2.938-6.5-6.5-6.5-2.313 0-4.344 1.219-5.5 3h1.75a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-3.5A.72.72 0 0 1 4 9.25v-3.5A.74.74 0 0 1 4.75 5a.76.76 0 0 1 .75.75zM12 8h-.031a.74.74 0 0 1 .75.75v2.969l2.031 2.031a.684.684 0 0 1 0 1.031.684.684 0 0 1-1.031 0l-2.25-2.25c-.156-.125-.219-.312-.219-.531V8.75A.74.74 0 0 1 12 8" })
  }
), u4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m12.469 4.188 8.25 7a.78.78 0 0 1 .093 1.062.78.78 0 0 1-1.062.094l-.75-.656V17.5c0 1.406-1.125 2.5-2.5 2.5h-9A2.47 2.47 0 0 1 5 17.5v-5.813l-.781.657a.78.78 0 0 1-1.063-.094.78.78 0 0 1 .094-1.063l8.25-7a.8.8 0 0 1 .969 0Zm5.031 6.218L12 5.75l-5.5 4.656V17.5c0 .563.438 1 1 1h9c.531 0 1-.438 1-1z" })
  }
), f4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.57 2.656a.65.65 0 0 1 .82 0l10.626 9.375c.273.235.273.625.078.899-.235.273-.625.273-.899.039l-1.445-1.29v7.696a3.11 3.11 0 0 1-3.125 3.125H6.375c-1.758 0-3.125-1.367-3.125-3.125V11.68l-1.484 1.289c-.235.234-.664.234-.86-.04-.234-.273-.234-.663.04-.898zm-7.07 7.93v8.789a1.85 1.85 0 0 0 1.875 1.875h11.25c1.016 0 1.875-.82 1.875-1.875v-8.79l-7.5-6.6z" })
  }
), j4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.5 2.563c0-.305.234-.563.563-.563h7.875a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562h-.187v.445c0 .961-.375 1.852-1.055 2.532L8.773 8l1.922 1.922a3.5 3.5 0 0 1 1.055 2.508v.445h.188a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562H4.064a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562h.187v-.445c0-.938.375-1.852 1.031-2.508L7.203 8 5.281 6.102A3.62 3.62 0 0 1 4.25 3.57v-.445h-.188a.54.54 0 0 1-.562-.563Zm2.578 8.156c-.094.094-.164.187-.258.281h4.336a3 3 0 0 0-.258-.281L8 8.797zM10.156 5c.305-.398.469-.914.469-1.43v-.445h-5.25v.445c0 .54.164 1.032.445 1.43z" })
  }
), M4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6 4.75A.74.74 0 0 1 6.75 4h10.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H17v.594a4.73 4.73 0 0 1-1.406 3.375L13.03 12l2.563 2.563A4.66 4.66 0 0 1 17 17.905v.594h.25a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H6.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75H7v-.594c0-1.25.5-2.468 1.375-3.343L10.938 12 8.374 9.469A4.83 4.83 0 0 1 7 6.094V5.5h-.25A.72.72 0 0 1 6 4.75m8.531 3.656a3.24 3.24 0 0 0 .969-2.312V5.5h-7v.594c0 .875.344 1.687.938 2.312L12 10.97z" })
  }
), C4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.5 4.375h-9a.385.385 0 0 0-.375.375v7.523l.094-.14 1.875-2.625a.57.57 0 0 1 .468-.258c.165 0 .352.094.446.234l.726 1.008L8.68 7.984a.53.53 0 0 1 .445-.234c.164 0 .328.094.445.234l3.188 4.125.117.141v-7.5a.4.4 0 0 0-.375-.375m-9-1.125h9c.82 0 1.5.68 1.5 1.5v7.5c0 .844-.68 1.5-1.5 1.5h-9a1.48 1.48 0 0 1-1.5-1.5v-7.5c0-.82.656-1.5 1.5-1.5m1.875 4.5c-.422 0-.773-.21-.984-.563a1.08 1.08 0 0 1 0-1.125c.21-.328.562-.562.984-.562.398 0 .75.234.96.563.212.351.212.796 0 1.125-.21.351-.562.562-.96.562" })
  }
), A4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18 6.5H6c-.281 0-.5.25-.5.5v10.031l.125-.187 2.5-3.5c.156-.219.375-.344.625-.344.219 0 .469.125.594.313l.969 1.343 2.593-3.344A.71.71 0 0 1 13.5 11c.219 0 .438.125.594.313l4.25 5.5.156.187V7c0-.25-.25-.5-.5-.5M6 5h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2m2.5 6a1.5 1.5 0 0 1-1.313-.75c-.28-.438-.28-1.031 0-1.5C7.47 8.312 7.938 8 8.5 8c.531 0 1 .313 1.281.75.281.469.281 1.063 0 1.5-.281.469-.75.75-1.281.75" })
  }
), V4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 12.875a.385.385 0 0 0 .375-.375V5.75H10.5A.74.74 0 0 1 9.75 5V3.125H6a.385.385 0 0 0-.375.375V8H4.5V3.5C4.5 2.68 5.156 2 6 2h3.867c.399 0 .774.164 1.055.445l2.133 2.133c.28.281.445.656.445 1.055V12.5c0 .844-.68 1.5-1.5 1.5H6a1.48 1.48 0 0 1-1.5-1.5v-1.875h1.125V12.5c0 .21.164.375.375.375zM8.46 7.039l1.876 1.875c.21.234.21.586 0 .797L8.46 11.586c-.234.234-.586.234-.797 0-.234-.211-.234-.563 0-.797l.914-.914H2.063a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562h6.515l-.914-.914c-.234-.211-.234-.563 0-.797.211-.21.563-.21.797 0Z" })
  }
), z4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18 18.5c.25 0 .5-.219.5-.5V9H16c-.563 0-1-.438-1-1V5.5h-5c-.281 0-.5.25-.5.5v6H8V6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V18c0 1.125-.906 2-2 2h-8c-1.125 0-2-.875-2-2v-2.5h1.5V18c0 .281.219.5.5.5zm-4.719-7.781 2.5 2.5c.281.312.281.781 0 1.062l-2.5 2.5c-.312.313-.781.313-1.062 0-.313-.281-.313-.75 0-1.062l1.219-1.219H4.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h8.688l-1.22-1.219c-.312-.281-.312-.75 0-1.062.282-.281.75-.281 1.063 0" })
  }
), H4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5.5c-2.344 0-4.469 1.25-5.656 3.25a6.52 6.52 0 0 0 0 6.5A6.51 6.51 0 0 0 12 18.5c2.313 0 4.438-1.219 5.625-3.25a6.52 6.52 0 0 0 0-6.5C16.437 6.75 14.312 5.5 12 5.5M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m-1.25-5.5h.75v-2h-.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75v2.75h.25a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75M12 10c-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1" })
  }
), B4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 3.125c-1.758 0-3.352.938-4.242 2.438a4.89 4.89 0 0 0 0 4.875A4.88 4.88 0 0 0 8 12.874a4.87 4.87 0 0 0 4.219-2.438 4.89 4.89 0 0 0 0-4.874c-.89-1.5-2.485-2.438-4.219-2.438ZM8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m-.938-4.125h.563v-1.5h-.563a.54.54 0 0 1-.562-.563c0-.304.234-.562.563-.562h1.125a.57.57 0 0 1 .562.563v2.062h.188a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562H7.063a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562ZM8 6.5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75" })
  }
), L4 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8 2C4.672 2 2 4.695 2 8c0 3.328 2.672 6 6 6 3.305 0 6-2.672 6-6 0-3.305-2.695-6-6-6m0 3c.398 0 .75.352.75.75 0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75m.938 6H7.062a.54.54 0 0 1-.562-.563c0-.304.234-.562.563-.562h.375v-1.5H7.25a.54.54 0 0 1-.563-.563c0-.304.235-.562.563-.562H8a.57.57 0 0 1 .563.563v2.062h.374a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562Z",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8 6.5c.398 0 .75-.328.75-.75A.77.77 0 0 0 8 5a.755.755 0 0 0-.75.75c0 .422.328.75.75.75m.938 3.375h-.376V7.812A.57.57 0 0 0 8 7.25h-.75a.555.555 0 0 0-.563.563c0 .328.235.562.563.562h.188v1.5h-.375a.555.555 0 0 0-.563.563c0 .328.234.562.563.562h1.875a.555.555 0 0 0 .562-.563.57.57 0 0 0-.563-.562Z"
        }
      )
    ]
  }
), X4 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M12 4c-4.438 0-8 3.594-8 8 0 4.438 3.563 8 8 8 4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8m0 4c.531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1m1.25 8h-2.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h.5v-2H11a.72.72 0 0 1-.75-.75A.74.74 0 0 1 11 11h1a.76.76 0 0 1 .75.75v2.75h.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M12 10c.531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1m1.25 4.5h-.5v-2.75A.76.76 0 0 0 12 11h-1a.74.74 0 0 0-.75.75c0 .438.313.75.75.75h.25v2h-.5a.74.74 0 0 0-.75.75c0 .438.313.75.75.75h2.5a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75"
        }
      )
    ]
  }
), R4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M19.781 5.875c-.312-.312-.781-.312-1.062 0l-.657.656L19.5 7.97l.656-.688c.282-.28.282-.75 0-1.062zm-6.562 5.531q-.14.188-.188.375l-.312 1.563 1.531-.313a.75.75 0 0 0 .375-.218L18.438 9 17 7.594zm4.437-6.593a2.235 2.235 0 0 1 3.188 0l.375.375a2.226 2.226 0 0 1 0 3.156l-5.532 5.531a2.24 2.24 0 0 1-1.124.625l-2.688.531c-.219.063-.5 0-.656-.187-.188-.188-.281-.438-.219-.688l.563-2.687c.093-.406.312-.813.593-1.094zM4.25 8h6a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-6a.74.74 0 0 0-.75.75v7.5c0 .438.313.75.75.75h13.5a.74.74 0 0 0 .75-.75v-4a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v4A2.26 2.26 0 0 1 17.75 20H4.25C3 20 2 19 2 17.75v-7.5C2 9.031 3 8 4.25 8M6 15c-.563 0-1-.437-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1m4-1c0 .563-.469 1-1 1-.563 0-1-.437-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1" })
  }
), y4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.474 10.526a4.17 4.17 0 0 0-5.744-.143l-.151.143-2.358 2.358a4.168 4.168 0 0 0 5.744 6.039l.15-.144 1.77-1.768a.834.834 0 0 0-1.101-1.249l-.079.07L9.937 17.6a2.5 2.5 0 0 1-3.65-3.417l.113-.12 2.358-2.358a2.5 2.5 0 0 1 3.537 0 .834.834 0 0 0 1.179-1.179m5.305-5.305a4.17 4.17 0 0 0-5.744-.144l-.15.144-1.77 1.768a.834.834 0 0 0 1.101 1.249l.079-.07L14.063 6.4a2.501 2.501 0 0 1 3.65 3.417l-.113.12-2.358 2.358a2.5 2.5 0 0 1-3.537 0 .833.833 0 1 0-1.179 1.179 4.17 4.17 0 0 0 5.744.143l.151-.143 2.358-2.358a4.17 4.17 0 0 0 0-5.895" })
  }
), Z4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.798 10.039 5.276 12.56a4.358 4.358 0 1 0 6.164 6.164l.84-.84a1.189 1.189 0 0 0-1.68-1.682l-.841.84a1.981 1.981 0 0 1-2.802-2.8L9.48 11.72a1.98 1.98 0 0 1 2.124-.444q.191.076.36.155l.367.172c.492.222.87.318 1.35-.163.692-.691.513-1.33-.33-1.91a4.36 4.36 0 0 0-5.552.509Zm4.762-4.763-.84.84a1.189 1.189 0 0 0 1.68 1.682l.841-.84a1.981 1.981 0 0 1 2.802 2.8L14.52 12.28a1.98 1.98 0 0 1-2.124.444 7 7 0 0 1-.36-.155l-.367-.172c-.492-.222-.87-.318-1.35.163-.692.691-.513 1.33.33 1.91a4.36 4.36 0 0 0 5.552-.509l2.522-2.521a4.358 4.358 0 0 0-6.164-6.164Z" })
  }
), E4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 4c.25 0 .531.063.75.188l6.563 2.78c.406.188.687.595.687 1.032 0 .469-.281.875-.688 1.063l-6.562 2.78c-.219.126-.5.157-.75.157-.281 0-.531-.031-.781-.156L4.656 9.063A1.15 1.15 0 0 1 4 8c0-.438.25-.844.656-1.031l6.563-2.782c.25-.125.5-.187.781-.187m-.188 1.563L6.063 8l5.75 2.469A.4.4 0 0 0 12 10.5c.063 0 .125 0 .156-.031L17.906 8l-5.75-2.438A.24.24 0 0 0 12 5.5a.44.44 0 0 0-.188.063m-7.156 5.406 1-.406 1.907.812-1.5.625 5.75 2.469A.4.4 0 0 0 12 14.5c.063 0 .125 0 .156-.031L17.906 12l-1.468-.625 1.875-.813 1 .407c.406.187.687.594.687 1.031 0 .469-.281.875-.688 1.063l-6.562 2.78c-.219.126-.5.157-.75.157-.281 0-.531-.031-.781-.156l-6.563-2.781A1.15 1.15 0 0 1 4 12c0-.438.25-.844.656-1.031m0 4 1-.406 1.907.812-1.5.625 5.75 2.469A.4.4 0 0 0 12 18.5c.063 0 .125 0 .156-.031L17.906 16l-1.468-.625 1.875-.813 1 .407c.406.187.687.594.687 1.031 0 .469-.281.875-.688 1.063l-6.562 2.78c-.219.126-.5.157-.75.157-.281 0-.531-.031-.781-.156l-6.563-2.782C4.25 16.875 4 16.47 4 16c0-.438.25-.844.656-1.031" })
  }
), b4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.14 2.695A2.1 2.1 0 0 1 12 2.5c.273 0 .586.078.82.195l8.516 3.828c.39.157.664.547.664 1.016 0 .43-.273.82-.664.977l-8.516 3.828a2 2 0 0 1-.82.156c-.313 0-.586-.04-.86-.156L2.626 8.516C2.235 8.359 2 7.969 2 7.5c0-.43.234-.82.625-.977zM12 3.75c-.117 0-.234.04-.352.078L3.445 7.5l8.203 3.71c.118.04.235.04.352.04s.234 0 .313-.04l8.203-3.71-8.203-3.672A.7.7 0 0 0 12 3.75M2.625 16.523l1.797-.82 1.523.664-2.5 1.133 8.203 3.71c.118.04.235.04.352.04s.234 0 .313-.04l8.203-3.71-2.5-1.094 1.523-.703 1.797.82c.39.157.664.547.664 1.016 0 .43-.273.82-.664.977l-8.516 3.828a2 2 0 0 1-.82.156c-.313 0-.586-.04-.86-.156l-8.515-3.828C2.235 18.359 2 17.969 2 17.5c0-.43.234-.82.625-.977m1.797-5.82 1.523.664-2.5 1.133 8.203 3.71c.118.04.235.04.352.04s.234 0 .313-.04l8.203-3.71-2.5-1.094 1.523-.703 1.797.82c.39.157.664.547.664 1.016 0 .43-.273.82-.664.977l-8.516 3.828a2 2 0 0 1-.82.156c-.313 0-.586-.04-.86-.156l-8.515-3.828C2.235 13.359 2 12.969 2 12.5c0-.43.234-.82.625-.977z" })
  }
), F4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18 6.5H6c-.281 0-.5.25-.5.5v2h13V7c0-.25-.25-.5-.5-.5M5.5 17c0 .281.219.5.5.5h2.5v-7h-3zm4.5.5h8c.25 0 .5-.219.5-.5v-6.5H10zM6 5h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2" })
  }
), k4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.781 18.75C9.97 18.437 8.531 18 7.5 18c-1.219 0-2.781.406-3.75.719-.375.125-.75-.157-.75-.5V6.625c0-.375.188-.719.563-.844C4.436 5.438 5.905 5 7.5 5c1.813 0 3.219.625 3.844 1.125a.5.5 0 0 1 .156.344V18.25a.535.535 0 0 1-.719.5m2.406 0c-.343.125-.687-.125-.687-.5V6.469c0-.125.031-.25.156-.344.594-.5 2-1.125 3.844-1.125 1.563 0 3.031.438 3.906.781a.87.87 0 0 1 .594.844v11.594c0 .343-.406.625-.781.5C19.25 18.406 17.687 18 16.5 18c-1.063 0-2.469.438-3.313.75" })
  }
), D4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m20.094 12.375-3.5 3.5a4.47 4.47 0 0 1-6.375 0 4.51 4.51 0 0 1-.5-5.813l.031-.03c.344-.47.969-.563 1.406-.25a.997.997 0 0 1 .219 1.405l-.031.032c-.719 1-.594 2.375.281 3.25.969 1 2.563 1 3.563 0l3.5-3.5c1-1 1-2.594 0-3.563-.875-.875-2.25-1-3.25-.281l-.032.031A.997.997 0 0 1 14 6.937a1.035 1.035 0 0 1 .219-1.406l.062-.031a4.51 4.51 0 0 1 5.813.5 4.47 4.47 0 0 1 0 6.375m-16.219-.719 3.5-3.531a4.565 4.565 0 0 1 6.406 0c1.563 1.562 1.75 4.031.469 5.844l-.031.03c-.313.47-.969.563-1.406.25a.997.997 0 0 1-.22-1.405l.032-.032a2.515 2.515 0 0 0-.281-3.25c-.969-1-2.563-1-3.563 0l-3.5 3.5c-.968.97-.968 2.563 0 3.563.875.875 2.25 1 3.25.281l.031-.031a.997.997 0 0 1 1.407.219A1.035 1.035 0 0 1 9.75 18.5l-.063.031c-1.78 1.281-4.25 1.063-5.812-.5a4.47 4.47 0 0 1 0-6.375" })
  }
), S4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.02 7.272a.5.5 0 0 1 .707.707l-.751.75a1.624 1.624 0 0 0 2.172 2.408l.123-.113.75-.75a.5.5 0 0 1 .708.708l-.75.75a2.624 2.624 0 0 1-3.71-3.71zm4.128-1.126a.5.5 0 0 1 .707.707L6.853 9.856a.5.5 0 0 1-.707-.707zm-.927-2.058c1.03-.84 2.55-.78 3.51.18l.181.2c.784.962.784 2.35 0 3.311l-.18.2-.75.75a.5.5 0 0 1-.708-.706l.75-.751.112-.123a1.624 1.624 0 0 0 0-2.05l-.112-.123a1.623 1.623 0 0 0-2.171-.112l-.124.112-.75.75-.08.064a.5.5 0 0 1-.628-.771l.75-.75z" })
  }
), P4 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M4.22 7.036a.7.7 0 0 1 .99.99l-.938.939a1.954 1.954 0 0 0 2.764 2.763l.937-.938.11-.09a.701.701 0 0 1 .88 1.08l-.937.938a3.355 3.355 0 0 1-4.744-4.743l.939-.939Z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M9.382 5.629a.7.7 0 0 1 .99.99l-3.754 3.753a.7.7 0 0 1-.99-.99L9.382 5.63Z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M8.1 3.163a3.354 3.354 0 0 1 4.618.12l.119.124a3.356 3.356 0 0 1 0 4.494l-.12.125-.938.938-.11.09a.7.7 0 0 1-.88-1.08l.938-.938.134-.148a1.954 1.954 0 0 0 0-2.467l-.134-.149a1.955 1.955 0 0 0-2.615-.134l-.148.134-.939.939a.7.7 0 0 1-.989-.99l.938-.939z" })
    ]
  }
), T4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.25 5.5h1.5a.76.76 0 0 1 .75.75v1.5a.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75v-1.5a.74.74 0 0 1 .75-.75m4.5.75h9.5A.76.76 0 0 1 20 7a.74.74 0 0 1-.75.75h-9.5A.72.72 0 0 1 9 7a.74.74 0 0 1 .75-.75m0 5h9.5A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-9.5A.72.72 0 0 1 9 12a.74.74 0 0 1 .75-.75m0 5h9.5A.76.76 0 0 1 20 17a.74.74 0 0 1-.75.75h-9.5A.72.72 0 0 1 9 17a.74.74 0 0 1 .75-.75m-5.25-5a.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75v1.5a.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75zm.75 4.25h1.5a.76.76 0 0 1 .75.75v1.5a.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75v-1.5a.74.74 0 0 1 .75-.75" })
  }
), _4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.781 6.281V6.25l-2.25 2.5A.67.67 0 0 1 6 9a.6.6 0 0 1-.531-.219l-1.25-1.25c-.313-.281-.313-.75 0-1.062.281-.282.75-.282 1.062 0l.688.718L7.687 5.25a.774.774 0 0 1 1.063-.031c.281.28.313.75.031 1.062m0 5v-.031l-2.25 2.5A.67.67 0 0 1 6 14a.6.6 0 0 1-.531-.219l-1.25-1.25c-.313-.281-.313-.75 0-1.062.281-.282.75-.282 1.062 0l.688.718 1.718-1.937a.774.774 0 0 1 1.063-.031c.281.28.313.75.031 1.062M10.75 7.75A.72.72 0 0 1 10 7a.74.74 0 0 1 .75-.75h8.5A.76.76 0 0 1 20 7a.74.74 0 0 1-.75.75zM10 12a.74.74 0 0 1 .75-.75h8.5A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-8.5A.72.72 0 0 1 10 12m-1 5a.74.74 0 0 1 .75-.75h9.5A.76.76 0 0 1 20 17a.74.74 0 0 1-.75.75h-9.5A.72.72 0 0 1 9 17m-2 0c0 .562-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1" })
  }
), O4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.75 5.5h1.5a.76.76 0 0 1 .75.75v1.5a.74.74 0 0 1-.75.75v2.75H8a.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75v1.5a.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75H6.25V16c0 .156.094.25.25.25H8a.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75v1.5a.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75H6.5c-.969 0-1.75-.781-1.75-1.75V8.5A.72.72 0 0 1 4 7.75v-1.5a.74.74 0 0 1 .75-.75M9 7a.74.74 0 0 1 .75-.75h9.5A.76.76 0 0 1 20 7a.74.74 0 0 1-.75.75h-9.5A.72.72 0 0 1 9 7m4 5a.74.74 0 0 1 .75-.75h5.5A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-5.5A.72.72 0 0 1 13 12m0 5a.74.74 0 0 1 .75-.75h5.5A.76.76 0 0 1 20 17a.74.74 0 0 1-.75.75h-5.5A.72.72 0 0 1 13 17" })
  }
), U4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.563 2.563v1.874A.555.555 0 0 1 8 5a.54.54 0 0 1-.563-.563V2.563A.56.56 0 0 1 8 2a.57.57 0 0 1 .563.563m0 9v1.874A.555.555 0 0 1 8 14a.54.54 0 0 1-.563-.563v-1.874c0-.305.235-.563.563-.563a.57.57 0 0 1 .563.563M2 8c0-.305.234-.563.563-.563h1.874A.57.57 0 0 1 5 8a.555.555 0 0 1-.563.563H2.563A.54.54 0 0 1 2 8m9.563-.563h1.874A.57.57 0 0 1 14 8a.555.555 0 0 1-.563.563h-1.874A.54.54 0 0 1 11 8c0-.305.234-.563.563-.563m.68-3.68c.21.235.21.587 0 .798L10.905 5.89a.58.58 0 0 1-.797 0 .58.58 0 0 1 0-.797l1.336-1.336c.211-.211.563-.211.797 0ZM5.866 10.93 4.53 12.242a.513.513 0 0 1-.773 0 .513.513 0 0 1 0-.773l1.312-1.336a.58.58 0 0 1 .797 0c.211.21.211.562 0 .797m-2.11-7.172a.55.55 0 0 1 .774 0l1.336 1.336a.58.58 0 0 1 0 .797c-.21.21-.562.21-.797 0L3.758 4.555c-.235-.211-.235-.563 0-.797Zm7.15 6.375 1.335 1.336a.55.55 0 0 1 0 .773c-.234.235-.586.235-.797 0L10.11 10.93a.58.58 0 0 1 0-.797.58.58 0 0 1 .797 0Z" })
  }
), q4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.75 4.75v2.5A.74.74 0 0 1 12 8a.72.72 0 0 1-.75-.75v-2.5A.74.74 0 0 1 12 4a.76.76 0 0 1 .75.75m0 12v2.5A.74.74 0 0 1 12 20a.72.72 0 0 1-.75-.75v-2.5A.74.74 0 0 1 12 16a.76.76 0 0 1 .75.75M4 12a.74.74 0 0 1 .75-.75h2.5A.76.76 0 0 1 8 12a.74.74 0 0 1-.75.75h-2.5A.72.72 0 0 1 4 12m12.75-.75h2.5A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-2.5A.72.72 0 0 1 16 12a.74.74 0 0 1 .75-.75m.906-4.906c.282.312.282.781 0 1.062l-1.781 1.782a.774.774 0 0 1-1.063 0 .774.774 0 0 1 0-1.063l1.782-1.781c.281-.282.75-.282 1.062 0m-8.5 9.562-1.781 1.75a.684.684 0 0 1-1.031 0 .684.684 0 0 1 0-1.031l1.75-1.781a.774.774 0 0 1 1.062 0c.281.281.281.75 0 1.062M6.344 6.344a.736.736 0 0 1 1.031 0l1.781 1.781a.774.774 0 0 1 0 1.063c-.281.28-.75.28-1.062 0l-1.75-1.782c-.313-.281-.313-.75 0-1.062m9.531 8.5 1.781 1.781a.736.736 0 0 1 0 1.031c-.312.313-.781.313-1.062 0l-1.782-1.75a.774.774 0 0 1 0-1.062.774.774 0 0 1 1.063 0" })
  }
), I4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9.5 8v2h5V8c0-1.375-1.125-2.5-2.5-2.5A2.487 2.487 0 0 0 9.5 8M8 10V8c0-2.188 1.781-4 4-4 2.188 0 4 1.813 4 4v2h1c1.094 0 2 .906 2 2v6c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2v-6c0-1.094.875-2 2-2zm-1.5 2v6c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5v-6c0-.25-.25-.5-.5-.5H7c-.281 0-.5.25-.5.5" })
  }
), W4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.125 5.375V6.5h3.75V5.375A1.88 1.88 0 0 0 8 3.5a1.866 1.866 0 0 0-1.875 1.875M4.625 6.5V5.375C4.625 3.523 6.125 2 8 2a3.39 3.39 0 0 1 3.375 3.375V6.5h.125c.82 0 1.5.68 1.5 1.5v4.5c0 .844-.68 1.5-1.5 1.5h-7A1.48 1.48 0 0 1 3 12.5V8c0-.82.656-1.5 1.5-1.5z" })
  }
), $4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M14 8v2h1c1.094 0 2 .906 2 2v6c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2v-6c0-1.094.875-2 2-2h7.5V8c0-2.188 1.781-4 4-4 2.188 0 4 1.813 4 4v2.25a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75V8c0-1.375-1.125-2.5-2.5-2.5A2.487 2.487 0 0 0 14 8m-9 3.5c-.281 0-.5.25-.5.5v6c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5v-6c0-.25-.25-.5-.5-.5z" })
  }
), Y4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15 8.594v1.656a.74.74 0 0 1-.75.75H10.5v2h3.75a.76.76 0 0 1 .75.75v1.688L18.438 12zM20 12c0 .375-.156.719-.406.969l-3.625 3.625a1.44 1.44 0 0 1-1.031.406 1.414 1.414 0 0 1-1.438-1.438V14.5h-3A1.48 1.48 0 0 1 9 13v-2a1.5 1.5 0 0 1 1.5-1.5h3V8.469c0-.813.625-1.469 1.438-1.469.374 0 .75.156 1.03.438l3.626 3.625c.25.25.406.593.406.937M9.25 6.5h-2.5c-.719 0-1.25.563-1.25 1.25v8.5c0 .719.531 1.25 1.25 1.25h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2.5A2.734 2.734 0 0 1 4 16.25v-8.5C4 6.25 5.219 5 6.75 5h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75" })
  }
), G4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m15.781 7.313 3.844 3.843c.219.219.375.531.375.844 0 .344-.156.656-.375.875l-3.844 3.844c-.187.187-.469.281-.75.281A1.04 1.04 0 0 1 14 15.969V14h-4c-.563 0-1-.438-1-1v-2c0-.531.438-1 1-1h4V8.062C14 7.5 14.469 7 15.031 7c.281 0 .563.125.75.313M9 7H7c-.563 0-1 .469-1 1v8c0 .563.438 1 1 1h2c.531 0 1 .469 1 1 0 .563-.469 1-1 1H7a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h2c.531 0 1 .469 1 1 0 .563-.469 1-1 1" })
  }
), N4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.5 12c0 3.063 2.438 5.5 5.5 5.5 3.031 0 5.5-2.438 5.5-5.5v-2h-2v2c0 1.938-1.594 3.5-3.5 3.5A3.494 3.494 0 0 1 8.5 12v-2h-2zM5 6.75C5 5.812 5.781 5 6.75 5h1.5C9.188 5 10 5.813 10 6.75V12c0 1.125.875 2 2 2 1.094 0 2-.875 2-2V6.75c0-.938.781-1.75 1.75-1.75h1.5c.938 0 1.75.813 1.75 1.75V12c0 3.875-3.156 7-7 7-3.875 0-7-3.125-7-7z" })
  }
), J4 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.125 5a.64.64 0 0 0-.625.625V7.5h3.125V5.625C7.625 5.312 7.312 5 7 5zM4.5 12.5c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5V8.75h-3.125v3.75c0 2.422-1.992 4.375-4.375 4.375A4.37 4.37 0 0 1 7.625 12.5V8.75H4.5zm15-5V5.625c0-.313-.313-.625-.625-.625H17a.64.64 0 0 0-.625.625V7.5zM3.25 5.625c0-1.016.82-1.875 1.875-1.875H7c1.016 0 1.875.86 1.875 1.875V12.5c0 1.758 1.367 3.125 3.125 3.125a3.11 3.11 0 0 0 3.125-3.125V5.625c0-1.016.82-1.875 1.875-1.875h1.875c1.016 0 1.875.86 1.875 1.875V12.5c0 4.844-3.945 8.75-8.75 8.75a8.736 8.736 0 0 1-8.75-8.75z" })
  }
), K4 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M20 20.5V22H4v-1.5zm.5-.5V4a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5V22l-.204-.01A2 2 0 0 1 2 20V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2v-1.5a.5.5 0 0 0 .5-.5" }),
      /* @__PURE__ */ l.jsx("path", { d: "M7.99 9.808 8.11 7.5h7.563l.118 2.308h-.236a2.46 2.46 0 0 0-2.311-1.616H12.6v6.347c0 .765.47 1.452 1.182 1.73v.231H10v-.23a1.86 1.86 0 0 0 1.182-1.731V8.192h-.644a2.46 2.46 0 0 0-2.31 1.616z" })
    ]
  }
), Q4 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M9 11.03a.3.3 0 0 1 .454-.257l4.117 2.47a.3.3 0 0 1 0 .514l-4.117 2.47A.3.3 0 0 1 9 15.97z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M20 3a2.5 2.5 0 0 1 2.5 2.5V17a2.5 2.5 0 0 1-2.5 2.5h-.05a2.5 2.5 0 0 1-2.45 2h-13A2.5 2.5 0 0 1 2 19V8a2.5 2.5 0 0 1 2.5-2.5H5A2.5 2.5 0 0 1 7.5 3zM4.5 7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm3-2.5a1 1 0 0 0-1 1h11A2.5 2.5 0 0 1 20 8v10a1 1 0 0 0 1-1V5.5a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), l3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          fillRule: "evenodd",
          d: "M22 4.143V3H4v2.286h15.75V19H22z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          fillRule: "evenodd",
          d: "M20 5v16H2V5zM8.978 9.778c-.327-.196-.593-.046-.593.335v6.326c0 .38.265.532.593.335l5.237-3.142c.326-.196.327-.515 0-.711z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), c3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 6.75A.74.74 0 0 1 5.75 6h12.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H5.75A.72.72 0 0 1 5 6.75m0 5a.74.74 0 0 1 .75-.75h12.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H5.75a.72.72 0 0 1-.75-.75m14 5a.74.74 0 0 1-.75.75H5.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h12.5a.76.76 0 0 1 .75.75" })
  }
), a3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.875 8a.555.555 0 0 1-.563.563H3.688A.54.54 0 0 1 3.125 8c0-.305.234-.563.563-.563h8.624a.57.57 0 0 1 .563.563" })
  }
), t3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.5 12a.74.74 0 0 1-.75.75H6.25A.72.72 0 0 1 5.5 12a.74.74 0 0 1 .75-.75h11.5a.76.76 0 0 1 .75.75" })
  }
), h3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5.5c-2.344 0-4.469 1.25-5.656 3.25a6.52 6.52 0 0 0 0 6.5A6.51 6.51 0 0 0 12 18.5c2.313 0 4.438-1.219 5.625-3.25a6.52 6.52 0 0 0 0-6.5C16.437 6.75 14.312 5.5 12 5.5M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m-2.25-8.75h4.5A.76.76 0 0 1 15 12a.74.74 0 0 1-.75.75h-4.5A.72.72 0 0 1 9 12a.74.74 0 0 1 .75-.75" })
  }
), e3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#E31C1C",
          d: "M4 12c0-4.406 3.563-8 8-8 4.406 0 8 3.594 8 8 0 4.438-3.594 8-8 8-4.438 0-8-3.563-8-8m5.25-.75a.74.74 0 0 0-.75.75c0 .438.313.75.75.75h5.5a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M2.5 12c0-5.23 4.23-9.5 9.5-9.5V4c-4.438 0-8 3.594-8 8 0 4.438 3.563 8 8 8 4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8V2.5c5.235 0 9.5 4.265 9.5 9.5 0 5.27-4.27 9.5-9.5 9.5A9.476 9.476 0 0 1 2.5 12m12.25-.75v1.5h-5.5A.72.72 0 0 1 8.5 12a.74.74 0 0 1 .75-.75zm0 0a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z"
        }
      )
    ]
  }
), r3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M12.748 3.625a.75.75 0 0 0-1.5 0v1.016h1.5zm0 5.077v-2.03h-1.5v2.03zm0 4.063v-2.032h-1.5v2.031zm0 4.061v-2.03h-1.5v2.03zm0 3.047v-1.016h-1.5v1.016a.75.75 0 1 0 1.5 0M8.365 5.829a.95.95 0 0 0-.866.56l-3.826 8.479a.95.95 0 0 0-.084.39v1.091c0 .525.425.95.95.95H9.3a.95.95 0 0 0 .95-.95V6.78a.95.95 0 0 0-.95-.95h-.935ZM5.09 15.377l3.63-8.048h.03v8.47H5.089zm10.161-4.662V7.329h.054l3.607 8.089v.381H15.25zm-.55-4.886a.95.95 0 0 0-.95.95v9.57c0 .525.425.95.95.95h4.761a.95.95 0 0 0 .95-.95v-1.048a.95.95 0 0 0-.082-.387l-3.8-8.522a.95.95 0 0 0-.868-.563H14.7Z",
        clipRule: "evenodd"
      }
    )
  }
), i3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M13 1.5a1 1 0 1 0-2 0v1.05h2zm-2 3.15v2.1h2v-2.1zm0 4.2v2.1h2v-2.1zm0 4.2v2.1h2v-2.1zm0 8.4v1.05a1 1 0 1 0 2 0v-1.05zM6.915 4a1.2 1.2 0 0 0-1.094.706L.607 16.242a1.2 1.2 0 0 0-.107.495V18.3a1.2 1.2 0 0 0 1.2 1.2h6.6a1.2 1.2 0 0 0 1.2-1.2V5.2A1.2 1.2 0 0 0 8.3 4zM11 17.25v2.1h2v-2.1zm-8.5-.34L7.431 6H7.5v11.5h-5zM15.7 4a1.2 1.2 0 0 0-1.2 1.2v13.1a1.2 1.2 0 0 0 1.2 1.2h6.6a1.2 1.2 0 0 0 1.2-1.2v-1.506a1.2 1.2 0 0 0-.104-.489l-5.18-11.594A1.2 1.2 0 0 0 17.12 4zm.8 13.5V6h.102L21.5 16.965v.535z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { d: "M0 0h24v24H0z" }) }) })
    ]
  }
), s3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M12.625 1a.625.625 0 1 0-1.25 0v.917h1.25zm0 4.583V3.75h-1.25v1.833zm0 3.667V7.417h-1.25V9.25zm0 3.667v-1.834h-1.25v1.834zm0 3.666V14.75h-1.25v1.833zm0 3.667v-1.833h-1.25v1.833zm0 2.75v-.917h-1.25V23a.625.625 0 1 0 1.25 0M7.415 4.375a.83.83 0 0 0-.752.485L1.448 16.397a.8.8 0 0 0-.073.34V18.3c0 .456.37.825.825.825h6.6c.456 0 .825-.37.825-.825V5.2a.825.825 0 0 0-.825-.825zm-4.79 12.453L7.689 5.625h.686v12.25h-5.75zm13-6.228V5.625h.72l5.03 11.26v.99h-5.75zM15.2 4.375a.825.825 0 0 0-.825.825v13.1c0 .456.37.825.825.825h6.6c.456 0 .825-.37.825-.825v-1.506a.8.8 0 0 0-.072-.336l-5.18-11.595a.83.83 0 0 0-.753-.488z",
        clipRule: "evenodd"
      }
    )
  }
), o3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.5 7.134 2.714-1.567.5.866L9 7.999l2.714 1.568-.5.866L8.5 8.865V12h-1V8.866l-2.714 1.568-.5-.867L7 8 4.286 6.434l.5-.867L7.5 7.134V4h1z" })
  }
), n3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#F2D30A",
          d: "M9.875 6.313h4.25c.266 0 .531.265.531.53a.546.546 0 0 1-.531.532h-4.25a.524.524 0 0 1-.531-.531c0-.266.232-.532.531-.532Zm2.79 3.984v.465c.232.033.464.1.696.166.332.1.565.465.465.797-.1.365-.465.564-.83.498-.365-.1-.697-.2-1.03-.2-.265 0-.53.067-.696.167s-.233.199-.233.332c0 .033.033.1.2.199.198.133.497.232.929.365h.033c.366.1.83.266 1.229.498.431.266.797.697.797 1.395.033.697-.332 1.195-.797 1.494a4 4 0 0 1-.797.299v.431a.666.666 0 0 1-.664.664.666.666 0 0 1-.664-.664v-.465c-.332-.1-.631-.199-.93-.299-.066-.033-.133-.033-.2-.066a.64.64 0 0 1-.398-.83c.1-.365.465-.531.83-.432.067.034.166.067.233.1.465.133.797.266 1.162.266.299 0 .565-.034.73-.167.133-.066.2-.165.166-.332 0-.1 0-.165-.166-.265-.232-.133-.53-.232-.93-.365h-.066c-.365-.133-.83-.266-1.195-.465-.398-.266-.797-.697-.797-1.361-.033-.698.365-1.196.83-1.462.233-.132.498-.232.764-.298v-.465c0-.365.299-.664.664-.664s.664.299.664.664Z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M9.875 6.313 8.281 3.954c-.232-.332.033-.83.432-.83h6.54c.4 0 .665.498.432.83l-1.56 2.357h-4.25Zm4.25 1.062c.1.1.266.2.432.299 1.859 1.195 5.943 3.785 5.943 9.264a3.19 3.19 0 0 1-3.188 3.187H6.688A3.19 3.19 0 0 1 3.5 16.937c0-5.478 4.05-8.068 5.943-9.263.133-.1.3-.2.432-.299zM12 9.633a.666.666 0 0 0-.664.664v.498a2.1 2.1 0 0 0-.764.265c-.465.266-.863.764-.83 1.461 0 .664.399 1.096.797 1.362.365.199.83.332 1.195.465h.067c.398.132.697.232.93.365.165.1.165.166.165.266.034.166-.033.265-.166.365-.165.1-.431.166-.73.133-.365 0-.697-.133-1.162-.266-.066-.033-.166-.066-.232-.1-.366-.1-.731.1-.83.432a.63.63 0 0 0 .398.83.5.5 0 0 0 .199.066c.266.1.598.233.93.3v.464c0 .365.299.664.664.664a.666.666 0 0 0 .664-.664v-.431q.398-.1.797-.3c.465-.298.83-.796.797-1.494 0-.663-.366-1.128-.797-1.394-.399-.232-.864-.365-1.229-.498h-.033c-.432-.133-.73-.232-.93-.332-.166-.133-.199-.166-.199-.232 0-.133.066-.233.232-.3.166-.132.432-.199.698-.165.332 0 .664.066 1.03.166a.69.69 0 0 0 .83-.465.69.69 0 0 0-.466-.83c-.232-.067-.465-.1-.697-.166v-.465A.666.666 0 0 0 12 9.633"
        }
      )
    ]
  }
), v3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.875 8c0 .422-.234.773-.563.984a1.08 1.08 0 0 1-1.124 0 1.122 1.122 0 0 1 0-1.945c.328-.21.773-.21 1.124 0 .329.211.563.563.563.961m-3.75 0c0 .422-.234.773-.563.984a1.08 1.08 0 0 1-1.124 0 1.122 1.122 0 0 1 0-1.945c.328-.21.773-.21 1.125 0 .328.211.562.563.562.961M4.25 9.125c-.422 0-.773-.21-.984-.563a1.08 1.08 0 0 1 0-1.124c.21-.329.562-.563.984-.563.398 0 .75.234.96.563.212.351.212.796 0 1.125-.21.351-.562.562-.96.562" })
  }
), w3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.5 12c0 .563-.313 1.031-.75 1.313-.469.28-1.063.28-1.5 0A1.5 1.5 0 0 1 15.5 12c0-.531.281-1 .75-1.281.438-.281 1.031-.281 1.5 0 .438.281.75.75.75 1.281m-5 0c0 .563-.313 1.031-.75 1.313-.469.28-1.063.28-1.5 0A1.5 1.5 0 0 1 10.5 12c0-.531.281-1 .75-1.281.438-.281 1.031-.281 1.5 0 .438.281.75.75.75 1.281M7 13.5a1.5 1.5 0 0 1-1.313-.75c-.28-.438-.28-1.031 0-1.5.282-.438.75-.75 1.313-.75.531 0 1 .313 1.281.75.281.469.281 1.063 0 1.5-.281.469-.75.75-1.281.75" })
  }
), x3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.016 18.5c2.312 0 4.437-1.219 5.625-3.25a6.52 6.52 0 0 0 0-6.5c-1.188-2-3.313-3.25-5.625-3.25-2.344 0-4.47 1.25-5.657 3.25a6.52 6.52 0 0 0 0 6.5 6.51 6.51 0 0 0 5.657 3.25m0-14.5c2.843 0 5.468 1.531 6.906 4 1.437 2.5 1.437 5.531 0 8a7.94 7.94 0 0 1-6.906 4c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8a8.02 8.02 0 0 1 6.938-4m1 8c0 .563-.47 1-1 1-.563 0-1-.438-1-1 0-.531.437-1 1-1 .53 0 1 .469 1 1m2-1c.53 0 1 .469 1 1 0 .563-.47 1-1 1-.563 0-1-.438-1-1 0-.531.437-1 1-1m-5 1c0 .563-.47 1-1 1-.563 0-1-.438-1-1 0-.531.437-1 1-1 .53 0 1 .469 1 1" })
  }
), d3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m-3-9c-.563 0-1 .469-1 1 0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1m2 1c0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1-.563 0-1 .469-1 1m4-1c-.563 0-1 .469-1 1 0 .563.438 1 1 1 .531 0 1-.438 1-1 0-.531-.469-1-1-1"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M8 12c0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1m3 0c0-.531.438-1 1-1 .531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1m4-1c.531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1"
        }
      )
    ]
  }
), g3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 15.5c.531 0 1 .313 1.281.75.281.469.281 1.063 0 1.5-.281.469-.75.75-1.281.75a1.5 1.5 0 0 1-1.313-.75c-.28-.438-.28-1.031 0-1.5.282-.438.75-.75 1.313-.75m0-5c.531 0 1 .313 1.281.75.281.469.281 1.063 0 1.5-.281.469-.75.75-1.281.75a1.5 1.5 0 0 1-1.313-.75c-.28-.438-.28-1.031 0-1.5.282-.438.75-.75 1.313-.75M13.5 7c0 .563-.313 1.031-.75 1.313-.469.28-1.063.28-1.5 0A1.5 1.5 0 0 1 10.5 7c0-.531.281-1 .75-1.281.438-.282 1.031-.282 1.5 0 .438.281.75.75.75 1.281" })
  }
), m3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.398 2.164 1.665 1.688c.234.234.234.586 0 .796a.513.513 0 0 1-.774 0l-.726-.726v3.515h3.515l-.726-.726c-.235-.211-.235-.563 0-.797.21-.21.562-.21.796 0l1.688 1.688c.21.234.21.585 0 .796l-1.688 1.688c-.234.234-.585.234-.796 0-.235-.211-.235-.563 0-.797l.726-.726H8.563v3.539l.726-.727c.211-.234.563-.234.797 0a.55.55 0 0 1 0 .773l-1.688 1.688c-.234.234-.585.234-.796 0l-1.688-1.688a.513.513 0 0 1 0-.773c.211-.234.563-.234.797 0l.726.727v-3.54H3.898l.727.727c.234.234.234.586 0 .797a.513.513 0 0 1-.773 0L2.164 8.398c-.234-.21-.234-.562 0-.796l1.688-1.665a.513.513 0 0 1 .773 0 .513.513 0 0 1 0 .774l-.727.726h3.516V3.922l-.726.726a.513.513 0 0 1-.774 0c-.234-.21-.234-.562 0-.796l1.688-1.688c.21-.21.562-.21.796 0" })
  }
), p3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m12.531 4.219 2.219 2.25c.313.312.313.781 0 1.062a.684.684 0 0 1-1.031 0l-.969-.968v4.687h4.688l-.97-.969c-.312-.281-.312-.75 0-1.062.282-.281.75-.281 1.063 0l2.25 2.25c.282.312.282.781 0 1.062l-2.25 2.25c-.312.313-.781.313-1.062 0-.313-.281-.313-.75 0-1.062l.968-.969H12.75v4.719l.969-.969c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031l-2.25 2.25c-.312.313-.781.313-1.062 0l-2.25-2.25a.684.684 0 0 1 0-1.031c.281-.313.75-.313 1.062 0l.969.969V12.75H6.531l.969.969c.313.312.313.781 0 1.062a.684.684 0 0 1-1.031 0l-2.25-2.25c-.313-.281-.313-.75 0-1.062l2.25-2.219a.684.684 0 0 1 1.031 0 .684.684 0 0 1 0 1.031l-.969.969h4.688V6.562l-.969.97a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063l2.25-2.25c.281-.282.75-.282 1.062 0" })
  }
), u3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m3.188 4.188 4.968 3.875 3.156-2.782a1.01 1.01 0 0 1 1.094-.187c.344.156.594.531.594.906v5.844l1.813 1.437c.03-.03.093-.062.124-.093.344-.282.563-.72.563-1.188a1.48 1.48 0 0 0-.563-1.156.776.776 0 0 1-.124-1.063.78.78 0 0 1 1.062-.093C16.563 10.25 17 11.063 17 12c0 .875-.375 1.688-.969 2.219l1.188.937A4.52 4.52 0 0 0 18.5 12a4.4 4.4 0 0 0-1.688-3.469c-.312-.28-.375-.75-.093-1.062a.776.776 0 0 1 1.062-.125C19.125 8.469 20 10.125 20 12c0 1.594-.625 3-1.594 4.094l3.282 2.594c.343.25.406.718.125 1.03-.25.345-.72.407-1.032.126l-18.5-14.5c-.344-.25-.406-.719-.125-1.031.25-.344.719-.407 1.031-.125ZM13 15.688V18c0 .406-.25.781-.594.938a1.01 1.01 0 0 1-1.094-.188L7.095 15H5c-1.125 0-2-.875-2-2v-2c0-.937.656-1.75 1.563-1.937z" })
  }
), f3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.25 5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-.5c-.719 0-1.25.563-1.25 1.25v.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-.5C3 6.25 4.219 5 5.75 5zM3 13.25v-2.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v2.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75M3.75 15a.76.76 0 0 1 .75.75v.5c0 .719.531 1.25 1.25 1.25h.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-.5A2.734 2.734 0 0 1 3 16.25v-.5a.74.74 0 0 1 .75-.75m12.5-5a.72.72 0 0 1-.75-.75v-1.5c0-.688-.563-1.25-1.25-1.25h-.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h.5C15.75 5 17 6.25 17 7.75v1.5a.74.74 0 0 1-.75.75M11 18.25a.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75m.25-11.75h-2.5A.72.72 0 0 1 8 5.75.74.74 0 0 1 8.75 5h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75M16.5 20a4.47 4.47 0 0 1-3.906-2.25 4.46 4.46 0 0 1 0-4.5A4.54 4.54 0 0 1 16.5 11c1.594 0 3.063.875 3.875 2.25a4.46 4.46 0 0 1 0 4.5A4.46 4.46 0 0 1 16.5 20m.5-6.5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5V15h-1.5c-.281 0-.5.25-.5.5 0 .281.219.5.5.5H16v1.5c0 .281.219.5.5.5.25 0 .5-.219.5-.5V16h1.5c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5H17z" })
  }
), j3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16.5 21a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-.5-6.5a.5.5 0 0 1 1 0V16h1.5a.5.5 0 0 1 0 1H17v1.5a.5.5 0 0 1-1 0V17h-1.5a.5.5 0 0 1 0-1H16z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M5 6.5h6c.25 0 .5.25.5.5v3c0 .281-.25.5-.5.5H5a.494.494 0 0 1-.5-.5V7c0-.25.219-.5.5-.5M11 5H5c-1.125 0-2 .906-2 2v3c0 1.125.875 2 2 2h6c1.094 0 2-.875 2-2V7c0-1.094-.906-2-2-2m6 1.5h2c.25 0 .5.25.5.5v4.89a5.5 5.5 0 0 1 1.5 1.447V7c0-1.094-.906-2-2-2h-2c-1.125 0-2 .906-2 2v4.207A5.5 5.5 0 0 1 16.5 11V7c0-.25.219-.5.5-.5m-5.133 7.034a2 2 0 0 0-.367-.034H7c-1.125 0-2 .906-2 2V17c0 1.125.875 2 2 2h4.5q.05 0 .098-.002a5.5 5.5 0 0 1-.507-1.498H7a.494.494 0 0 1-.5-.5v-1.5c0-.25.219-.5.5-.5h4.207a5.5 5.5 0 0 1 .66-1.466",
          clipRule: "evenodd"
        }
      )
    ]
  }
), M3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M16.797 6.142a.75.75 0 0 1 1.06-.012A5.4 5.4 0 0 1 19.485 10l-.007.283a5.4 5.4 0 0 1-1.62 3.586.75.75 0 1 1-1.048-1.072A3.9 3.9 0 0 0 17.984 10v-.001l-.004-.195a3.9 3.9 0 0 0-1.171-2.601.75.75 0 0 1-.012-1.06Z" }),
      /* @__PURE__ */ l.jsxs(
        "mask",
        {
          id: "a",
          width: 13,
          height: 16,
          x: 3,
          y: 4,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: [
            /* @__PURE__ */ l.jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M10.333 13.333h.479l3.487 2.302a.667.667 0 0 0 1.034-.557v-9.84a.667.667 0 0 0-1.033-.556l-3.009 1.985H7.333a3.333 3.333 0 0 0-1.282 6.41l1.312 4.809a1.512 1.512 0 0 0 2.97-.398z",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ l.jsx("path", { d: "M14.624 4.273a.967.967 0 0 1 1.01.966v9.839a.967.967 0 0 1-1.387.87l-.113-.064-3.412-2.25h-.089v3.854a1.813 1.813 0 0 1-2.813 1.51 1.8 1.8 0 0 1-.697-.877l-.05-.156-1.275-4.674a3.63 3.63 0 0 1-2.03-4.003 3.635 3.635 0 0 1 3.565-2.921h3.868l2.934-1.936.113-.064a1 1 0 0 1 .376-.094m.013.3a.67.67 0 0 0-.337.11l-3.009 1.983H7.333a3.334 3.334 0 0 0-1.282 6.412l1.312 4.808a1.513 1.513 0 0 0 2.97-.398v-4.155h.479l3.487 2.301a.669.669 0 0 0 1.034-.556V5.239a.67.67 0 0 0-.696-.666" })
          ]
        }
      ),
      /* @__PURE__ */ l.jsx("g", { mask: "url(#a)", children: /* @__PURE__ */ l.jsx("path", { d: "m10.812 13.333.624-.946-.284-.186h-.34zm-.479 0V12.2H9.2v1.133zm.958-6.666V7.8h.34l.284-.187zm-5.24 6.41 1.094-.297-.147-.535-.51-.213zm4.761-.876-.479-.001v2.267h.479V12.2Zm4.111 2.488-3.487-2.302-1.25 1.893 3.49 2.301zm-.724.389a.467.467 0 0 1 .724-.39l-1.248 1.893c1.197.79 2.791-.07 2.791-1.502zm0-9.84v9.84h2.267v-9.84zm.724.39a.467.467 0 0 1-.724-.39h2.267c0-1.433-1.594-2.291-2.79-1.502zm-3.008 1.985 3.008-1.985-1.248-1.892-3.008 1.985zM7.333 7.8h3.958l.001-2.267H7.333zm-2.2 2.2a2.2 2.2 0 0 1 2.2-2.2V5.533c-2.466 0-4.466 2-4.466 4.467zm1.354 2.032A2.2 2.2 0 0 1 5.133 10H2.867a4.47 4.47 0 0 0 2.748 4.124zm1.968 5.556-1.31-4.808-2.186.597 1.31 4.807zm.366.279a.38.38 0 0 1-.366-.28l-2.186.597a2.645 2.645 0 0 0 2.552 1.95zm.379-.38a.38.38 0 0 1-.379.38v2.266a2.645 2.645 0 0 0 2.646-2.645H9.2Zm0-4.154v4.155h2.267v-4.155z" }) })
    ]
  }
), C3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15.969 18c.531 0 .969-.469.969-1V7.031c0-.562-.47-1-1-1a.954.954 0 0 0-.97.969v10c0 .563.47 1 1 1Zm-7.344-.219 6-4.968c.25-.188.344-.5.344-.782 0-.281-.094-.562-.344-.75l-6-4.969C7.969 5.72 7 6.157 7 7.032V17a.99.99 0 0 0 1.625.781" })
  }
), A3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M14.813 8.219a1.55 1.55 0 0 1-1.75-.406C12.374 7.03 11.374 6.5 10.25 6.5a3.74 3.74 0 0 0-3.75 3.75v.031c0 .625-.406 1.188-1 1.406a2.97 2.97 0 0 0-2 2.813 3 3 0 0 0 3 3h11.406c1.438-.063 2.594-1.281 2.594-2.75a2.71 2.71 0 0 0-1.656-2.5c-.625-.281-1-.938-.875-1.625 0-.125.031-.25.031-.375C18 9.031 16.969 8 15.75 8c-.344 0-.656.094-.938.219ZM18 19H6.5C4 19 2 17 2 14.5c0-1.938 1.25-3.625 3-4.219v-.031C5 7.375 7.344 5 10.25 5c1.563 0 3 .719 3.969 1.844A3.55 3.55 0 0 1 15.75 6.5a3.76 3.76 0 0 1 3.75 3.75c0 .219-.031.406-.063.625 1.5.656 2.563 2.156 2.563 3.875A4.25 4.25 0 0 1 18 19" })
  }
), V3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fill: "#000",
        fillOpacity: 0.25,
        d: "M2.146 10.836a.55.55 0 0 1 0-.774c.235-.234.586-.234.797 0l1.29 1.29v-8.04a.57.57 0 0 1 .562-.562c.328 0 .562.258.562.563v8.039l1.29-1.29c.234-.234.585-.234.796 0a.513.513 0 0 1 0 .774l-2.25 2.25c-.21.234-.562.234-.797 0zm8.25-7.922c.235-.21.586-.21.797 0l2.25 2.25c.235.234.235.586 0 .797a.513.513 0 0 1-.773 0l-1.29-1.29v8.017a.555.555 0 0 1-.562.562.54.54 0 0 1-.562-.563V4.672L8.966 5.96c-.234.234-.585.234-.796 0-.234-.211-.234-.563 0-.797z"
      }
    )
  }
), z3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.469 15.781c-.313-.281-.313-.75 0-1.062.281-.281.75-.281 1.062 0l1.719 1.75V5.75A.74.74 0 0 1 8 5a.76.76 0 0 1 .75.75v10.719l1.719-1.719a.684.684 0 0 1 1.031 0 .684.684 0 0 1 0 1.031l-3 3a.684.684 0 0 1-1.031 0zM14 13h4c.281 0 .563.188.656.469a.67.67 0 0 1-.125.781l-2.875 3.25H18a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-4c-.313 0-.594-.156-.688-.438a.67.67 0 0 1 .126-.78l2.874-3.282H14a.72.72 0 0 1-.75-.75A.74.74 0 0 1 14 13m2-8c.281 0 .531.188.656.438l2.5 5a.74.74 0 0 1-.343 1 .74.74 0 0 1-1-.344l-.438-.844h-2.813l-.406.844a.74.74 0 0 1-1 .344.74.74 0 0 1-.344-1l2.5-5A.77.77 0 0 1 16 5m-.688 3.75h1.344L16 7.437z" })
  }
), H3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.469 15.781c-.313-.281-.313-.75 0-1.062.281-.281.75-.281 1.062 0l1.719 1.75V5.75A.74.74 0 0 1 8 5a.76.76 0 0 1 .75.75v10.719l1.719-1.719a.684.684 0 0 1 1.031 0 .684.684 0 0 1 0 1.031l-3 3a.684.684 0 0 1-1.031 0zM14 5h4c.281 0 .563.188.656.469a.67.67 0 0 1-.125.781L15.656 9.5H18a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-4c-.313 0-.594-.156-.688-.438a.67.67 0 0 1 .126-.78L16.311 6.5H14a.72.72 0 0 1-.75-.75A.74.74 0 0 1 14 5m2 7.5h-.031c.312 0 .562.188.687.438l2.5 5a.74.74 0 0 1-.343 1 .74.74 0 0 1-1-.344l-.438-.844h-2.813l-.406.844a.74.74 0 0 1-1 .343.74.74 0 0 1-.344-1l2.5-5A.77.77 0 0 1 16 12.5m-.688 3.75h1.344L16 14.937z" })
  }
), B3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M7.46 10.836a.55.55 0 0 0 0-.774c-.233-.234-.585-.234-.796 0l-1.289 1.29v-8.04a.57.57 0 0 0-.563-.562.555.555 0 0 0-.562.563v8.039l-1.29-1.29c-.233-.234-.585-.234-.796 0a.513.513 0 0 0 0 .774l2.25 2.25c.211.234.563.234.797 0z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M11.217 2.92c-.235-.211-.586-.211-.797 0L8.17 5.17c-.234.234-.234.586 0 .797.21.234.562.234.773 0l1.29-1.29v8.016c0 .329.257.563.562.563a.54.54 0 0 0 .562-.563V4.678l1.29 1.289c.234.234.585.234.796 0 .235-.211.235-.563 0-.797z"
        }
      )
    ]
  }
), L3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m19.531 15.781-3 3c-.312.313-.781.313-1.062 0l-3-3a.684.684 0 0 1 0-1.031c.281-.313.75-.313 1.062 0l1.719 1.719V5.75A.74.74 0 0 1 16 5a.76.76 0 0 1 .75.75v10.719l1.719-1.719c.281-.313.75-.313 1.062 0a.736.736 0 0 1 0 1.031m-11-10.562 2.969 3c.313.312.313.781 0 1.062-.281.313-.75.313-1.063 0L8.72 7.562V18.25c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75V7.562L5.5 9.283a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063l3-3c.281-.282.75-.282 1.062 0Z" })
  }
), X3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M7.46 10.836a.55.55 0 0 0 0-.774c-.233-.234-.585-.234-.796 0l-1.289 1.29v-8.04a.57.57 0 0 0-.563-.562.555.555 0 0 0-.562.563v8.039l-1.29-1.29c-.233-.234-.585-.234-.796 0a.513.513 0 0 0 0 .774l2.25 2.25c.211.234.563.234.797 0z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M11.217 2.92c-.235-.211-.586-.211-.797 0L8.17 5.17c-.234.234-.234.586 0 .797.21.234.562.234.773 0l1.29-1.29v8.016c0 .329.257.563.562.563a.54.54 0 0 0 .562-.563V4.678l1.29 1.289c.234.234.585.234.796 0 .235-.211.235-.563 0-.797z"
        }
      )
    ]
  }
), R3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.885 12.056a.5.5 0 0 1 .5-.5h1.274a.5.5 0 0 1 .5.5v.786c.382.139.731.345 1.034.605l.687-.394a.5.5 0 0 1 .682.186l.633 1.105a.5.5 0 0 1-.185.683l-.7.4a3.4 3.4 0 0 1-.01 1.154l.706.408a.5.5 0 0 1 .183.683l-.638 1.103a.5.5 0 0 1-.683.183l-.719-.415a3.3 3.3 0 0 1-.99.567v.834a.5.5 0 0 1-.5.5h-1.274a.5.5 0 0 1-.5-.5v-.834a3.3 3.3 0 0 1-1-.576l-.72.413a.5.5 0 0 1-.683-.186l-.633-1.105a.5.5 0 0 1 .185-.682l.708-.405a3.4 3.4 0 0 1-.006-1.155l-.698-.403a.5.5 0 0 1-.182-.683l.637-1.103a.5.5 0 0 1 .683-.183l.685.396a3.3 3.3 0 0 1 1.024-.596zm1.137 5.309a1.389 1.389 0 1 0 0-2.778 1.389 1.389 0 0 0 0 2.778",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M6 4c-1.125 0-2 .906-2 2v12c0 1.125.875 2 2 2h6.386a2 2 0 0 1-.877-.812l-.393-.688H6a.494.494 0 0 1-.5-.5V6c0-.25.219-.5.5-.5h5V8c0 .563.438 1 1 1h2.5v1.767c.294-.17.635-.267.999-.267H16V8.844c0-.531-.219-1.031-.594-1.406l-2.844-2.844A2 2 0 0 0 11.156 4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), y3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.5 6h1c.813 0 1.5.688 1.5 1.5v9A1.5 1.5 0 0 1 9.5 18h-1A1.48 1.48 0 0 1 7 16.5v-9A1.5 1.5 0 0 1 8.5 6m6 0h1c.813 0 1.5.688 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-1a1.48 1.48 0 0 1-1.5-1.5v-9A1.5 1.5 0 0 1 14.5 6" })
  }
), Z3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M19 5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM7.769 15.234a.75.75 0 1 0 1.363.624zm4.788-7.848a.75.75 0 0 0-1.372.59l.027.07 1.634 3.8h-1.402c-.538 0-.993-.01-1.405.137a2.4 2.4 0 0 0-.799.48l-.095.095c-.229.235-.388.528-.547.867l-.163.353-.666 1.456.681.312.682.312.667-1.455.169-.363c.137-.288.19-.374.25-.436l.073-.066a.9.9 0 0 1 .252-.142c.11-.038.25-.05.901-.05h2.046l1.073 2.497a.75.75 0 0 0 1.378-.592l-1.256-2.923-.008-.018-2.086-4.855-.034-.07Z" })
  }
), E3 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M5 5h14c1.094 0 2 .906 2 2v1H3V7c0-1.094.875-2 2-2m16 6v6c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2v-6zM6.5 15c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm3.5.5c0 .281.219.5.5.5h4c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5h-4c-.281 0-.5.25-.5.5"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { fill: "#398AE7", d: "M21 11H3V8h18z" })
    ]
  }
), b3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 5h14c1.094 0 2 .906 2 2v1H3V7c0-1.094.875-2 2-2m16 6v6c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2v-6zM6.5 15c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm3.5.5c0 .281.219.5.5.5h4c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5h-4c-.281 0-.5.25-.5.5" })
  }
), F3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M19 6.5H5c-.281 0-.5.25-.5.5v1h15V7c0-.25-.25-.5-.5-.5m-7 9q0-.513.09-1h-1.34a.74.74 0 0 0-.75.75c0 .438.313.75.75.75h1.272a6 6 0 0 1-.022-.5M4.5 11h9.837c.895-.63 1.986-1 3.163-1 1.33 0 2.55.472 3.5 1.257V7c0-1.094-.906-2-2-2H5c-1.125 0-2 .906-2 2v10c0 1.125.875 2 2 2h8.257a5.5 5.5 0 0 1-.882-1.5H5a.494.494 0 0 1-.5-.5zm2.25 3.5h1.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75m15.25 1a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.403-1.355a.5.5 0 0 1 .003.707l-2.254 2.273a.5.5 0 0 1-.709.001l-1.26-1.26a.5.5 0 0 1 .707-.707l.905.905 1.9-1.916a.5.5 0 0 1 .708-.003",
        clipRule: "evenodd"
      }
    )
  }
), k3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.469 6.5c3.031 0 5.5 2.469 5.5 5.5s-2.469 5.5-5.5 5.5a5.51 5.51 0 0 1-5.5-5.5c0-3.031 2.468-5.5 5.5-5.5m-1.25 8.75v-6.5A3.52 3.52 0 0 0 7 12c0 1.5.938 2.75 2.219 3.25m2.5 0a3.47 3.47 0 0 0 2.25-3.25 3.5 3.5 0 0 0-2.25-3.25zM19.5 5c.813 0 1.5.688 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.48 1.48 0 0 1 3 17.5v-11A1.5 1.5 0 0 1 4.5 5zm-6.219 13c3.281 0 6.281-2.656 6.281-5.938 0-3.562-3-6.062-6.28-6.062h-2.813c-3.313 0-6.063 2.5-6.063 6.063 0 3.28 2.75 5.937 6.063 5.937z" })
  }
), D3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M19.25 10.156c0 .25-.188.375-.5.375h-.156V9.75h.156c.313 0 .5.156.5.406M19.5 5c.813 0 1.5.688 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.48 1.48 0 0 1 3 17.5v-11A1.5 1.5 0 0 1 4.5 5zm-1.406 4.344v2.562h.5v-1h.093l.688 1h.594l-.782-1.062c.375-.094.563-.344.563-.719 0-.906-.938-.781-1.656-.781m-1.719 0v2.562h1.406V11.5h-.906v-.719h.875v-.406h-.875v-.594h.906v-.437zm-2.156 0h-.563L14.75 12h.281l1.094-2.656h-.531l-.688 1.75zm-1.75-.094a1.4 1.4 0 0 0-1.406 1.406 1.4 1.4 0 0 0 1.406 1.406 1.4 1.4 0 0 0 1.406-1.406 1.4 1.4 0 0 0-1.406-1.406m-1.531.219c-.97-.469-2 .187-2 1.187s1.062 1.625 2 1.188v-.594c-.626.594-1.47.188-1.47-.594 0-.75.845-1.25 1.47-.594V9.47ZM7.874 11.53c-.219 0-.406-.125-.531-.344l-.313.313c.532.813 1.75.563 1.75-.344 0-.406-.156-.594-.719-.812-.312-.094-.406-.188-.406-.313 0-.281.469-.437.782-.094l.28-.343c-.593-.531-1.562-.25-1.562.469 0 .343.157.53.625.687.813.313.469.781.094.781m-3.156.375c.968 0 1.375-.687 1.375-1.25 0-.781-.563-1.312-1.375-1.312H4v2.562h.719Zm2.093 0V9.344h-.5v2.562zM20 17.531V13c-1.063.656-7.094 3.906-13 5h12.531a.46.46 0 0 0 .469-.469M5.312 10a.97.97 0 0 1 .282.656c0 .219-.125.469-.282.625s-.375.219-.687.219H4.5V9.781h.125c.313 0 .5.063.688.219Z" })
  }
), S3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16.469 11.656v-1.031c1.281 0 1.218.031 1.218.031.22.031.407.219.407.5 0 .25-.188.438-.407.469-.062.031-.125.031-1.218.031m1.343.625c-.093-.031-.093-.031-1.343-.031v1.094c1.25 0 1.25.031 1.343 0a.54.54 0 0 0 .407-.531c0-.282-.188-.5-.407-.532M21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.48 1.48 0 0 1 3 17.5v-11A1.5 1.5 0 0 1 4.5 5h15c.813 0 1.5.688 1.5 1.5M8.687 10.031h-1.78c0 2.094.312 3.406-1.126 3.406A3.95 3.95 0 0 1 4 13v.875c.938.25 2.125.25 2.125.25 3.031 0 2.563-1.5 2.563-4.094Zm5.563.125c-1.969-.5-5.156-.469-5.156 1.875 0 2.406 3.375 2.281 5.156 1.844v-.906c-1.5.781-3.344.687-3.344-.969s1.844-1.719 3.344-.969zM20 12.97c0-.594-.531-.969-1.188-1v-.031c.594-.094.938-.47.938-.938 0-.594-.5-.938-1.156-.969h-3.75V14h3.812c.782 0 1.344-.406 1.344-1.031Z" })
  }
), P3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.063 16.844c0 .218-.125.343-.344.343s-.344-.156-.344-.343c0-.219.125-.375.344-.375s.343.156.343.375Zm-9.688-.375a.36.36 0 0 0-.375.375c0 .187.156.343.375.343.188 0 .344-.125.344-.343-.031-.219-.156-.375-.344-.375m3.656 0c-.156 0-.281.093-.281.25h.594a.304.304 0 0 0-.313-.25m3.375 0c-.219 0-.344.156-.344.375 0 .187.126.343.344.343.219 0 .344-.125.344-.343s-.125-.375-.344-.375m3.313.812v.062c0 .032 0 .032-.032.032 0 0 0 .031-.03.031h-.063s0-.031-.032-.031v-.031c-.03 0-.03 0-.03-.032 0 0 0-.03.03-.03v-.032h.032l.031-.031c.031 0 .031 0 .031.031h.032c.03 0 .03.031.03.031Zm-.063.063v-.032c.032 0 .032 0 .032-.03h-.032s0-.032-.031-.032h-.031v.125h.031v-.063l.031.063h.032zM21 6.53v11a1.5 1.5 0 0 1-1.5 1.5h-15a1.48 1.48 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h15c.813 0 1.5.688 1.5 1.5M5 10.906c0 2.406 1.938 4.344 4.313 4.344.843 0 1.687-.281 2.406-.75-2.281-1.844-2.281-5.344 0-7.188a4.43 4.43 0 0 0-2.406-.718A4.32 4.32 0 0 0 5 10.906m7 3.406c2.188-1.718 2.188-5.062 0-6.812-2.219 1.75-2.219 5.094 0 6.813Zm-4.469 2.376c0-.282-.156-.438-.437-.47a.46.46 0 0 0-.407.22c-.093-.125-.218-.22-.375-.22a.43.43 0 0 0-.343.188v-.156h-.25v1.156h.25c0-.593-.094-.937.281-.937.313 0 .25.312.25.937h.25c0-.562-.063-.937.281-.937.313 0 .25.312.25.937h.25zm1.407-.438h-.25v.156a.42.42 0 0 0-.344-.187c-.344 0-.594.281-.594.625s.25.593.594.593c.156 0 .281-.062.344-.156v.125h.25zm1.28.813c0-.47-.718-.25-.718-.47 0-.187.375-.155.563-.03l.124-.22c-.312-.187-.968-.187-.968.25 0 .47.719.282.719.47 0 .218-.407.187-.626.03l-.124.22c.343.218 1.03.187 1.03-.25m1.095.28-.063-.187c-.125.063-.375.125-.375-.156v-.5h.406v-.25h-.406v-.344h-.281v.344h-.219v.25h.219v.5c0 .563.562.469.719.344Zm.406-.405h.875c0-.5-.25-.72-.563-.72s-.562.25-.562.626c0 .625.719.75 1.062.437l-.125-.187c-.25.187-.594.187-.687-.157Zm1.844-.688c-.126-.063-.344-.031-.47.156v-.156h-.25v1.156h.25v-.656c0-.344.313-.313.407-.25zm.343.594c0-.375.375-.469.656-.282l.126-.187c-.376-.281-1.032-.125-1.032.469 0 .625.688.75 1.031.468l-.124-.218c-.282.218-.657.093-.657-.25M16 16.25h-.25v.156c-.281-.343-.938-.156-.938.438 0 .593.688.75.938.437v.125H16zm1.031 0c-.062-.031-.343-.063-.468.156v-.156h-.25v1.156h.25v-.656c0-.344.28-.313.406-.25zm1.282-.438h-.25v.594c-.25-.343-.938-.156-.938.438 0 .593.688.75.938.437v.125h.25zm.218-2.374v.156h.032v-.156h.062-.156zm.219 3.874v-.03l-.031-.032c0-.031-.032-.031-.032-.031-.03 0-.03-.032-.062-.032l-.031.032c-.032 0-.032 0-.032.031-.03 0-.03 0-.03.031v.094l.03.031.032.032h.094c0-.032.03-.032.03-.032 0-.031 0-.031.032-.031zm.094-3.875h-.032l-.062.094-.031-.094h-.063v.157h.032v-.125l.062.094h.031l.032-.094v.125h.03zm.156-2.53c0-2.376-1.969-4.313-4.344-4.313-.844 0-1.687.25-2.375.718 2.25 1.844 2.281 5.344 0 7.188a4.25 4.25 0 0 0 2.375.719C17.031 15.25 19 13.313 19 10.906Z" })
  }
), T3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M19 6.5H5c-.281 0-.5.25-.5.5v1h15V7c0-.25-.25-.5-.5-.5M13.179 16a1.44 1.44 0 0 1-.675-1.5H10.75a.74.74 0 0 0-.75.75c0 .438.313.75.75.75zM4.5 11h11.373c.175-.278.454-.517.868-.6.424-.119.855-.15 1.259-.15.38 0 .807.032 1.229.15.75.154 1.146.853 1.146 1.444v.02a1.4 1.4 0 0 1 .625-.19V7c0-1.094-.906-2-2-2H5c-1.125 0-2 .906-2 2v10c0 1.125.875 2 2 2h8.166l-.086-.142c-.21-.35-.416-.75-.543-1.215a2 2 0 0 1-.033-.143H5a.494.494 0 0 1-.5-.5zm2.25 3.5h1.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-1.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75m9.875-2.656c0-.219.125-.438.344-.469.312-.094.656-.125 1.031-.125.344 0 .688.031 1 .125.219.031.375.25.375.469v.531c0 .25.125.469.344.594s.468.156.687.031l.438-.25a.43.43 0 0 1 .562.063c.25.25.469.53.625.843.188.313.344.656.438.969a.505.505 0 0 1-.219.563l-.469.25a.7.7 0 0 0-.312.562c0 .25.125.469.312.594l.469.25a.45.45 0 0 1 .219.531c-.094.344-.25.656-.438.969a3.3 3.3 0 0 1-.625.843.48.48 0 0 1-.562.094l-.438-.25c-.218-.125-.468-.093-.687 0a.67.67 0 0 0-.344.594v.563a.5.5 0 0 1-.375.468 5 5 0 0 1-1 .094 5.3 5.3 0 0 1-1.031-.094.47.47 0 0 1-.344-.468v-.563c0-.25-.156-.469-.375-.594a.68.68 0 0 0-.688 0l-.437.25a.48.48 0 0 1-.563-.093c-.25-.25-.437-.532-.624-.844a3.9 3.9 0 0 1-.438-.969.45.45 0 0 1 .219-.531l.437-.25A.67.67 0 0 0 14.5 16a.71.71 0 0 0-.344-.594l-.437-.25a.45.45 0 0 1-.219-.531l.053-.134c.109-.275.223-.566.384-.835.188-.312.376-.594.626-.844a.43.43 0 0 1 .562-.062l.438.219a.68.68 0 0 0 .687 0c.219-.125.375-.344.375-.594zM19.5 16c0-.531-.281-1.063-.75-1.344a1.5 1.5 0 0 0-1.531 0A1.49 1.49 0 0 0 16.5 16c-.031.563.25 1.094.719 1.375a1.5 1.5 0 0 0 1.531 0c.469-.281.75-.813.75-1.375",
        clipRule: "evenodd"
      }
    )
  }
), _3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17.688 11.25s.218 1.156.28 1.406h-1.03c.093-.281.5-1.375.5-1.375-.032.031.093-.281.156-.469l.093.438ZM21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.48 1.48 0 0 1 3 17.5v-11A1.5 1.5 0 0 1 4.5 5h15c.813 0 1.5.688 1.5 1.5M7.75 14.375 9.719 9.5H8.406l-1.25 3.313-.125-.657-.437-2.219c-.063-.312-.282-.406-.563-.437H4v.125c.469.125.906.281 1.313.531l1.125 4.219zm2.938 0L11.5 9.5h-1.281l-.781 4.875zm4.374-1.594c.032-.562-.312-.969-1.03-1.312-.438-.219-.72-.375-.72-.594s.22-.438.72-.438c.405 0 .718.094.937.188l.125.063.156-1.063a3.2 3.2 0 0 0-1.125-.188c-1.25 0-2.125.657-2.125 1.594 0 .688.625 1.094 1.094 1.313.5.25.656.406.656.594 0 .343-.375.5-.75.5-.5 0-.75-.094-1.188-.282l-.156-.062-.156 1.094c.281.124.813.25 1.375.25 1.344 0 2.188-.657 2.188-1.657Zm4.438 1.594L18.469 9.5H17.5c-.313 0-.531.094-.656.406l-1.875 4.469h1.344s.187-.594.25-.719h1.625c.03.156.125.719.125.719z" })
  }
), O3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6 18.5h1.5V20H6c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V13.5h-1.5V9H12c-.563 0-1-.438-1-1V5.5H6c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5M9.5 15h1c.938 0 1.75.813 1.75 1.75 0 .969-.813 1.75-1.75 1.75H10v1c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5v-4c0-.25.219-.5.5-.5m1 2.5a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75H10v1.5zm3-2.5h1c.813 0 1.5.688 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-1a.494.494 0 0 1-.5-.5v-4c0-.25.219-.5.5-.5m1 4c.25 0 .5-.219.5-.5v-2c0-.25-.25-.5-.5-.5H14v3zm2.5-3.5c0-.25.219-.5.5-.5H19c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1v1h1c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1v1.5c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5z" })
  }
), U3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 6c0-1.094.875-2 2-2h5v4c0 .563.438 1 1 1h4v4.5H9.5c-1.125 0-2 .906-2 2V20H6c-1.125 0-2-.875-2-2zm12 2h-4V4zm-6.5 7h1c.938 0 1.75.813 1.75 1.75 0 .969-.813 1.75-1.75 1.75H10v1c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5v-4c0-.25.219-.5.5-.5m1 2.5a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75H10v1.5zm3-2.5h1c.813 0 1.5.688 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5h-1a.494.494 0 0 1-.5-.5v-4c0-.25.219-.5.5-.5m1 4c.25 0 .5-.219.5-.5v-2c0-.25-.25-.5-.5-.5H14v3zm2.5-3.5c0-.25.219-.5.5-.5H19c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1v1h1c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1v1.5c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5z" })
  }
), q3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.5 21.25h1.875v1.25H4.5A2.47 2.47 0 0 1 2 20V5c0-1.367 1.094-2.5 2.5-2.5h6.094c.469 0 .976.234 1.328.586l4.492 4.492c.352.352.586.86.586 1.328v5.469h-1.25V10h-4.375A1.85 1.85 0 0 1 9.5 8.125V3.75h-5c-.703 0-1.25.586-1.25 1.25v15c0 .703.547 1.25 1.25 1.25m11.21-12.5c-.038-.078-.077-.195-.155-.273l-4.532-4.532c-.078-.078-.195-.117-.273-.156v4.336c0 .352.273.625.625.625h4.336Zm-6.835 7.5h1.25c1.172 0 2.188 1.016 2.188 2.188 0 1.21-1.016 2.187-2.188 2.187H9.5v1.25a.64.64 0 0 1-.625.625.617.617 0 0 1-.625-.625v-5c0-.313.273-.625.625-.625m1.25 3.125c.508 0 .938-.39.938-.938a.95.95 0 0 0-.938-.937H9.5v1.875zm3.75-3.125h1.25c1.016 0 1.875.86 1.875 1.875v2.5c0 1.055-.86 1.875-1.875 1.875h-1.25a.617.617 0 0 1-.625-.625v-5c0-.313.273-.625.625-.625m1.25 5a.64.64 0 0 0 .625-.625v-2.5c0-.313-.313-.625-.625-.625H14.5v3.75zm3.125-4.375c0-.313.273-.625.625-.625h1.875c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625H19.5v1.25h1.25c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625H19.5v1.875a.64.64 0 0 1-.625.625.617.617 0 0 1-.625-.625z" })
  }
), I3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.25 20a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5zm6.515-7.031a1 1 0 0 1 .937.653l2.564 6.936a.7.7 0 0 1-.658.942h-.472a1 1 0 0 1-.955-.704l-.37-1.195h-2.628l-.37 1.194a1 1 0 0 1-.955.705h-.468a.7.7 0 0 1-.658-.942l2.55-6.934a1 1 0 0 1 .938-.655zm-4.453-9.344a2.02 2.02 0 0 1 2.844 0l1.219 1.219c.094.093.188.218.25.312a1.994 1.994 0 0 1-.25 2.531l-9.5 9.5c-.031.032-.094.063-.125.125q-.469.375-1.031.563l-2.438.719L2.937 19a.71.71 0 0 1-.718-.219.64.64 0 0 1-.188-.718l.375-1.344.719-2.438c.125-.437.375-.844.687-1.156zm3.36 14.388h1.647l-.825-2.664zM4.875 14.187c-.031 0-.031.032-.063.063-.124.125-.187.281-.25.469l-.218.719-.5 1.718 1.718-.5.72-.218c.218-.063.374-.157.53-.313l7.157-7.156L12.03 7.03l-7.156 7.157Z" })
  }
), W3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.75 4h10.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H17v.594a4.73 4.73 0 0 1-1.406 3.375L13.03 12l2.563 2.563A4.66 4.66 0 0 1 17 17.905v.594h.25a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H6.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75H7v-.594c0-1.25.5-2.468 1.375-3.343L10.938 12 8.374 9.469A4.83 4.83 0 0 1 7 6.094V5.5h-.25A.72.72 0 0 1 6 4.75.74.74 0 0 1 6.75 4M12 13.063l-2.563 2.562a3.27 3.27 0 0 0-.937 2.281v.594h7v-.594a3.17 3.17 0 0 0-.969-2.281L12 13.062Zm0-2.126v.032l2.531-2.563a3.24 3.24 0 0 0 .969-2.312V5.5h-7v.594c0 .875.344 1.687.938 2.312z" })
  }
), $3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M4 3.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5V8h5.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-16a.5.5 0 0 1-.5-.5zM5 4v15h15V9h-5.5a.5.5 0 0 1-.5-.5V4z",
        clipRule: "evenodd"
      }
    )
  }
), Y3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "currentColor",
    viewBox: "0 0 64 64",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M42.5 36.076c4.278-2.514 9.625-2.514 14 0 4.278 2.514 7 7.06 7 11.992 0 5.029-2.722 9.574-7 12.088-4.375 2.514-9.722 2.515-14 0-4.375-2.514-7-7.06-7-12.088 0-4.932 2.625-9.477 7-11.992m12.444 2.708c-3.402-2.03-7.583-2.03-10.888 0-3.403 1.934-5.445 5.416-5.445 9.284 0 3.965 2.042 7.446 5.445 9.38 3.305 2.031 7.486 2.03 10.888 0 3.306-1.934 5.445-5.415 5.446-9.38 0-3.868-2.14-7.35-5.446-9.284M53 7.5c3.828 0 7 3.155 7 6.963V34.16q-.827-.616-1.736-1.14a17 17 0 0 0-1.764-.9V14.462c0-1.85-1.64-3.482-3.5-3.482H11c-1.969 0-3.5 1.632-3.5 3.482V39.92l7.328-7.398a4.58 4.58 0 0 1 6.235 0L28.5 39.92l14.328-14.36a4.58 4.58 0 0 1 6.234 0l6.051 6.018a17.3 17.3 0 0 0-5.92-.913l-2.646-2.602a.86.86 0 0 0-1.203 0l-5.738 5.68a17.8 17.8 0 0 0-4.436 4.393L20.406 52.758h12.245c.347 1.213.825 2.38 1.422 3.481H11c-3.938 0-7-3.046-7-6.963V14.463A6.96 6.96 0 0 1 11 7.5zm-4.796 33.315c.583-.58 1.653-.58 2.236 0l5.445 5.416c.583.58.583 1.644 0 2.224-.584.58-1.653.58-2.237 0l-2.722-2.805v8.607c0 .87-.777 1.547-1.555 1.548a1.53 1.53 0 0 1-1.556-1.548V45.65l-2.82 2.805c-.583.58-1.652.58-2.235 0-.584-.58-.584-1.644 0-2.224zm-29.657-5.79a.86.86 0 0 0-1.203 0L7.5 44.815v4.46c0 1.959 1.531 3.482 3.5 3.482h4.484l10.5-10.444-7.437-7.29Zm-1.422-19.8c1.531-.98 3.61-.98 5.25 0 1.531.979 2.625 2.61 2.625 4.46 0 1.958-1.094 3.59-2.625 4.569-1.64.979-3.719.979-5.25 0-1.64-.98-2.625-2.611-2.625-4.57 0-1.849.985-3.48 2.625-4.46Zm2.625 2.72c-.984 0-1.75.87-1.75 1.74 0 .979.766 1.74 1.75 1.74.875 0 1.75-.761 1.75-1.74 0-.87-.875-1.74-1.75-1.74" })
  }
), G3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 2.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19m-.75 13v2.25c0 .422.328.75.75.75.398 0 .75-.328.75-.75V15.5zM9 6.5a.755.755 0 0 0-.75.75c0 .422.328.75.75.75h.68l-.258 3.492a3.96 3.96 0 0 0-1.875 2.203l-.024.07c-.07.235-.046.493.118.68.14.211.351.305.609.305h7.5a.78.78 0 0 0 .61-.305c.14-.187.163-.445.093-.68l-.023-.07a3.96 3.96 0 0 0-1.875-2.203L14.297 8H15c.398 0 .75-.328.75-.75A.77.77 0 0 0 15 6.5z" })
  }
), N3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.281 5.219 9 5.5C17.72 11 18 11.5 18 12c0 .531-.281 1.031-.719 1.281l-9 5.5c-.469.282-1.062.313-1.531.032-.469-.25-.75-.75-.75-1.313v-11c0-.531.281-1.031.75-1.281a1.5 1.5 0 0 1 1.531 0" })
  }
), J3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.563 3.688v3.75h3.75a.57.57 0 0 1 .562.562.555.555 0 0 1-.563.563h-3.75v3.75a.555.555 0 0 1-.562.562.54.54 0 0 1-.563-.563v-3.75h-3.75A.54.54 0 0 1 3.125 8c0-.305.234-.563.563-.563h3.75v-3.75c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563" })
  }
), K3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.75 6.25v5h5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-5v5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-5h-5A.72.72 0 0 1 5.5 12a.74.74 0 0 1 .75-.75h5v-5A.74.74 0 0 1 12 5.5a.76.76 0 0 1 .75.75" })
  }
), Q3 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 5.5c-2.344 0-4.469 1.25-5.656 3.25a6.52 6.52 0 0 0 0 6.5A6.51 6.51 0 0 0 12 18.5c2.313 0 4.438-1.219 5.625-3.25a6.52 6.52 0 0 0 0-6.5C16.437 6.75 14.312 5.5 12 5.5M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m-.75-5.25v-2h-2A.72.72 0 0 1 8.5 12a.74.74 0 0 1 .75-.75h2v-2A.74.74 0 0 1 12 8.5a.76.76 0 0 1 .75.75v2h2a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2v2a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75" })
  }
), l7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m-.75-5.25c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-2h2a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75h-2v-2A.76.76 0 0 0 12 8.5a.74.74 0 0 0-.75.75v2h-2a.74.74 0 0 0-.75.75c0 .438.313.75.75.75h2z" })
  }
), c7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M12.656 14.363a.46.46 0 0 1-.406.287h-8.5a.44.44 0 0 1-.438-.45V1.8c0-.225.192-.45.438-.45h5.875V3.6c0 .506.383.9.875.9h2.188v8.497l-2.46-2.399a3.14 3.14 0 0 0 .656-1.927c0-1.755-1.433-3.171-3.192-3.171S4.5 6.916 4.5 8.671s1.433 3.171 3.192 3.171c.67 0 1.294-.205 1.808-.557l3.15 3.073zM3.75 0C2.766 0 2 .816 2 1.8v12.4c0 1.013.766 1.8 1.75 1.8h8.5c.957 0 1.75-.787 1.75-1.8V4.36a1.8 1.8 0 0 0-.52-1.266L10.992.534A1.72 1.72 0 0 0 9.762 0zM5.5 8.671c0-1.195.978-2.171 2.192-2.171s2.192.976 2.192 2.171c0 .594-.24 1.133-.632 1.526a.5.5 0 0 0-.12.112 2.2 2.2 0 0 1-1.44.534A2.18 2.18 0 0 1 5.5 8.67Z",
        clipRule: "evenodd"
      }
    )
  }
), a7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M18.246 19.816a.596.596 0 0 1-.58.497H6.334a.566.566 0 0 1-.583-.563V4.25a.59.59 0 0 1 .583-.563h7.834V6.5c0 .633.51 1.125 1.166 1.125h2.917v10.119l-2.844-2.723a4.17 4.17 0 0 0 .844-2.521c0-2.37-1.967-4.26-4.352-4.26s-4.353 1.89-4.353 4.26 1.968 4.259 4.353 4.259c.888 0 1.718-.262 2.41-.713zM6.333 2C5.021 2 4 3.02 4 4.25v15.5C4 21.016 5.02 22 6.333 22h11.334C18.943 22 20 21.016 20 19.75V7.45a2.2 2.2 0 0 0-.693-1.583L15.99 2.668A2.36 2.36 0 0 0 14.349 2zm2.712 10.5c0-1.505 1.259-2.76 2.853-2.76s2.852 1.255 2.852 2.76c0 .744-.308 1.427-.811 1.927a.8.8 0 0 0-.17.156 2.9 2.9 0 0 1-1.871.676c-1.594 0-2.853-1.254-2.853-2.76Z",
        clipRule: "evenodd"
      }
    )
  }
), t7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.125 6.5v5.25c0 .21.164.375.375.375h9a.385.385 0 0 0 .375-.375V6.5zM2 4.25c0-.82.656-1.5 1.5-1.5h9c.82 0 1.5.68 1.5 1.5v7.5c0 .844-.68 1.5-1.5 1.5h-9a1.48 1.48 0 0 1-1.5-1.5zm10.219 0h-1.711c-.164 0-.258.21-.14.328l.866.867c.07.07.188.07.258 0l.867-.867c.118-.117.024-.328-.14-.328M5 7.438h6a.57.57 0 0 1 .563.562.555.555 0 0 1-.563.563H5A.54.54 0 0 1 4.437 8c0-.305.235-.563.563-.563Zm0 2.25h6a.57.57 0 0 1 .563.562.555.555 0 0 1-.563.563H5a.54.54 0 0 1-.563-.563c0-.305.235-.563.563-.563Z" })
  }
), h7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.5 10v7c0 .281.219.5.5.5h12c.25 0 .5-.219.5-.5v-7zM4 7c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2zm13.625 0h-2.281c-.219 0-.344.281-.188.438l1.156 1.156c.094.094.25.094.344 0l1.157-1.156c.156-.157.03-.438-.188-.438M8 11.25h8a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H8a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75m0 3h8a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H8a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75" })
  }
), e7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M2 4.25a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M1 11.75v-7.5a2.5 2.5 0 0 1 2.5-2.5v1A1.5 1.5 0 0 0 2 4.25v7.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5v-1a2.5 2.5 0 0 1 2.5 2.5v7.5a2.5 2.5 0 0 1-2.5 2.5h-9a2.5 2.5 0 0 1-2.5-2.5m11.5-10v1h-9v-1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#D9D9D9",
          d: "M3.5 2.75c-.844 0-1.5.68-1.5 1.5v7.5c0 .844.656 1.5 1.5 1.5h9c.82 0 1.5-.656 1.5-1.5v-7.5c0-.82-.68-1.5-1.5-1.5zm9 3.75v5.25h-9V6.5zm-.281-2.25c.164 0 .258.21.14.328l-.867.867a.184.184 0 0 1-.258 0l-.867-.867c-.117-.117-.023-.328.14-.328zM5 7.438A.555.555 0 0 0 4.437 8c0 .328.235.563.563.563h6A.555.555 0 0 0 11.563 8 .57.57 0 0 0 11 7.437zm0 2.25a.555.555 0 0 0-.563.562c0 .328.235.563.563.563h6a.555.555 0 0 0 .563-.563.57.57 0 0 0-.563-.563H5Z"
        }
      )
    ]
  }
), r7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "m14.787 5.25 3.97 4.025a4.195 4.195 0 0 1 0 5.96l-3.502 3.527c-.28.312-.75.312-1.063.031-.28-.312-.28-.78 0-1.06l3.502-3.558a2.71 2.71 0 0 0 0-3.839L13.692 6.28c-.281-.28-.281-.748.031-1.06.282-.281.75-.281 1.063.03Z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M5.5 5h4.66a2 2 0 0 1 1.406.593l5.253 5.242c.781.78.781 2.06 0 2.84l-4.158 4.15c-.782.78-2.064.78-2.846 0l-5.252-5.242A1.95 1.95 0 0 1 4 11.18V6.498A1.5 1.5 0 0 1 5.5 5m0 6.179c0 .172.057.278.124.345l5.252 5.243a.52.52 0 0 0 .723 0l4.159-4.15a.517.517 0 0 0 0-.722l-5.253-5.243a.5.5 0 0 0-.346-.154H5.501v4.68Z" }),
      /* @__PURE__ */ l.jsx("path", { d: "M8.502 8.495a1 1 0 1 1-1.999-.002 1 1 0 0 1 2 .002Z" })
    ]
  }
), i7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 12.875h6a.385.385 0 0 0 .375-.375V5.75H9.5A.74.74 0 0 1 8.75 5V3.125H5a.385.385 0 0 0-.375.375v9c0 .21.164.375.375.375M3.5 3.5C3.5 2.68 4.156 2 5 2h3.867c.399 0 .774.164 1.055.445l2.133 2.133c.28.281.445.656.445 1.055V12.5c0 .844-.68 1.5-1.5 1.5H5a1.48 1.48 0 0 1-1.5-1.5zm1.875 1.125c0-.188.164-.375.375-.375h1.875c.188 0 .375.188.375.375 0 .21-.188.375-.375.375H5.75a.37.37 0 0 1-.375-.375m0 1.5c0-.188.164-.375.375-.375h1.875c.188 0 .375.188.375.375 0 .21-.188.375-.375.375H5.75a.37.37 0 0 1-.375-.375M8 11.375c0-.188.164-.375.375-.375h1.875c.188 0 .375.188.375.375 0 .21-.188.375-.375.375H8.375A.37.37 0 0 1 8 11.375M6.125 7.25h3.75c.398 0 .75.352.75.75v1.5c0 .422-.352.75-.75.75h-3.75a.74.74 0 0 1-.75-.75V8c0-.398.328-.75.75-.75" })
  }
), s7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 2h3.75v3c0 .422.328.75.75.75h3v6.75c0 .844-.68 1.5-1.5 1.5H5a1.48 1.48 0 0 1-1.5-1.5v-9C3.5 2.68 4.156 2 5 2m4.5 0 3 3h-3zM5.375 3.5A.385.385 0 0 0 5 3.875c0 .21.164.375.375.375h1.5a.385.385 0 0 0 .375-.375.4.4 0 0 0-.375-.375zm0 1.5A.385.385 0 0 0 5 5.375c0 .21.164.375.375.375h1.5a.385.385 0 0 0 .375-.375A.4.4 0 0 0 6.875 5zm.375 2.25A.755.755 0 0 0 5 8v1.5c0 .422.328.75.75.75h4.5c.398 0 .75-.328.75-.75V8a.77.77 0 0 0-.75-.75zm0 .75h4.5v1.5h-4.5zm3.375 3.75a.385.385 0 0 0-.375.375c0 .21.164.375.375.375h1.5a.385.385 0 0 0 .375-.375.4.4 0 0 0-.375-.375z" })
  }
), o7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M20.75 12c0-5.086-3.664-8.75-8.75-8.75a.75.75 0 0 1 0-1.5c5.914 0 10.25 4.336 10.25 10.25a.75.75 0 0 1-1.5 0" }),
      /* @__PURE__ */ l.jsx("path", { d: "M22.4 9.55a.75.75 0 0 1 1.2.9l-1.5 2a.75.75 0 0 1-1.05.15l-2-1.5a.75.75 0 0 1 .9-1.2l1.4 1.05z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16.071 6.571H7.93C7.125 6.571 6.5 7.22 6.5 8v8.072A1.41 1.41 0 0 0 7.929 17.5h8.142c.782 0 1.429-.625 1.429-1.428V8c0-.781-.647-1.429-1.429-1.429m-.802 1.572c0 .361.27.643.616.643a.634.634 0 0 0 .615-.643c0-.342-.288-.643-.615-.643-.346 0-.616.301-.616.643m-2.154 6.75v-4.5c0-.342.27-.643.616-.643.327 0 .615.301.615.643v4.5a.634.634 0 0 1-.615.643c-.346 0-.616-.282-.616-.643m.616 1.607c.846 0 1.538-.703 1.538-1.607v-4.5c0-.884-.692-1.607-1.538-1.607-.866 0-1.539.723-1.539 1.607v4.5c0 .904.673 1.607 1.539 1.607m-3.077-2.712v.783c0 .523-.404.965-.923.965-.25 0-.462.2-.462.482a.48.48 0 0 0 .462.482c1.019 0 1.846-.864 1.846-1.929v-4.178c0-.904-.673-1.607-1.538-1.607-.847 0-1.539.703-1.539 1.607v1.928c0 .884.692 1.607 1.539 1.607.23 0 .442-.06.615-.14m0-1.467c0 .342-.27.643-.615.643-.327 0-.616-.301-.616-.643v-1.928c0-.362.289-.643.616-.643.346 0 .615.281.615.643z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M9.5 6.5h-3v3h3zM6.5 5h3c.813 0 1.5.688 1.5 1.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.48 1.48 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5m3 9.5h-3v3h3zm-3-1.5h3c.813 0 1.5.688 1.5 1.5v3A1.5 1.5 0 0 1 9.5 19h-3A1.48 1.48 0 0 1 5 17.5v-3A1.5 1.5 0 0 1 6.5 13m8-6.5v3h3v-3zm-1.5 0A1.5 1.5 0 0 1 14.5 5h3c.813 0 1.5.688 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.48 1.48 0 0 1 13 9.5zM7.25 7.75c0-.25.219-.5.5-.5h.5c.25 0 .5.25.5.5v.5c0 .281-.25.5-.5.5h-.5a.494.494 0 0 1-.5-.5zm.5 7.5h.5c.25 0 .5.25.5.5v.5c0 .281-.25.5-.5.5h-.5a.494.494 0 0 1-.5-.5v-.5c0-.25.219-.5.5-.5m7.5-7.5c0-.25.219-.5.5-.5h.5c.25 0 .5.25.5.5v.5c0 .281-.25.5-.5.5h-.5a.494.494 0 0 1-.5-.5zM13 13.5c0-.25.219-.5.5-.5h2c.25 0 .5.25.5.5 0 .281.219.5.5.5h1c.25 0 .5-.219.5-.5 0-.25.219-.5.5-.5.25 0 .5.25.5.5v3c0 .281-.25.5-.5.5h-2a.494.494 0 0 1-.5-.5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5v2c0 .281-.25.5-.5.5h-1a.494.494 0 0 1-.5-.5zm3.5 4.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m2 0c.25 0 .5.25.5.5 0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5" })
  }
), v7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 4a.76.76 0 0 1 .75.75v6.5h6.5A.76.76 0 0 1 20 12a.74.74 0 0 1-.75.75h-6.5v6.5A.74.74 0 0 1 12 20a.72.72 0 0 1-.75-.75v-6.5h-6.5A.72.72 0 0 1 4 12a.74.74 0 0 1 .75-.75h6.5v-6.5A.74.74 0 0 1 12 4m4.5 1a.76.76 0 0 1 .75.75v1h1a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-1v1a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-1h-1A.72.72 0 0 1 14 7.5a.74.74 0 0 1 .75-.75h1v-1A.74.74 0 0 1 16.5 5M5.719 14.75a.72.72 0 0 1 1.062 0l.719.719.688-.719c.312-.281.78-.281 1.062 0a.774.774 0 0 1 0 1.063l-.719.687.719.719a.774.774 0 0 1 0 1.062.774.774 0 0 1-1.063 0l-.687-.718-.719.718a.774.774 0 0 1-1.062 0 .774.774 0 0 1 0-1.062l.718-.719-.718-.688c-.282-.312-.282-.78 0-1.062m.281-8h3a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H6a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75m9 7.75h3a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-3a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75m0 2.5h3a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-3a.72.72 0 0 1-.75-.75A.74.74 0 0 1 15 17" })
  }
), w7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.875 8c0-1.734-.938-3.328-2.438-4.219a4.89 4.89 0 0 0-4.874 0A4.87 4.87 0 0 0 3.124 8a4.88 4.88 0 0 0 2.438 4.242c1.5.867 3.351.867 4.875 0A4.93 4.93 0 0 0 12.874 8ZM2 8a5.96 5.96 0 0 1 3-5.18 5.97 5.97 0 0 1 6 0A6 6 0 0 1 14 8a6.01 6.01 0 0 1-3 5.203 5.97 5.97 0 0 1-6 0A5.97 5.97 0 0 1 2 8m3.96-2.11c.188-.538.68-.89 1.243-.89h1.36c.82 0 1.5.68 1.5 1.5 0 .516-.305 1.008-.75 1.266l-.75.445A.566.566 0 0 1 8 8.75a.54.54 0 0 1-.563-.563v-.304c0-.211.094-.399.282-.492l1.031-.586a.37.37 0 0 0 .188-.305c0-.21-.165-.352-.376-.352H7.204c-.07 0-.14.047-.164.118l-.023.023a.55.55 0 0 1-.704.352.585.585 0 0 1-.351-.727v-.023Zm1.29 4.36c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75" })
  }
), x7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M2.365 10.614A.365.365 0 0 1 2 10.25V6.365a.365.365 0 0 1 .73 0v3.884a.365.365 0 0 1-.365.365M20.27 6.365a.365.365 0 0 1 .731 0v3.884a.365.365 0 0 1-.73 0V6.365ZM2 16.308a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2v-2.923a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zm1.432-2.384a1 1 0 0 1 1-1h.403v2.307h.701v-2.307H6.94v1.538h.702v-1.538h1.403v1.538h.701v-1.538h1.404v2.307h.701v-2.307h1.403v1.538h.702v-1.538h1.403v1.538h.701v-1.538h1.403v2.307h.702v-2.307h.403a1 1 0 0 1 1 1v1.845a1 1 0 0 1-1 1H4.432a1 1 0 0 1-1-1zm-.28-5.867a.3.3 0 0 0 0 .501l1.896 1.248a.3.3 0 0 0 .465-.25v-.671h11.973v.67a.3.3 0 0 0 .465.25l1.896-1.247a.3.3 0 0 0 0-.5l-1.897-1.25a.3.3 0 0 0-.465.251v.67H5.513v-.67a.3.3 0 0 0-.465-.25L3.153 8.056Z",
        clipRule: "evenodd"
      }
    )
  }
), d7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.75 11h-4.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h2.813l-.844-1c-1.032-1.219-2.532-2-4.219-2A5.49 5.49 0 0 0 6.5 12c0 3.063 2.438 5.5 5.5 5.5a5.45 5.45 0 0 0 3.281-1.094.75.75 0 0 1 1.063.157.75.75 0 0 1-.157 1.062C15.031 18.5 13.563 19 12 19c-3.875 0-7-3.125-7-7 0-3.844 3.125-7 7-7 2.156 0 4.094 1 5.375 2.531l.625.75V5.75a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v4.5a.74.74 0 0 1-.75.75" })
  }
), g7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M14.143 6.3a.75.75 0 0 1 1.017-1.1l3.28 3.029a.95.95 0 0 1 0 1.396l-3.28 3.03a.75.75 0 0 1-1.018-1.102l2.031-1.876h-5.885a3.788 3.788 0 1 0 0 7.576h4.164a.75.75 0 0 1 0 1.5h-4.164a5.288 5.288 0 1 1 0-10.576h5.885z",
        clipRule: "evenodd"
      }
    )
  }
), m7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M16.942 4.22a.625.625 0 1 1 .823-.94l3.828 3.35a.825.825 0 0 1 0 1.24l-3.828 3.35a.625.625 0 0 1-.823-.94l2.748-2.405H9a5.375 5.375 0 0 0 0 10.75h7.015a.625.625 0 0 1 0 1.25H8.999a6.625 6.625 0 1 1 0-13.25H19.69z",
        clipRule: "evenodd"
      }
    )
  }
), p7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.898 3.125c-.07 0-.117.047-.164.094l-.445.656h3.399l-.446-.656a.2.2 0 0 0-.164-.094zm4.149.75h1.641a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562h-.28l-.563 7.617a1.49 1.49 0 0 1-1.5 1.383H5.633c-.797 0-1.43-.586-1.5-1.383L3.57 5h-.257a.54.54 0 0 1-.563-.563c0-.304.234-.562.563-.562H4.93l.867-1.29A1.34 1.34 0 0 1 6.898 2h2.18c.445 0 .867.234 1.102.586zM11.28 5H4.695l.563 7.547a.38.38 0 0 0 .375.328h4.71a.38.38 0 0 0 .376-.328z" })
  }
), u7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.531 5.5c-.094 0-.156.063-.219.125L9.72 6.5h4.531l-.594-.875a.26.26 0 0 0-.219-.125h-2.906Zm5.531 1h2.188a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-.375l-.75 10.156c-.094 1.063-.938 1.844-2 1.844H8.844c-1.063 0-1.906-.781-2-1.844L6.094 8H5.75A.72.72 0 0 1 5 7.25a.74.74 0 0 1 .75-.75h2.156l1.157-1.719A1.79 1.79 0 0 1 10.53 4h2.906c.594 0 1.157.313 1.47.781L16.061 6.5Zm.313 1.5H7.594l.75 10.063c.031.25.25.437.5.437h6.281c.25 0 .469-.188.5-.438z" })
  }
), f7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.5 11h-.25a.72.72 0 0 1-.75-.75v-4a.75.75 0 0 1 .438-.687.9.9 0 0 1 .843.156L7.063 7.03c2.75-2.687 7.156-2.687 9.875.032a7.036 7.036 0 0 1 0 9.906 7.035 7.035 0 0 1-9.907 0c-.375-.407-.375-1.032 0-1.407.407-.406 1.032-.406 1.407 0a5.055 5.055 0 0 0 7.093 0 5.055 5.055 0 0 0 0-7.093c-1.937-1.938-5.094-1.938-7.061-.03l1.312 1.28c.188.22.25.563.156.845A.75.75 0 0 1 9.25 11z" })
  }
), j7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M6 6c0-1.094.875-2 2-2h5v4c0 .563.438 1 1 1h4v9c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2zm3.5 6c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h5c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm0 2c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h5c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm0 2c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h5c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M18 9h-4c-.563 0-1-.438-1-1V4zm-8.5 3h5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-5a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m0 2h5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-5a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m0 2h5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-5a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5"
        }
      )
    ]
  }
), M7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17.344 17.781 12 13.313v-2.594l5.344-4.469c.312-.25.718-.313 1.062-.156.344.187.594.531.594.906v10a1 1 0 0 1-.594.906c-.343.188-.75.125-1.062-.125M11 15v2a1 1 0 0 1-.594.906c-.344.188-.75.125-1.062-.125l-6-5A1.02 1.02 0 0 1 3 12c0-.281.125-.563.344-.75l6-5c.312-.25.719-.313 1.062-.156.344.187.594.531.594.906z" })
  }
), C7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15.002 5.608a.43.43 0 0 1-.422-.422V4.26c0-1.236-.803-2.115-2.045-2.115h-.187v.75c0 .44-.358.556-.698.304l-1.54-1.136c-.253-.188-.247-.416 0-.604L11.65.316c.34-.257.698-.146.698.305v.738h.187c1.717 0 2.889 1.172 2.889 2.9v.927a.43.43 0 0 1-.422.422M5.1 13.318c-1.06 0-1.618-.533-1.618-1.617V5.918c0-1.084.557-1.617 1.618-1.617h5.795c1.066 0 1.617.533 1.617 1.617v5.783c0 1.084-.551 1.617-1.617 1.617zm.064-1.125h5.666c.387 0 .557-.152.557-.556V5.983c0-.405-.17-.557-.557-.557H5.164c-.387 0-.557.152-.557.557v5.654c0 .404.17.556.557.556" })
  }
), A7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M9.333 4.851a7.27 7.27 0 0 1 5.263.11 7.46 7.46 0 0 1 3.863 3.655.7.7 0 0 0 .17.227c.102.208.3.364.544.403a.754.754 0 0 0 .858-.628l.679-4.148a.747.747 0 0 0-.614-.863.754.754 0 0 0-.857.628l-.361 2.206a8.9 8.9 0 0 0-3.71-2.866 8.77 8.77 0 0 0-6.348-.133 8.94 8.94 0 0 0-4.816 4.19 9.16 9.16 0 0 0-1.084 4.324.75.75 0 1 0 1.5 0c0-1.255.308-2.5.906-3.616a7.44 7.44 0 0 1 4.007-3.49Zm11.391 7.105a.75.75 0 1 0-1.5 0c0 1.855-.67 3.644-1.881 5.025a7.36 7.36 0 0 1-4.677 2.47 7.3 7.3 0 0 1-5.101-1.324 7.5 7.5 0 0 1-2.362-2.793.8.8 0 0 0-.172-.229.74.74 0 0 0-.56-.44.75.75 0 0 0-.856.625l-.679 4.148c-.067.413.206.8.612.868a.75.75 0 0 0 .856-.625l.362-2.211a9 9 0 0 0 1.925 1.877 8.8 8.8 0 0 0 6.15 1.594 8.86 8.86 0 0 0 5.63-2.971 9.13 9.13 0 0 0 2.253-6.014",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M16.192 8.455c-.39 0-.692-.319-.692-.728 0-.386.303-.727.692-.727.368 0 .693.34.693.727 0 .41-.325.728-.693.728m-3.115 1.636v5.09c0 .41.303.728.692.728.368 0 .692-.318.692-.727V10.09c0-.386-.324-.727-.692-.727-.39 0-.692.34-.692.727Zm2.423 5.09c0 1.024-.779 1.819-1.73 1.819-.974 0-1.731-.796-1.731-1.818V10.09c0-1 .757-1.818 1.73-1.818.952 0 1.731.818 1.731 1.818z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M10.308 14.818v-.886c-.195.09-.433.159-.693.159-.952 0-1.73-.818-1.73-1.818V10.09c0-1.023.778-1.818 1.73-1.818.974 0 1.731.795 1.731 1.818v4.728c0 1.204-.93 2.181-2.077 2.181-.281 0-.519-.25-.519-.546 0-.318.238-.545.52-.545.583 0 1.038-.5 1.038-1.09M9.615 13c.39 0 .693-.34.693-.727V10.09c0-.41-.303-.727-.693-.727-.367 0-.692.318-.692.727v2.182c0 .386.325.727.692.727Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), V7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2.656 9.477a.57.57 0 0 1-.562-.563V7.68c0-2.305 1.57-3.867 3.86-3.867h.241v-.985c0-.601.477-.75.938-.406L9.18 3.945c.328.25.336.555 0 .805L7.133 6.266c-.453.336-.938.18-.938-.407v-1h-.25c-1.648 0-2.726 1.172-2.726 2.82v1.235c0 .305-.25.563-.563.563m13.203 10.28H8.133c-1.414 0-2.156-.71-2.156-2.155V9.89c0-1.446.742-2.157 2.156-2.157h7.726c1.414 0 2.157.711 2.157 2.157v7.71c0 1.446-.743 2.157-2.157 2.157m-.086-1.5c.516 0 .743-.202.743-.741v-7.54c0-.538-.227-.742-.743-.742H8.22c-.516 0-.742.204-.742.743v7.539c0 .539.226.742.742.742h7.554Z" })
  }
), z7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M19 7c0 .5-.344 1.25-.875 2.156A26 26 0 0 1 17 10.72c-.375-.438-.781-1-1.156-1.563C15.313 8.25 15 7.5 15 7c0-1.094.875-2 2-2 1.094 0 2 .906 2 2m-2.125 5c.188.063.344 0 .469-.156C18.125 10.938 20 8.594 20 7a3 3 0 0 0-6 0c0 1.219 1.094 2.875 1.938 4H14.5a2.487 2.487 0 0 0-2.5 2.5c0 1.406 1.094 2.5 2.5 2.5h3c.813 0 1.5.688 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5H9.187c-.312.406-.593.75-.843 1H17.5c1.375 0 2.5-1.094 2.5-2.5 0-1.375-1.125-2.5-2.5-2.5h-3a1.48 1.48 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5zM9 15c0 .469-.313 1.219-.875 2.063A22 22 0 0 1 7 18.53a15 15 0 0 1-1.156-1.468C5.28 16.218 5 15.469 5 15c0-1.094.875-2 2-2 1.094 0 2 .906 2 2m-1.344 4.281a1.6 1.6 0 0 0 .219-.25C8.75 17.97 10 16.281 10 15a3 3 0 0 0-6 0c0 1.594 1.844 3.781 2.656 4.656.188.188.5.188.657 0l.187-.187c.031-.063.094-.125.156-.188M17.75 7a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75M7 15.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M17 3.75A3.25 3.25 0 0 1 20.25 7c0 .875-.505 1.913-1.073 2.813A19 19 0 0 1 17.538 12l.001.001a.73.73 0 0 1-.323.24.63.63 0 0 1-.37.01H14.5a1.25 1.25 0 0 0-1.25 1.25c0 .706.544 1.25 1.25 1.25h3a2.757 2.757 0 0 1 2.75 2.75 2.737 2.737 0 0 1-2.75 2.75H7.74l.427-.427c.238-.238.51-.57.822-.975l.075-.098H17.5a1.25 1.25 0 0 0 1.25-1.25c0-.674-.576-1.25-1.25-1.25h-3a2.72 2.72 0 0 1-2.75-2.75 2.737 2.737 0 0 1 2.75-2.75h.944a15 15 0 0 1-1.012-1.597c-.384-.716-.682-1.48-.682-2.153A3.25 3.25 0 0 1 17 3.75m-10 8A3.25 3.25 0 0 1 10.25 15c0 .71-.343 1.501-.77 2.225-.431.73-.971 1.43-1.412 1.965a2 2 0 0 1-.235.268.7.7 0 0 0-.11.122l-.018.037-.216.216c-.267.3-.74.27-1.01 0l-.006-.007a17 17 0 0 1-1.659-2.09C4.25 16.875 3.75 15.875 3.75 15A3.25 3.25 0 0 1 7 11.75M17 4a3 3 0 0 0-3 3c0 1.219 1.094 2.875 1.938 4H14.5a2.487 2.487 0 0 0-2.5 2.5c0 1.406 1.094 2.5 2.5 2.5h3c.813 0 1.5.688 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5H9.187c-.312.406-.593.75-.843 1H17.5c1.375 0 2.5-1.094 2.5-2.5 0-1.375-1.125-2.5-2.5-2.5h-3a1.48 1.48 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5h2.375c.188.063.344 0 .469-.156C18.125 10.938 20 8.594 20 7a3 3 0 0 0-3-3M7 12a3 3 0 0 0-3 3c0 1.594 1.844 3.781 2.656 4.656.188.188.5.188.657 0l.187-.187c.031-.063.094-.125.156-.188a1.6 1.6 0 0 0 .219-.25C8.75 17.97 10 16.281 10 15a3 3 0 0 0-3-3m0 1c1.094 0 2 .906 2 2 0 .469-.313 1.219-.875 2.063A22 22 0 0 1 7 18.53a15 15 0 0 1-1.156-1.468C5.28 16.218 5 15.469 5 15c0-1.094.875-2 2-2m0 .25c-.984 0-1.75.792-1.75 1.75 0 .393.246 1.09.798 1.918l.283.393c.22.298.446.583.662.834.294-.363.622-.794.928-1.227.273-.41.482-.793.622-1.125.143-.338.207-.607.207-.793 0-.956-.794-1.75-1.75-1.75M7 14c.544 0 1 .456 1 1a.99.99 0 0 1-1 1c-.576 0-1-.424-1-1 0-.537.418-1 1-1m0 .25a.74.74 0 0 0-.75.75c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75M17 5c1.094 0 2 .906 2 2 0 .5-.344 1.25-.875 2.156A26 26 0 0 1 17 10.72c-.375-.438-.781-1-1.156-1.563C15.313 8.25 15 7.5 15 7c0-1.094.875-2 2-2m0 .25c-.984 0-1.75.792-1.75 1.75 0 .204.065.482.205.833.138.346.34.746.6 1.19.305.457.63.91.938 1.292.293-.385.617-.838.92-1.293.261-.445.473-.846.618-1.193q.22-.53.219-.829c0-.956-.794-1.75-1.75-1.75M17 6c.544 0 1 .456 1 1a.99.99 0 0 1-1 1c-.576 0-1-.424-1-1 0-.537.418-1 1-1m0 .25a.74.74 0 0 0-.75.75c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75" })
    ]
  }
), H7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.5 7v10c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5V9.344A.5.5 0 0 0 17.344 9l1.062-1.063c.375.375.563.875.563 1.407V17c0 1.125-.875 2-2 2H7c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2h7.656c.531 0 1.031.219 1.406.594l2.344 2.343L17.344 9 15 6.656v-.031V9.75a.74.74 0 0 1-.75.75h-6a.72.72 0 0 1-.75-.75V6.5H7c-.281 0-.5.25-.5.5M9 6.5V9h4.5V6.5zm1 7.5a2.02 2.02 0 0 1 1-1.719c.594-.344 1.375-.344 2 0 .594.375 1 1.031 1 1.719 0 .719-.406 1.375-1 1.75-.625.344-1.406.344-2 0A2.03 2.03 0 0 1 10 14" })
  }
), B7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.5 15c0 .281.219.5.5.5h9c.25 0 .5-.219.5-.5V8.344A.5.5 0 0 0 18.344 8l1.062-1.063L18.344 8 16 5.656v-.031V7.75a.74.74 0 0 1-.75.75h-5a.72.72 0 0 1-.75-.75V5.5H9c-.281 0-.5.25-.5.5zM11 4h4.656c.531 0 1.031.219 1.406.594l2.344 2.343c.375.375.594.875.594 1.407V15c0 1.125-.906 2-2 2H9c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2zm0 1.5V7h3.5V5.5zM5.5 7.75v8a2.734 2.734 0 0 0 2.75 2.75h8a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-8A4.215 4.215 0 0 1 4 15.75v-8A.74.74 0 0 1 4.75 7a.76.76 0 0 1 .75.75m6 4.25a2.02 2.02 0 0 1 1-1.719c.594-.344 1.375-.344 2 0 .594.375 1 1.031 1 1.719 0 .719-.406 1.375-1 1.75-.625.344-1.406.344-2 0a2.03 2.03 0 0 1-1-1.75" })
  }
), L7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4.25 6.25v12.5c0 .703.547 1.25 1.25 1.25H18c.664 0 1.25-.547 1.25-1.25V9.18c0-.352-.156-.664-.39-.899l-2.891-2.89c-.156-.157-.313-.235-.469-.313V8.75c0 .703-.586 1.25-1.25 1.25h-7.5c-.703 0-1.25-.547-1.25-1.25V5c-.703 0-1.25.586-1.25 1.25M6.75 5v3.75h7.5V5zM3 6.25c0-1.367 1.094-2.5 2.5-2.5h9.57c.664 0 1.29.273 1.758.742l2.93 2.93c.469.469.742 1.094.742 1.758v9.57c0 1.406-1.133 2.5-2.5 2.5H5.5a2.47 2.47 0 0 1-2.5-2.5zM13.625 15c0-.664-.39-1.25-.938-1.602-.585-.351-1.328-.351-1.874 0-.586.352-.938.938-.938 1.602 0 .703.352 1.29.938 1.64.546.352 1.289.352 1.874 0 .547-.35.938-.937.938-1.64m-1.875-3.125c1.094 0 2.11.625 2.695 1.563.547.976.547 2.187 0 3.124-.586.977-1.601 1.563-2.695 1.563a3.16 3.16 0 0 1-2.734-1.563c-.547-.937-.547-2.148 0-3.125.586-.937 1.601-1.562 2.734-1.562" })
  }
), X7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.5 7v10c0 .281.219.5.5.5h7.375c.214.548.514 1.054.882 1.5H5c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2h7.656c.531 0 1.031.219 1.406.594l2.344 2.343c.375.375.563.875.563 1.407v.681a5.5 5.5 0 0 0-1.469.35V9.344A.5.5 0 0 0 15.344 9L13 6.656V9.75a.74.74 0 0 1-.75.75h-6a.72.72 0 0 1-.75-.75V6.5H5c-.281 0-.5.25-.5.5M7 6.5V9h4.5V6.5zM8 14a2.02 2.02 0 0 1 1-1.719c.594-.344 1.375-.344 2 0 .594.375 1 1.031 1 1.719 0 .719-.406 1.375-1 1.75-.625.344-1.406.344-2 0A2.03 2.03 0 0 1 8 14m14 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2.403-1.355a.5.5 0 0 1 .003.707l-2.254 2.273a.5.5 0 0 1-.709.001l-1.26-1.26a.5.5 0 0 1 .707-.707l.905.905 1.9-1.916a.5.5 0 0 1 .708-.003",
        clipRule: "evenodd"
      }
    )
  }
), R7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#04B50B",
          fillRule: "evenodd",
          d: "M18.5 20a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m2.1-5.148a.5.5 0 1 0-.71-.704l-1.9 1.916-.906-.905a.5.5 0 1 0-.707.707l1.26 1.26a.5.5 0 0 0 .709-.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.15,
          fillRule: "evenodd",
          d: "M12.563 5H5c-1.125 0-2 .906-2 2v10c0 1.125.875 2 2 2h9.257A5.502 5.502 0 0 1 17 10.207v-.77c0-.53-.219-1.062-.594-1.437L14 5.594A2.06 2.06 0 0 0 12.562 5ZM5 10V8c0-.531.438-1 1-1h6c.531 0 1 .469 1 1v2c0 .563-.469 1-1 1H6c-.563 0-1-.438-1-1m3.25 4c.375-.594 1.031-1 1.75-1 .688 0 1.344.406 1.719 1 .344.625.344 1.406 0 2A2.02 2.02 0 0 1 10 17a2.03 2.03 0 0 1-1.75-1c-.344-.594-.344-1.375 0-2",
          clipRule: "evenodd"
        }
      )
    ]
  }
), y7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 4.75A.74.74 0 0 1 8.75 4a.76.76 0 0 1 .75.75V6H8zm5.5 0a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75V6h-1.5zm-2-.75c.25 0 .5.25.5.5V6h-1V4.5c0-.25.219-.5.5-.5m4.5.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5v8c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5zm3.25-.5a.76.76 0 0 1 .75.75v7.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-7.5a.74.74 0 0 1 .75-.75M6 8.5c-.281 0-.5.25-.5.5v9c0 .281.219.5.5.5h7c.25 0 .5-.219.5-.5V9c0-.25-.25-.5-.5-.5zM6 7h7c1.094 0 2 .906 2 2v9c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2V9c0-1.094.875-2 2-2m1.25 2.5h4.5a.76.76 0 0 1 .75.75v6.5a.74.74 0 0 1-.75.75h-4.5a.72.72 0 0 1-.75-.75v-6.5a.74.74 0 0 1 .75-.75" })
  }
), Z7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.75 4h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2.5a.246.246 0 0 0-.25.25v2.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-2.5C4 4.812 4.781 4 5.75 4m10 0h2.5c.938 0 1.75.813 1.75 1.75v2.5a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-2.5a.27.27 0 0 0-.25-.25h-2.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75M5.5 15.75v2.5c0 .156.094.25.25.25h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2.5C4.781 20 4 19.219 4 18.25v-2.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75m14.5 0v2.5c0 .969-.813 1.75-1.75 1.75h-2.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h2.5c.125 0 .25-.094.25-.25v-2.5a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75M9.406 7.781c.219-.468.656-.781 1.156-.781h2.844c.5 0 .969.313 1.156.781l.094.219H15c1.094 0 2 .906 2 2v4c0 1.125-.906 2-2 2H9c-1.125 0-2-.875-2-2v-4c0-1.094.875-2 2-2h.313zm1.313.719-.219.563a.75.75 0 0 1-.688.437H9c-.281 0-.5.25-.5.5v4c0 .281.219.5.5.5h6c.25 0 .5-.219.5-.5v-4c0-.25-.25-.5-.5-.5h-.844a.75.75 0 0 1-.687-.438L13.25 8.5zM10.25 12c0-.625.313-1.188.875-1.5.531-.313 1.188-.313 1.75 0 .531.313.875.875.875 1.5a1.76 1.76 0 0 1-.875 1.531c-.563.313-1.219.313-1.75 0-.563-.312-.875-.875-.875-1.531" })
  }
), E7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.625 6.875c0-1.336-.727-2.555-1.875-3.234a3.7 3.7 0 0 0-3.75 0 3.72 3.72 0 0 0-1.875 3.234A3.73 3.73 0 0 0 5 10.133c1.148.68 2.578.68 3.75 0a3.78 3.78 0 0 0 1.875-3.258m-.727 3.844a4.9 4.9 0 0 1-3.023 1.031A4.87 4.87 0 0 1 2 6.875C2 4.203 4.18 2 6.875 2c2.672 0 4.875 2.203 4.875 4.875a4.95 4.95 0 0 1-1.055 3.047l3.14 3.117c.212.234.212.586 0 .797-.233.234-.585.234-.796 0L9.9 10.719Z" })
  }
), b7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15.5 10.5c0-1.781-.969-3.406-2.5-4.313a4.94 4.94 0 0 0-5 0A4.96 4.96 0 0 0 5.5 10.5c0 1.813.938 3.438 2.5 4.344a4.94 4.94 0 0 0 5 0c1.531-.906 2.5-2.531 2.5-4.344m-.969 5.125A6.55 6.55 0 0 1 10.5 17 6.495 6.495 0 0 1 4 10.5C4 6.937 6.906 4 10.5 4c3.563 0 6.5 2.938 6.5 6.5a6.6 6.6 0 0 1-1.406 4.063l4.187 4.156c.282.312.282.781 0 1.062-.312.313-.781.313-1.062 0z" })
  }
), F7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.477 5.75c0-.69.56-1.25 1.25-1.25h.959a.75.75 0 0 0 0-1.5h-.96a2.75 2.75 0 0 0-2.75 2.75v1.183a.75.75 0 1 0 1.5 0V5.75Zm6.48-1.25a.75.75 0 1 0 0-1.5H11.04a.75.75 0 0 0 0 1.5zm2.355 0h.958c.69 0 1.25.56 1.25 1.25v1.183a.75.75 0 0 0 1.5 0V5.75A2.75 2.75 0 0 0 16.27 3h-.958a.75.75 0 0 0 0 1.5M6.477 9.4a.75.75 0 1 0-1.5 0v1.854a.75.75 0 0 0 1.5 0V9.399Zm11.043 1.854a.75.75 0 0 0 1.5 0V9.399a.75.75 0 0 0-1.5 0zM6.477 18.25c0 .69.56 1.25 1.25 1.25h.959a.75.75 0 0 1 0 1.5h-.96a2.75 2.75 0 0 1-2.75-2.75l-.003-.957a.75.75 0 1 1 1.5-.007zm6.48 1.25a.75.75 0 1 1 0 1.5H11.04a.75.75 0 0 1 0-1.5zm2.355 0h.958c.69 0 1.25-.56 1.25-1.25l-.004-.957a.75.75 0 1 1 1.5-.007l.004.964A2.75 2.75 0 0 1 16.27 21h-.958a.75.75 0 0 1 0-1.5M13.75 15a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0 0 1.5zM8 14.25a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 .75.75m12.25.75a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0 0 1.5z",
        clipRule: "evenodd"
      }
    )
  }
), k7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.25 19v-.934a.75.75 0 0 1 1.5 0V19c0 .138.112.25.25.25h.934a.75.75 0 0 1 0 1.5H5A1.75 1.75 0 0 1 3.25 19m7.35.25a.75.75 0 0 1 0 1.5H8.733a.75.75 0 0 1 0-1.5zm4.667 0a.75.75 0 0 1 0 1.5H13.4a.75.75 0 0 1 0-1.5zM19.25 19v-.934a.75.75 0 0 1 1.5 0V19A1.75 1.75 0 0 1 19 20.75h-.934a.75.75 0 0 1 0-1.5H19a.25.25 0 0 0 .25-.25m-16-3.733V13.4a.75.75 0 0 1 1.5 0v1.867a.75.75 0 0 1-1.5 0m16 0V13.4a.75.75 0 0 1 1.5 0v1.867a.75.75 0 0 1-1.5 0m-16-4.667V8.733a.75.75 0 0 1 1.5 0V10.6a.75.75 0 0 1-1.5 0m16 0V8.733a.75.75 0 0 1 1.5 0V10.6a.75.75 0 0 1-1.5 0m-16-4.666V5c0-.966.784-1.75 1.75-1.75h.934a.75.75 0 0 1 0 1.5H5a.25.25 0 0 0-.25.25v.934a.75.75 0 0 1-1.5 0m16 0V5a.25.25 0 0 0-.25-.25h-.934a.75.75 0 0 1 0-1.5H19c.966 0 1.75.784 1.75 1.75v.934a.75.75 0 0 1-1.5 0M10.6 3.25a.75.75 0 0 1 0 1.5H8.733a.75.75 0 1 1 0-1.5zm4.667 0a.75.75 0 0 1 0 1.5H13.4a.75.75 0 0 1 0-1.5zM7 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0m0 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0" })
  }
), D7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m4.5 12.156 14-8c.313-.187.75-.187 1.063.031a.98.98 0 0 1 .406.97l-2 13c-.094.624-.782 1.03-1.375.78l-3.875-1.625-1.938 2.344A1.01 1.01 0 0 1 10 20c-.563 0-1-.438-1-1v-3.25l-4.406-1.813c-.75-.312-.813-1.374-.094-1.78Zm1.625.781 3.844 1.594-.031-.031 6.843-7.656zm10.469 4.376 1.468-9.657-6.687 7.469z" })
  }
), S7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M19.563 4.187a.98.98 0 0 1 .406.97l-2 13c-.032.312-.219.562-.5.718a.96.96 0 0 1-.875.063L11 16.593v-.407l4.875-6.375c.156-.187.125-.5-.063-.687-.218-.156-.5-.156-.687.031L9.562 14.97l-.437.437A.47.47 0 0 0 9 15.75l-.906-.344-3.5-1.469C4.25 13.781 4 13.47 4 13.063a.93.93 0 0 1 .5-.907l14-8c.313-.187.75-.187 1.063.031"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M15.875 9.813 11 16.187v.407l1.875.781-2.156 2.313a.97.97 0 0 1-1.094.25A.99.99 0 0 1 9 19v-3.5a.47.47 0 0 1 .125-.344l.406-.406 5.594-5.594a.524.524 0 0 1 .688-.031c.187.188.218.5.062.688"
        }
      )
    ]
  }
), P7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 2c.398 0 .773.047 1.148.117.188.047.516.14.704.469.046.094.07.187.093.281l.235.914c.023.117.258.258.398.211l.89-.258c.095-.023.188-.046.282-.046.375 0 .633.234.75.374a6 6 0 0 1 1.172 2.016c.07.188.14.516-.07.82a.9.9 0 0 1-.188.235l-.656.656c-.117.094-.117.352 0 .445l.656.657c.07.07.14.14.188.234.187.305.117.633.07.82a6 6 0 0 1-1.172 2.016c-.117.14-.375.375-.75.375-.094 0-.188-.024-.281-.047l-.89-.281c-.142-.024-.376.094-.4.234l-.234.914a1.3 1.3 0 0 1-.093.281c-.188.329-.516.422-.704.47-.375.07-.75.093-1.148.093s-.797-.023-1.172-.094c-.187-.047-.516-.14-.703-.469-.047-.093-.07-.187-.094-.28l-.234-.915c-.024-.14-.258-.258-.375-.234l-.89.281c-.095.024-.212.024-.305.047-.375 0-.633-.234-.75-.375a6 6 0 0 1-1.172-2.016c-.047-.187-.118-.515.07-.843.047-.07.117-.165.188-.235l.68-.633c.093-.093.093-.351 0-.445l-.68-.656c-.07-.07-.141-.14-.188-.235-.188-.304-.117-.632-.07-.82.257-.75.656-1.43 1.172-2.016.117-.14.375-.375.75-.375.093 0 .21.024.304.047l.89.258c.118.047.352-.094.376-.21l.234-.915c.024-.094.047-.187.094-.281.188-.328.516-.422.703-.469A6.4 6.4 0 0 1 8 2m-.89 1.219-.212.82c-.187.75-1.054 1.266-1.804 1.055l-.82-.258a5.6 5.6 0 0 0-.891 1.547l.633.586c.562.539.562 1.547 0 2.086l-.633.586c.21.562.515 1.078.89 1.546l.82-.257c.75-.211 1.618.304 1.805 1.054l.211.82a4.6 4.6 0 0 0 1.782 0l.187-.82c.188-.75 1.055-1.265 1.805-1.054l.82.258c.375-.47.68-.985.89-1.547l-.609-.586c-.562-.54-.562-1.547 0-2.086l.61-.586a5.7 5.7 0 0 0-.89-1.547l-.821.258c-.727.21-1.617-.305-1.805-1.055l-.187-.82a4.6 4.6 0 0 0-1.782 0ZM6.874 8c0 .422.21.773.563.984.328.211.773.211 1.125 0 .328-.21.562-.562.562-.984 0-.398-.234-.75-.563-.96a1.08 1.08 0 0 0-1.124 0 1.11 1.11 0 0 0-.563.96M8 10.25c-.82 0-1.547-.422-1.969-1.125a2.27 2.27 0 0 1 0-2.25C6.453 6.195 7.18 5.75 8 5.75c.797 0 1.523.445 1.945 1.125.399.703.399 1.57 0 2.25C9.523 9.828 8.797 10.25 8 10.25" })
  }
), T7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 4a8.3 8.3 0 0 1 1.531.156c.25.063.688.188.938.625.062.125.094.25.125.375l.312 1.219c.031.156.344.344.531.281l1.188-.343c.125-.032.25-.063.375-.063.5 0 .844.313 1 .5a8 8 0 0 1 1.563 2.688c.093.25.187.687-.094 1.093a1.2 1.2 0 0 1-.25.313l-.875.875c-.157.125-.157.469 0 .594l.875.874c.093.094.187.188.25.313.25.406.156.844.093 1.094A8 8 0 0 1 18 17.28c-.156.188-.5.5-1 .5-.125 0-.25-.031-.375-.062l-1.188-.375c-.187-.032-.5.125-.53.312l-.313 1.219c-.031.125-.063.25-.125.375-.25.438-.688.563-.938.625-.5.094-1 .125-1.531.125a8.6 8.6 0 0 1-1.563-.125c-.25-.063-.687-.188-.937-.625-.063-.125-.094-.25-.125-.375l-.313-1.219c-.03-.187-.343-.343-.5-.312l-1.187.375c-.125.031-.281.031-.406.062-.5 0-.844-.312-1-.5a8 8 0 0 1-1.563-2.687c-.062-.25-.156-.688.094-1.125a2 2 0 0 1 .25-.313l.906-.844c.125-.124.125-.468 0-.593l-.906-.875a1.2 1.2 0 0 1-.25-.313c-.25-.406-.156-.844-.094-1.094.344-1 .875-1.906 1.563-2.687.156-.188.5-.5 1-.5.125 0 .281.031.406.063l1.188.343c.156.063.468-.125.5-.281l.312-1.219c.031-.125.063-.25.125-.375.25-.437.688-.562.938-.625A8.5 8.5 0 0 1 12 4m-1.188 1.625-.28 1.094c-.25 1-1.407 1.687-2.407 1.406l-1.094-.344a7.5 7.5 0 0 0-1.187 2.063l.843.781c.75.719.75 2.063 0 2.781l-.843.781c.281.75.687 1.438 1.187 2.063l1.094-.344c1-.281 2.156.406 2.406 1.406l.281 1.094c.75.157 1.594.157 2.376 0l.25-1.093c.25-1 1.406-1.688 2.406-1.407l1.094.344a7.5 7.5 0 0 0 1.187-2.063l-.813-.78c-.75-.72-.75-2.063 0-2.782l.813-.781a7.5 7.5 0 0 0-1.188-2.063l-1.093.344c-.969.281-2.156-.406-2.406-1.406l-.25-1.094a6.1 6.1 0 0 0-2.376 0M10.5 12c0 .563.281 1.031.75 1.313.438.28 1.031.28 1.5 0 .438-.282.75-.75.75-1.313 0-.531-.313-1-.75-1.281-.469-.281-1.063-.281-1.5 0-.469.281-.75.75-.75 1.281m1.5 3a3.03 3.03 0 0 1-2.625-1.5c-.531-.906-.531-2.063 0-3C9.938 9.594 10.906 9 12 9c1.063 0 2.031.594 2.594 1.5.531.938.531 2.094 0 3-.563.938-1.531 1.5-2.594 1.5" })
  }
), _7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.25 3.5 6.656 6.125H9.82zm2.883 2.625a.72.72 0 0 1 0 .75.71.71 0 0 1-.633.375H6c-.281 0-.54-.14-.656-.375a.72.72 0 0 1 0-.75l2.25-3.75A.75.75 0 0 1 8.25 2c.258 0 .492.14.633.375zM12.375 9.5h-3v3h3zM9.187 8.375h3.376a.94.94 0 0 1 .937.938v3.374c0 .54-.422.938-.938.938H9.188a.91.91 0 0 1-.938-.938V9.313c0-.516.398-.938.938-.938ZM6.376 11c0-.656-.375-1.266-.938-1.617a1.91 1.91 0 0 0-1.875 0A1.89 1.89 0 0 0 2.625 11c0 .68.352 1.29.938 1.64a1.9 1.9 0 0 0 1.874 0c.563-.35.938-.96.938-1.64ZM1.5 11c0-1.055.563-2.04 1.5-2.578a2.99 2.99 0 0 1 3 0C6.914 8.96 7.5 9.945 7.5 11A3.03 3.03 0 0 1 6 13.602a2.99 2.99 0 0 1-3 0A2.98 2.98 0 0 1 1.5 11" })
  }
), O7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m13 6-2.125 3.5h4.219zm3.844 3.5a.96.96 0 0 1 0 1c-.157.313-.5.5-.844.5h-6c-.375 0-.719-.188-.875-.5a.96.96 0 0 1 0-1l3-5a.987.987 0 0 1 1.719 0zM18.5 14h-4v4h4zm-4.25-1.5h4.5c.688 0 1.25.563 1.25 1.25v4.5c0 .719-.563 1.25-1.25 1.25h-4.5c-.719 0-1.25-.531-1.25-1.25v-4.5c0-.688.531-1.25 1.25-1.25M10.5 16c0-.875-.5-1.688-1.25-2.156-.781-.438-1.75-.438-2.5 0-.781.469-1.25 1.281-1.25 2.156 0 .906.469 1.719 1.25 2.188.75.437 1.719.437 2.5 0 .75-.47 1.25-1.282 1.25-2.188M4 16c0-1.406.75-2.719 2-3.438a3.98 3.98 0 0 1 4 0c1.219.72 2 2.032 2 3.438 0 1.438-.781 2.75-2 3.469a3.98 3.98 0 0 1-4 0A3.98 3.98 0 0 1 4 16" })
  }
), U7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.531 4.219 16 7.719c.313.312.313.781 0 1.062-.281.313-.75.313-1.063 0L12.72 6.562v7.688c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75V6.562L9 8.783a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063l3.5-3.5c.281-.282.75-.282 1.062 0ZM6.25 5h.25a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-.25a.74.74 0 0 0-.75.75v10.5c0 .438.313.75.75.75h11.5a.74.74 0 0 0 .75-.75V7.25a.76.76 0 0 0-.75-.75h-.25a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h.25C18.969 5 20 6.031 20 7.25v10.5A2.26 2.26 0 0 1 17.75 20H6.25C5 20 4 19 4 17.75V7.25C4 6.031 5 5 6.25 5" })
  }
), q7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m12.43 2.695 4.062 4.063a.66.66 0 0 1 0 .898.66.66 0 0 1-.898 0l-2.969-3.008V15a.64.64 0 0 1-.625.625.617.617 0 0 1-.625-.625V4.648L8.367 7.656a.66.66 0 0 1-.898 0 .66.66 0 0 1 0-.898l4.062-4.063a.66.66 0 0 1 .899 0M4.5 3.75h1.25c.313 0 .625.313.625.625A.64.64 0 0 1 5.75 5H4.5c-.703 0-1.25.586-1.25 1.25V20c0 .703.547 1.25 1.25 1.25h15c.664 0 1.25-.547 1.25-1.25V6.25c0-.664-.586-1.25-1.25-1.25h-1.25a.617.617 0 0 1-.625-.625c0-.313.273-.625.625-.625h1.25c1.367 0 2.5 1.133 2.5 2.5V20c0 1.406-1.133 2.5-2.5 2.5h-15A2.47 2.47 0 0 1 2 20V6.25c0-1.367 1.094-2.5 2.5-2.5" })
  }
), I7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.5 18c0 .281.219.5.5.5h8c.25 0 .5-.219.5-.5V9H14c-.563 0-1-.438-1-1V5.5H8c-.281 0-.5.25-.5.5zM8 4h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V18c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2m1 3h2.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H9a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m0 2h2.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H9a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m1.688 6.938C10.5 16.593 9.905 17 9.25 17H9a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5h.25a.47.47 0 0 0 .469-.344l.469-1.531A.835.835 0 0 1 11 13.5c.344 0 .688.25.781.594l.344 1.187a1.12 1.12 0 0 1 .75-.281c.406 0 .781.25.969.625l.187.375H15c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-1.25a.55.55 0 0 1-.469-.25l-.312-.688c-.031-.03-.063-.062-.094-.062-.063 0-.094.031-.125.063l-.313.687a.51.51 0 0 1-.5.25c-.187 0-.374-.156-.437-.344l-.5-1.75-.313 1.031Z" })
  }
), W7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.5 8v1.25a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75V8a3 3 0 0 1 6 0v.25c0 .719-.063 1.406-.156 2.094L16 9.063c.281-.094.594-.032.781.187.188.188.25.5.157.781l-.875 2.469h3.187a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H15c-.25 0-.5-.094-.625-.313-.156-.187-.188-.437-.094-.687l.75-2.063L11.562 12l-.03.156a16 16 0 0 1-2 4.969l-.47.813A2.16 2.16 0 0 1 7.188 19 2.174 2.174 0 0 1 5 16.812V14.5c0-1.219.781-2.281 1.938-2.625l3.343-1.063c.125-.843.219-1.687.219-2.562V8c0-.813-.688-1.5-1.5-1.5A1.5 1.5 0 0 0 7.5 8m-.125 5.281A1.28 1.28 0 0 0 6.5 14.5v2.344c0 .375.281.687.688.687.218 0 .437-.156.562-.343l.5-.844A15 15 0 0 0 9.906 12.5zM4 15.5V17H2.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75zm6.75 1.5q.422-.704.75-1.5h9.75a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z" })
  }
), $7 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M4 15.5V17H2.75a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75zm6.844 1.5c.25-.469.5-.969.687-1.5h9.719a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M9 7c-.563 0-1 .469-1 1v1c0 .563-.469 1-1 1-.563 0-1-.438-1-1V8a3 3 0 0 1 6 0v.25c0 .656-.063 1.313-.125 1.969l3.813-1.156c.374-.126.75 0 1.03.25.25.28.345.656.22 1.03l-.563 1.688H19c.531 0 1 .438 1 1 0 .531-.469 1-1 1h-4a.94.94 0 0 1-.813-.437c-.218-.25-.25-.594-.156-.906l.406-1.157-2.968.875c-.375 1.656-.969 3.25-1.813 4.719l-.437.75a2.26 2.26 0 0 1-1.969 1.156C6 19.031 5 18 5 16.75V14.5c0-1.313.844-2.5 2.125-2.875l2.625-.781c.156-.844.219-1.719.219-2.594V8c0-.531-.438-1-1-1zm.219 6.094-1.531.437c-.407.125-.688.531-.688.969v2.25c0 .156.094.25.25.25.094 0 .188-.031.219-.125l.437-.75c.563-.969 1-2 1.313-3.031"
        }
      )
    ]
  }
), Y7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16.25 6.25v1.5h1.5v-1.5zM16 5h2c.531 0 1 .469 1 1v2c0 .563-.469 1-1 1h-.25v6H18c.531 0 1 .469 1 1v2c0 .563-.469 1-1 1h-2c-.563 0-1-.438-1-1v-.25H9V18c0 .563-.469 1-1 1H6c-.563 0-1-.438-1-1v-2c0-.531.438-1 1-1h.25V9H6c-.563 0-1-.438-1-1V6c0-.531.438-1 1-1h2c.531 0 1 .469 1 1v.25h6V6c0-.531.438-1 1-1M7.75 15H8c.531 0 1 .469 1 1v.25h6V16c0-.531.438-1 1-1h.25V9H16c-.563 0-1-.438-1-1v-.25H9V8c0 .563-.469 1-1 1h-.25zm-1.5 2.75h1.5v-1.5h-1.5zm10 0h1.5v-1.5h-1.5zm-10-10h1.5v-1.5h-1.5z" })
  }
), G7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M1.602 10.836c-.235-.211-.235-.563 0-.797.21-.21.562-.21.796 0l1.29 1.313v-8.04c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563v8.039l1.289-1.29a.513.513 0 0 1 .773 0 .513.513 0 0 1 0 .774l-2.25 2.25a.513.513 0 0 1-.773 0zm6.96 2.414A.54.54 0 0 1 8 12.687c0-.304.234-.562.563-.562h1.124a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H8.563Zm0-3A.54.54 0 0 1 8 9.687c0-.304.234-.562.563-.562h2.624a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H8.563Zm0-3A.54.54 0 0 1 8 6.687c0-.304.234-.562.563-.562h4.124a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H8.564Zm0-3A.54.54 0 0 1 8 3.687c0-.304.234-.562.563-.562h5.624a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562H8.564Z" })
  }
), N7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.469 5.219a.736.736 0 0 1 1.031 0l3 3c.313.312.313.781 0 1.062a.684.684 0 0 1-1.031 0L7.75 7.562V18.25A.74.74 0 0 1 7 19a.72.72 0 0 1-.75-.75V7.562l-1.719 1.72c-.312.312-.781.312-1.062 0a.684.684 0 0 1 0-1.032l3-3zM12.75 19a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75zm0-4a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h3.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75zm0-4a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h5.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75zm0-4a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h7.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z" })
  }
), J7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.469 15.281c-.313-.281-.313-.75 0-1.062.281-.281.75-.281 1.062 0l1.719 1.75V5.25A.74.74 0 0 1 7 4.5a.76.76 0 0 1 .75.75v10.719l1.719-1.719a.684.684 0 0 1 1.031 0 .684.684 0 0 1 0 1.031l-3 3a.684.684 0 0 1-1.031 0zM12.75 18.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h1.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75zm0-4a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h3.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75zm0-4a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h5.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75zm0-4a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h7.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z" })
  }
), K7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.5 18c0 .281.219.5.5.5h8c.25 0 .5-.219.5-.5V9H14c-.563 0-1-.438-1-1V5.5H8c-.281 0-.5.25-.5.5zM8 4h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V18c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2m3.5 8h-2v1.5h2zm-2 2.5V16h2v-1.5zm3 0V16h2v-1.5zM12 17H9.5c-.563 0-1-.438-1-1v-4c0-.531.438-1 1-1h5c.531 0 1 .469 1 1v4c0 .563-.469 1-1 1zm.5-3.5h2V12h-2z" })
  }
), Q7 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M17 6.5H7c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5m2 .5v10c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2h10c1.094 0 2 .906 2 2m-9 1.5h4.719a.74.74 0 0 1 .75.75v5c0 .438-.313.75-.75.75a.74.74 0 0 1-.75-.75v-3.188l-4.219 4.22a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063L12.938 10H10a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75" })
  }
), l6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 4c.313 0 .594.219.688.531L14.28 9.5h4.969c.313 0 .594.219.688.531.125.281 0 .625-.25.813l-4.094 3.187 1.594 5a.7.7 0 0 1-.282.844.75.75 0 0 1-.875 0L12 16.719l-4.063 3.125a.706.706 0 0 1-.875.031.7.7 0 0 1-.28-.844l1.593-5-4.094-3.187a.74.74 0 0 1-.25-.813.74.74 0 0 1 .719-.531h4.938l1.593-4.969A.74.74 0 0 1 12 4m0 3.25-1.063 3.25a.7.7 0 0 1-.687.5H6.906l2.782 2.188c.25.187.343.5.25.812l-1 3.188 2.593-2a.71.71 0 0 1 .906 0l2.594 2-1-3.188a.73.73 0 0 1 .25-.813L17.062 11H13.75c-.344 0-.625-.188-.719-.5z" })
  }
), c6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M19.25 8c.987 0 1.795.653 2.093 1.51.399 1.013-.08 2.012-.735 2.516l.001.001-3.268 2.544 1.276 4.005h-.002c.338.976-.07 1.962-.81 2.497l.001.002q-.021.015-.046.031l-.022.017a2.2 2.2 0 0 1-2.626-.096v.002l-3.116-2.416-3.144 2.42v-.002a2.2 2.2 0 0 1-2.622.09v.002q-.02-.015-.039-.028l-.028-.02c-.74-.535-1.148-1.523-.81-2.499l1.275-4.005-3.268-2.544h.001c-.651-.502-1.129-1.494-.74-2.502A2.24 2.24 0 0 1 4.75 8v1.5l-.126.01a.74.74 0 0 0-.593.521c-.125.281 0 .625.25.813l4.094 3.187-1.594 5h-.002.002l-.035.118a.71.71 0 0 0 .316.726c.25.188.625.187.875-.031L12 16.719l4.031 3.125c.25.218.625.218.875.031.281-.188.406-.531.281-.844l-1.594-5 4.094-3.187c.25-.188.375-.531.25-.813a.74.74 0 0 0-.572-.521l-.115-.01zm-7.06-5.492c.924.08 1.663.734 1.924 1.565h.002L15.376 8h3.874v1.5h-4.97l-1.594-4.969A.73.73 0 0 0 12 4a.74.74 0 0 0-.719.531L9.687 9.5H4.75V8h3.844l1.26-3.927A2.24 2.24 0 0 1 12 2.5z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#F2D30A",
          d: "M14.281 9.5h4.969c.313 0 .594.219.688.531.125.281 0 .625-.25.813l-4.094 3.187 1.594 5a.7.7 0 0 1-.282.844.706.706 0 0 1-.875-.031L12 16.719l-4.063 3.125a.706.706 0 0 1-.875.031.7.7 0 0 1-.28-.844l1.593-5-4.094-3.187c-.25-.188-.375-.531-.25-.813A.74.74 0 0 1 4.75 9.5h4.938l1.593-4.969A.74.74 0 0 1 12 4c.313 0 .594.219.688.531L14.28 9.5Z"
        }
      )
    ]
  }
), a6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.656 2.422 1.524 3.117 3.351.492a.76.76 0 0 1 .61.516.7.7 0 0 1-.188.75L11.516 9.71l.586 3.422a.74.74 0 0 1-.305.726c-.235.188-.54.188-.797.07l-3-1.617-3.023 1.618a.72.72 0 0 1-.774-.07.74.74 0 0 1-.305-.727l.563-3.422-2.438-2.414c-.187-.188-.257-.492-.187-.75a.76.76 0 0 1 .61-.516l3.374-.49 1.5-3.117A.73.73 0 0 1 8 2a.72.72 0 0 1 .656.422" })
  }
), t6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.688 4.531 14.28 9.5h4.969c.313 0 .594.219.688.531.125.281 0 .625-.25.813l-4.094 3.187 1.594 5a.7.7 0 0 1-.282.844.706.706 0 0 1-.875-.031L12 16.719l-4.063 3.125a.706.706 0 0 1-.875.031.7.7 0 0 1-.28-.844l1.593-5-4.094-3.187a.74.74 0 0 1-.25-.813.74.74 0 0 1 .719-.531h4.938l1.593-4.969A.74.74 0 0 1 12 4c.313 0 .594.219.688.531" })
  }
), h6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10.5 17v.5l2.25-1.688c.25-.187.563-.312.906-.312H18c.25 0 .5-.219.5-.5V6c0-.25-.25-.5-.5-.5H6c-.281 0-.5.25-.5.5v9c0 .281.219.5.5.5h3c.813 0 1.5.688 1.5 1.5m-.031 2.406-.156.094-.532.406c-.156.125-.344.125-.531.063A.51.51 0 0 1 9 19.5V17H6c-1.125 0-2-.875-2-2V6c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v9c0 1.125-.906 2-2 2h-4.344L10.5 19.375zM9.28 7.688A1.745 1.745 0 0 1 10.937 6.5h1.813c1.094 0 1.969.906 1.969 2 0 .688-.375 1.344-.969 1.688l-1.031.593c0 .406-.313.719-.75.719a.74.74 0 0 1-.75-.75v-.406c0-.281.156-.531.406-.656L13 8.905a.46.46 0 0 0 .219-.406c0-.281-.188-.5-.469-.5h-1.813c-.093 0-.187.094-.218.188l-.031.03a.76.76 0 0 1-.938.47.78.78 0 0 1-.469-.97v-.03ZM13 13.5c0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1 .531 0 1 .469 1 1" })
  }
), e6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.5 12.25h5.75V9H5.5zm0 1.5V17c0 .281.219.5.5.5h5.25v-3.75zm7.25 3.75H18c.25 0 .5-.219.5-.5v-3.25h-5.75zm5.75-5.25V9h-5.75v3.25zM6 5h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2" })
  }
), r6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.367 2.75c.399 0 .774.164 1.055.445l4.125 4.125a1.514 1.514 0 0 1 0 2.133L9.43 12.57a1.514 1.514 0 0 1-2.133 0L3.172 8.445a1.47 1.47 0 0 1-.422-1.054V3.875c0-.61.492-1.125 1.125-1.125zM3.875 7.39a.35.35 0 0 0 .094.258l4.125 4.125c.14.141.398.141.539 0l3.117-3.117a.357.357 0 0 0 0-.539L7.625 3.992a.38.38 0 0 0-.258-.117H3.875v3.516Zm1.5-2.765c.398 0 .75.352.75.75 0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75" })
  }
), i6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.156 5c.531 0 1.031.219 1.406.594l5.5 5.5a2.02 2.02 0 0 1 0 2.844l-4.156 4.156a2.02 2.02 0 0 1-2.844 0l-5.5-5.5A1.96 1.96 0 0 1 5 11.188V6.5A1.5 1.5 0 0 1 6.5 5zM6.5 11.188c0 .124.031.25.125.343l5.5 5.5a.53.53 0 0 0 .719 0L17 12.875a.476.476 0 0 0 0-.719l-5.5-5.5a.5.5 0 0 0-.344-.156H6.5zm2-3.688c.531 0 1 .469 1 1 0 .563-.469 1-1 1-.563 0-1-.438-1-1 0-.531.438-1 1-1" })
  }
), s6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#fff",
          d: "M7.867 1.75c.678 0 1.304.28 1.762.738l4.125 4.125c.976.977.976 2.57 0 3.547l-3.117 3.117a2.513 2.513 0 0 1-3.547 0L2.965 9.152a2.47 2.47 0 0 1-.715-1.761V3.875c0-1.148.926-2.125 2.125-2.125v1c-.633 0-1.125.516-1.125 1.125v3.516c0 .398.14.773.422 1.054l4.125 4.125a1.514 1.514 0 0 0 2.133 0l3.117-3.117a1.514 1.514 0 0 0 0-2.133L8.922 3.195a1.5 1.5 0 0 0-1.055-.445zM6.125 5.375a.25.25 0 0 0-.076-.174.25.25 0 0 0-.349-.008.26.26 0 0 0-.075.182c0 .097.04.156.067.183a.25.25 0 0 0 .183.067v.5a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75.398 0 .75.352.75.75 0 .422-.352.75-.75.75v-.5a.26.26 0 0 0 .182-.075.25.25 0 0 0 .068-.175M7.867 1.75v1H4.375v-1z"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#D9D9D9",
          d: "M4.375 2.75h3.492c.399 0 .774.164 1.055.445l4.125 4.125a1.514 1.514 0 0 1 0 2.133L9.93 12.57a1.514 1.514 0 0 1-2.133 0L3.672 8.445a1.47 1.47 0 0 1-.422-1.054V3.875c0-.61.492-1.125 1.125-1.125m1.5 3.375c.398 0 .75-.328.75-.75a.77.77 0 0 0-.75-.75.755.755 0 0 0-.75.75c0 .422.328.75.75.75"
        }
      )
    ]
  }
), o6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m14.781 5.25 3.969 4.031a4.206 4.206 0 0 1 0 5.969l-3.5 3.531c-.281.313-.75.313-1.063.032-.28-.313-.28-.782 0-1.063l3.5-3.563a2.716 2.716 0 0 0 0-3.843l-4-4.063c-.28-.281-.28-.75.032-1.062.281-.282.75-.282 1.062.031M4 11.188V6.5A1.5 1.5 0 0 1 5.5 5h4.656c.531 0 1.031.219 1.406.594l5.25 5.25a2.02 2.02 0 0 1 0 2.844l-4.156 4.156a2.02 2.02 0 0 1-2.844 0l-5.25-5.25A1.96 1.96 0 0 1 4 11.188M8.5 8.5c0-.531-.469-1-1-1-.563 0-1 .469-1 1 0 .563.438 1 1 1 .531 0 1-.438 1-1" })
  }
), n6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16.5 18V9H14c-.563 0-1-.438-1-1V5.5H8c-.281 0-.5.25-.5.5v12c0 .281.219.5.5.5h8c.25 0 .5-.219.5-.5M6 6c0-1.094.875-2 2-2h5.156c.531 0 1.031.219 1.406.594l2.844 2.843c.375.375.594.875.594 1.407V18c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2zm6 4.75c.344 0 .625.281.625.625v.313c.219.03.438.093.625.124.344.094.563.438.469.75a.6.6 0 0 1-.75.47c-.344-.063-.688-.126-1-.126-.25-.031-.5.031-.688.125-.156.094-.156.156-.156.188 0 .031.031.062.125.125.188.094.5.187.906.281.344.094.813.219 1.156.438.376.218.782.593.782 1.218.031.656-.344 1.094-.781 1.313a2 2 0 0 1-.72.25v.312a.627.627 0 0 1-.624.625.627.627 0 0 1-.625-.625v-.343c-.313-.063-.594-.157-.844-.22-.063-.03-.125-.03-.188-.062a.625.625 0 0 1-.437-.781.597.597 0 0 1 .781-.406c.094 0 .156.031.219.062.438.125.781.219 1.125.219.281.031.531-.031.719-.125.125-.063.156-.125.156-.219 0 0 0-.062-.156-.156a5.3 5.3 0 0 0-.906-.281l-.032-.031c-.344-.094-.781-.22-1.125-.376-.375-.218-.781-.593-.781-1.218-.031-.656.406-1.063.813-1.281.218-.126.437-.188.687-.25v-.313c0-.344.281-.625.625-.625M9 7h2.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H9a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m0 2h2.5c.25 0 .5.25.5.5 0 .281-.25.5-.5.5H9a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5" })
  }
), v6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#9CCAFF",
          d: "M6 6c0-1.094.875-2 2-2h5v4c0 .563.438 1 1 1h4v9c0 1.125-.906 2-2 2H8c-1.125 0-2-.875-2-2zm2 .5c0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5h-2c-.281 0-.5.25-.5.5m0 2c0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5h-2c-.281 0-.5.25-.5.5m4 2.25c-.281 0-.5.25-.5.5v.563a2.3 2.3 0 0 0-.781.25c-.406.25-.719.687-.719 1.28 0 .563.313.938.688 1.157.343.219.75.344 1.093.438h.063c.375.124.687.218.906.374.188.094.219.22.219.344.031.219-.063.344-.219.438-.188.125-.469.187-.75.187-.375-.031-.719-.156-1.125-.281-.094-.031-.156-.063-.219-.094-.281-.062-.562.063-.656.344a.53.53 0 0 0 .313.625c.062 0 .156.031.218.063.281.093.594.218.969.28v.532c0 .281.219.5.5.5.25 0 .5-.219.5-.5v-.531c.25-.032.531-.125.781-.282.406-.25.719-.687.719-1.28-.031-.595-.344-.97-.719-1.22A5.6 5.6 0 0 0 12.156 14h-.031c-.406-.125-.688-.219-.906-.344-.188-.125-.219-.219-.219-.312 0-.188.063-.313.25-.406.188-.126.469-.188.719-.188.312.031.656.094 1 .188.281.062.562-.094.625-.376a.5.5 0 0 0-.344-.593 6 6 0 0 0-.75-.156v-.563c0-.25-.25-.5-.5-.5"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#398AE7",
          d: "M18 9h-4c-.563 0-1-.438-1-1V4zm-5.5 2.25v.563c.25.03.5.093.75.156.25.062.406.344.344.594-.063.28-.344.437-.625.374a6 6 0 0 0-1-.187c-.25 0-.531.063-.719.188-.188.093-.25.218-.25.406 0 .094.031.187.219.312.219.125.5.219.906.344h.031c.344.094.781.25 1.125.438.375.25.688.624.719 1.218 0 .594-.313 1.031-.719 1.281-.25.157-.531.25-.781.282v.562c0 .25-.25.5-.5.5-.281 0-.5-.25-.5-.5v-.562c-.375-.063-.688-.188-.969-.282a.6.6 0 0 0-.219-.062.53.53 0 0 1-.312-.625c.094-.281.375-.406.656-.344.063.031.125.063.219.094.406.125.75.25 1.125.281.281 0 .563-.062.75-.187.156-.094.25-.219.219-.438 0-.125-.031-.25-.219-.344-.219-.156-.531-.25-.906-.374h-.063c-.344-.094-.75-.22-1.094-.438-.374-.219-.687-.594-.687-1.156 0-.594.313-1.031.719-1.281.25-.126.5-.22.781-.25v-.563c0-.25.219-.5.5-.5.25 0 .5.25.5.5"
        }
      )
    ]
  }
), w6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.25 20V10h-4.375A1.85 1.85 0 0 1 12 8.125V3.75H7c-.703 0-1.25.586-1.25 1.25v15c0 .703.547 1.25 1.25 1.25h10c.664 0 1.25-.547 1.25-1.25m-.04-11.25c-.038-.078-.077-.195-.155-.273l-4.532-4.532c-.078-.078-.195-.117-.273-.156v4.336c0 .352.273.625.625.625zM4.5 5c0-1.367 1.094-2.5 2.5-2.5h6.094c.469 0 .976.234 1.328.586l4.492 4.492c.352.352.586.86.586 1.328V20c0 1.406-1.133 2.5-2.5 2.5H7A2.47 2.47 0 0 1 4.5 20zm2.5.625C7 5.312 7.273 5 7.625 5h2.5c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625h-2.5A.617.617 0 0 1 7 5.625m0 2.5c0-.313.273-.625.625-.625h2.5c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625h-2.5A.617.617 0 0 1 7 8.125m5.625 3.906v.547c.313.04.625.078.898.156a.62.62 0 0 1 .47.743.617.617 0 0 1-.743.468c-.43-.078-.86-.156-1.29-.156-.312-.039-.702.04-.937.195-.234.118-.273.235-.273.352 0 .078 0 .156.234.273.274.157.664.235 1.172.391.43.117.977.273 1.406.508.47.234.899.703.938 1.406 0 .742-.43 1.211-.938 1.523-.273.157-.624.235-.937.313v.508a.64.64 0 0 1-.625.625.617.617 0 0 1-.625-.625v-.547a9 9 0 0 1-1.21-.313c-.08-.039-.157-.039-.235-.078-.313-.078-.508-.43-.43-.78.117-.313.469-.509.781-.43.117.038.196.078.274.117.547.156.976.273 1.445.273.39.04.742-.04.977-.156.195-.117.273-.274.273-.43 0-.078-.04-.195-.273-.312-.274-.157-.665-.274-1.172-.391l-.04-.04c-.43-.116-.937-.233-1.367-.468-.43-.234-.898-.664-.898-1.367 0-.742.469-1.211.938-1.484.312-.157.624-.235.937-.274v-.547c0-.351.273-.625.625-.625s.625.274.625.625" })
  }
), x6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M3.856 7.606a3.75 3.75 0 0 1 3.75-3.75h8.72a3.75 3.75 0 0 1 3.75 3.75v8.72a3.75 3.75 0 0 1-3.75 3.75h-8.72a3.75 3.75 0 0 1-3.75-3.75zm3.75-2.25a2.25 2.25 0 0 0-2.25 2.25v1.157h13.22V7.606a2.25 2.25 0 0 0-2.25-2.25zm-2.25 10.97v-6.063h3.407v8.313H7.606a2.25 2.25 0 0 1-2.25-2.25m4.907 2.25h6.063a2.25 2.25 0 0 0 2.25-2.25v-6.063h-8.313z",
        clipRule: "evenodd"
      }
    )
  }
), d6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M1.653 5.251a3.75 3.75 0 0 1 3.75-3.75h13.194a3.75 3.75 0 0 1 3.75 3.75V18.75a3.75 3.75 0 0 1-3.75 3.75H5.403a3.75 3.75 0 0 1-3.75-3.75V5.25Zm3.75-2.25a2.25 2.25 0 0 0-2.25 2.25v2.75h17.694V5.25A2.25 2.25 0 0 0 18.597 3zM3.153 18.75V9.5h4.696v11.498H5.403a2.25 2.25 0 0 1-2.25-2.25ZM9.349 21h9.248a2.25 2.25 0 0 0 2.25-2.25V9.5H9.349v11.498Z",
        clipRule: "evenodd"
      }
    )
  }
), g6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M5.625 3a.625.625 0 1 0-1.25 0v2.875H2a.625.625 0 1 0 0 1.25h2.375V21a.625.625 0 1 0 1.25 0V7.125H8a.625.625 0 1 0 0-1.25H5.625zm7 0a.625.625 0 1 0-1.25 0v13.375H9a.625.625 0 1 0 0 1.25h2.375V21a.625.625 0 1 0 1.25 0v-3.375H15a.625.625 0 1 0 0-1.25h-2.375zM19 2.375c.345 0 .625.28.625.625v7.375H22a.625.625 0 1 1 0 1.25h-2.375V21a.625.625 0 1 1-1.25 0v-9.375H16a.625.625 0 1 1 0-1.25h2.375V3c0-.345.28-.625.625-.625",
        clipRule: "evenodd"
      }
    )
  }
), m6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 12 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m5.46 10.79-3-3a.76.76 0 0 1-.163-.821A.77.77 0 0 1 3 6.5h6c.305 0 .563.188.68.469a.76.76 0 0 1-.164.82l-3 3a.723.723 0 0 1-1.055 0Z" })
  }
), p6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 15 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m6.781 11.719-4-4a1.01 1.01 0 0 1-.218-1.094C2.719 6.25 3.093 6 3.5 6h8c.406 0 .75.25.906.625a1.01 1.01 0 0 1-.219 1.094l-4 4a.964.964 0 0 1-1.406 0" })
  }
), u6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 15 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.781 8.719a.964.964 0 0 1 0-1.406l4-4a1.01 1.01 0 0 1 1.094-.22A.98.98 0 0 1 9.5 4v8c0 .406-.25.781-.625.938a1.01 1.01 0 0 1-1.094-.22z" })
  }
), f6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 15 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m11.188 8.719-4 4a1.01 1.01 0 0 1-1.094.219A1.02 1.02 0 0 1 5.469 12V4c0-.406.25-.75.625-.906a1.01 1.01 0 0 1 1.093.219l4 4a.964.964 0 0 1 0 1.406Z" })
  }
), j6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 15 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.188 4.313 4 4c.28.28.374.718.218 1.093a1.01 1.01 0 0 1-.906.625h-8c-.406 0-.781-.25-.937-.625a1.01 1.01 0 0 1 .218-1.094l4-4a.964.964 0 0 1 1.407 0Z" })
  }
), M6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 12 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.21 8.539a.723.723 0 0 1 0-1.055l3-3a.76.76 0 0 1 .821-.164A.74.74 0 0 1 7.5 5v6a.77.77 0 0 1-.469.703.76.76 0 0 1-.82-.164z" })
  }
), C6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 12 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m8.766 8.539-3 3a.76.76 0 0 1-.82.164.77.77 0 0 1-.47-.703V5c0-.305.188-.563.47-.68a.76.76 0 0 1 .82.164l3 3a.723.723 0 0 1 0 1.055" })
  }
), A6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 12 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m6.516 5.234 3 3c.21.211.28.54.164.82a.76.76 0 0 1-.68.47H3a.77.77 0 0 1-.703-.47.76.76 0 0 1 .164-.82l3-3a.723.723 0 0 1 1.055 0" })
  }
), V6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15.281 11.781A3.96 3.96 0 0 0 16 9.5c0-2.188-1.813-4-4-4-2.219 0-4 1.813-4 4 0 .875.25 1.656.688 2.281.124.188.25.375.406.563.406.562.875 1.219 1.25 1.875.312.594.5 1.219.562 1.781h-1.5c-.094-.375-.187-.719-.375-1.063a13.5 13.5 0 0 0-1.094-1.624l-.468-.657A5.47 5.47 0 0 1 6.5 9.5C6.5 6.469 8.938 4 12 4c3.031 0 5.5 2.469 5.5 5.5a5.5 5.5 0 0 1-1 3.156l-.469.656a13.5 13.5 0 0 0-1.093 1.626c-.188.343-.282.687-.376 1.062h-1.5c.094-.563.25-1.188.563-1.781.375-.656.844-1.313 1.25-1.875a6 6 0 0 0 .406-.563M12 8a1.5 1.5 0 0 0-1.5 1.5c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5C9.5 8.125 10.594 7 12 7c.25 0 .5.25.5.5 0 .281-.25.5-.5.5m0 12a2.47 2.47 0 0 1-2.5-2.5V17h5v.5c0 1.406-1.125 2.5-2.5 2.5" })
  }
), z6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M18.344 8.75v.438c0 4.343-3.282 9.312-9.313 9.312-1.875 0-3.594-.531-5.031-1.469.25.032.5.063.781.063a6.6 6.6 0 0 0 4.063-1.407 3.265 3.265 0 0 1-3.063-2.28c.219.03.407.062.625.062.282 0 .594-.063.844-.125a3.285 3.285 0 0 1-2.625-3.219v-.031c.438.25.969.375 1.5.406a3.23 3.23 0 0 1-1.469-2.719c0-.625.157-1.187.438-1.656a9.52 9.52 0 0 0 6.781 3.438q-.094-.375-.094-.75a3.28 3.28 0 0 1 3.281-3.282 3.28 3.28 0 0 1 2.407 1.032 7 7 0 0 0 2.062-.813 3.2 3.2 0 0 1-1.437 1.813 6.2 6.2 0 0 0 1.875-.5c-.438.656-1 1.218-1.625 1.687" })
  }
), H6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5.25 11a.72.72 0 0 1-.75-.75v-4.5A.74.74 0 0 1 5.25 5a.76.76 0 0 1 .75.75v2.531l.625-.75C7.906 6 9.813 5 12 5c3.844 0 7 3.156 7 7 0 3.875-3.156 7-7 7a7.03 7.03 0 0 1-4.219-1.375c-.312-.25-.406-.719-.156-1.063a.75.75 0 0 1 1.063-.156A5.47 5.47 0 0 0 12 17.5c3.031 0 5.5-2.438 5.5-5.5 0-3.031-2.469-5.5-5.5-5.5-1.719 0-3.219.781-4.25 2l-.844 1H9.75a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z" })
  }
), B6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M9.873 6.314a.75.75 0 0 0-.987-1.128L5.324 8.302a.95.95 0 0 0 0 1.43l3.562 3.116a.75.75 0 0 0 .987-1.13L7.48 9.626h6.02a3.875 3.875 0 0 1 0 7.75H9.324a.625.625 0 1 0 0 1.25H13.5a5.125 5.125 0 1 0 0-10.25H7.519l2.354-2.06Z",
        clipRule: "evenodd"
      }
    )
  }
), L6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M7.058 4.22a.625.625 0 0 0-.823-.94L2.407 6.63a.825.825 0 0 0 0 1.24l3.828 3.35a.625.625 0 0 0 .823-.94L4.31 7.875H15a5.375 5.375 0 1 1 0 10.75H7.986a.625.625 0 0 0 0 1.25H15a6.625 6.625 0 1 0 0-13.25H4.31z",
        clipRule: "evenodd"
      }
    )
  }
), X6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M13.406 5.094c.344.156.594.531.594.906v12c0 .406-.25.75-.594.938a1.01 1.01 0 0 1-1.094-.188L8.095 15H6c-1.125 0-2-.875-2-2v-2c0-1.094.875-2 2-2h2.094l4.219-3.719a1.01 1.01 0 0 1 1.093-.187m5.375 2.25C20.125 8.469 21 10.125 21 12a5.97 5.97 0 0 1-2.219 4.656.744.744 0 0 1-1.062-.093c-.282-.313-.219-.782.093-1.063A4.42 4.42 0 0 0 19.5 12a4.4 4.4 0 0 0-1.688-3.469.78.78 0 0 1-.093-1.062.776.776 0 0 1 1.062-.125m-1.906 2.343C17.563 10.25 18 11.063 18 12c0 .969-.438 1.781-1.125 2.344a.754.754 0 0 1-1.063-.125.74.74 0 0 1 .126-1.031A1.55 1.55 0 0 0 16.5 12a1.48 1.48 0 0 0-.563-1.156.776.776 0 0 1-.124-1.063.78.78 0 0 1 1.062-.094" })
  }
), R6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 12 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M10 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0" })
  }
), y6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 16 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0" })
  }
), Z6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M12.688 4.531A.73.73 0 0 0 12 4a.74.74 0 0 0-.719.531L9.687 9.5H4.75a.74.74 0 0 0-.719.531c-.125.281 0 .625.25.813l4.094 3.187-1.594 5a.7.7 0 0 0 .282.844c.25.188.625.188.875-.031l3.14-2.416a5.5 5.5 0 0 1 .007-1.896l-2.148 1.655 1-3.187a.73.73 0 0 0-.25-.813L6.908 11h3.343a.7.7 0 0 0 .688-.5L12 7.25l1.031 3.25c.094.313.375.5.719.5h3.313l-.033.025c.637.061 1.241.23 1.796.49l.861-.671c.25-.188.375-.531.25-.813a.73.73 0 0 0-.687-.531h-4.969l-1.594-4.969Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M16.5 21a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-2-5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), E6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.938 9.875a.78.78 0 0 1-1 .375.75.75 0 0 1-.407-.969C6.594 6.781 9.094 5 12 5a6.15 6.15 0 0 1 4.344 1.813L18 8.469V6.75a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75v3.5a.74.74 0 0 1-.75.75h-3.5a.72.72 0 0 1-.75-.75.74.74 0 0 1 .75-.75h1.688L15.28 7.875A4.67 4.67 0 0 0 12 6.5a5.49 5.49 0 0 0-5.063 3.375Zm11.5 4.906C17.343 17.25 14.874 19 12 19c-1.656 0-3.219-.625-4.375-1.813L6 15.563v1.688a.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75v-3.5a.74.74 0 0 1 .75-.75h3.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H7.031l1.657 1.656C9.562 17.031 10.75 17.5 12 17.5c2.25 0 4.219-1.344 5.031-3.313a.767.767 0 0 1 1-.406.77.77 0 0 1 .407 1" })
  }
), b6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8.563 10.438A.555.555 0 0 1 8 11a.54.54 0 0 1-.563-.563V3.923L5.212 6.148c-.234.235-.586.235-.797 0-.234-.21-.234-.562 0-.796l3.188-3.188c.21-.21.562-.21.773 0l3.21 3.188c.212.234.212.585 0 .796-.233.235-.585.235-.796 0L8.563 3.922v6.515Zm.75-.188V9.125H12.5c.82 0 1.5.68 1.5 1.5V12.5c0 .844-.68 1.5-1.5 1.5h-9A1.48 1.48 0 0 1 2 12.5v-1.875c0-.82.656-1.5 1.5-1.5h3.188v1.125H3.5a.385.385 0 0 0-.375.375V12.5c0 .21.164.375.375.375h9a.385.385 0 0 0 .375-.375v-1.875a.4.4 0 0 0-.375-.375H9.312ZM11 11.563c0-.305.234-.563.563-.563a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.562.54.54 0 0 1-.562-.563Z" })
  }
), F6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12.75 15.25A.74.74 0 0 1 12 16a.72.72 0 0 1-.75-.75V6.562l-2.969 2.97c-.312.312-.781.312-1.062 0-.313-.282-.313-.75 0-1.063l4.25-4.25a.736.736 0 0 1 1.031 0l4.281 4.25c.282.312.282.781 0 1.062-.312.313-.781.313-1.062 0L12.75 6.562zm1-.25v-1.5H18c1.094 0 2 .906 2 2V18c0 1.125-.906 2-2 2H6c-1.125 0-2-.875-2-2v-2.5c0-1.094.875-2 2-2h4.25V15H6c-.281 0-.5.25-.5.5V18c0 .281.219.5.5.5h12c.25 0 .5-.219.5-.5v-2.5c0-.25-.25-.5-.5-.5zM16 16.75a.74.74 0 0 1 .75-.75.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75.72.72 0 0 1-.75-.75" })
  }
), k6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M14.5 8c0-.875-.5-1.688-1.25-2.156-.781-.438-1.75-.438-2.5 0C9.969 6.312 9.5 7.125 9.5 8c0 .906.469 1.719 1.25 2.188.75.437 1.719.437 2.5 0C14 9.717 14.5 8.905 14.5 8M8 8c0-1.406.75-2.719 2-3.438a3.98 3.98 0 0 1 4 0c1.219.72 2 2.032 2 3.438 0 1.438-.781 2.75-2 3.469a3.98 3.98 0 0 1-4 0A3.98 3.98 0 0 1 8 8M6.531 18.5h10.907a4.08 4.08 0 0 0-4.032-3.5h-2.844a4.08 4.08 0 0 0-4.03 3.5ZM5 19.094C5 16 7.469 13.5 10.563 13.5h2.843C16.5 13.5 19 16 19 19.094c0 .5-.438.906-.938.906H5.906A.907.907 0 0 1 5 19.094" })
  }
), D6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.516 11.375A4.83 4.83 0 0 0 12.875 8c0-2.672-2.203-4.875-4.875-4.875-2.695 0-4.875 2.203-4.875 4.875 0 1.313.492 2.508 1.336 3.375A3 3 0 0 1 7.25 9.5h1.5c1.242 0 2.32.773 2.766 1.875m-.938.773a1.88 1.88 0 0 0-1.828-1.523h-1.5c-.914 0-1.688.656-1.852 1.523A4.87 4.87 0 0 0 8 12.875c.938 0 1.828-.258 2.578-.727M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14m0-6.375a.89.89 0 0 0 .797-.469.95.95 0 0 0 0-.937A.94.94 0 0 0 8 5.75a.95.95 0 0 0-.82.469.95.95 0 0 0 0 .937c.164.305.468.469.82.469m-2.063-.938c0-.726.375-1.406 1.032-1.78a2.15 2.15 0 0 1 2.062 0 2.09 2.09 0 0 1 1.031 1.78c0 .75-.398 1.43-1.03 1.805a2.15 2.15 0 0 1-2.063 0 2.05 2.05 0 0 1-1.032-1.805" })
  }
), S6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M16.688 16.5A6.44 6.44 0 0 0 18.5 12c0-3.563-2.938-6.5-6.5-6.5-3.594 0-6.5 2.938-6.5 6.5 0 1.75.656 3.344 1.781 4.5A4 4 0 0 1 11 14h2a3.99 3.99 0 0 1 3.688 2.5m-1.25 1.031c-.22-1.156-1.25-2.031-2.438-2.031h-2c-1.219 0-2.25.875-2.469 2.031 1 .625 2.188.969 3.469.969 1.25 0 2.438-.344 3.438-.969M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20m0-8.5c.438 0 .844-.219 1.063-.625a1.27 1.27 0 0 0 0-1.25A1.25 1.25 0 0 0 12 9c-.469 0-.875.25-1.094.625a1.27 1.27 0 0 0 0 1.25c.219.406.625.625 1.094.625m-2.75-1.25c0-.969.5-1.875 1.375-2.375a2.86 2.86 0 0 1 2.75 0 2.78 2.78 0 0 1 1.375 2.375c0 1-.531 1.906-1.375 2.406a2.86 2.86 0 0 1-2.75 0c-.875-.5-1.375-1.406-1.375-2.406" })
  }
), P6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M12 12c-1.438 0-2.75-.75-3.469-2a3.98 3.98 0 0 1 0-4A4.04 4.04 0 0 1 12 4c1.406 0 2.719.781 3.438 2a3.98 3.98 0 0 1 0 4A3.96 3.96 0 0 1 12 12m-1.438 1.5h2.844C16.5 13.5 19 16 19 19.094c0 .5-.438.906-.938.906H5.906A.907.907 0 0 1 5 19.094C5 16 7.469 13.5 10.563 13.5Z" })
  }
), T6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.5 10.625A3.03 3.03 0 0 1 7 8c0-1.063.563-2.031 1.5-2.594.906-.531 2.063-.531 3 0C12.406 5.97 13 6.938 13 8c0 1.094-.594 2.063-1.5 2.625-.938.531-2.094.531-3 0m3.5.844A4.04 4.04 0 0 0 14 8c0-1.406-.781-2.719-2-3.438a3.98 3.98 0 0 0-4 0C6.75 5.282 6 6.595 6 8c0 1.438.75 2.75 2 3.469a3.98 3.98 0 0 0 4 0M12.257 19H4a4.575 4.575 0 0 1 4.563-4.5h2.528a5.4 5.4 0 0 1 .284-1H8.562C5.47 13.5 3 16 3 19.094c0 .5.406.906.906.906h9.43a5.5 5.5 0 0 1-1.079-1m4.259-8c1.593 0 3.062.875 3.875 2.25a4.46 4.46 0 0 1 0 4.5A4.46 4.46 0 0 1 16.516 20a4.47 4.47 0 0 1-3.907-2.25 4.46 4.46 0 0 1 0-4.5A4.54 4.54 0 0 1 16.516 11m0 8c1.25 0 2.375-.656 3-1.75.656-1.063.656-2.406 0-3.5-.625-1.063-1.75-1.75-3-1.75a3.5 3.5 0 0 0-3.032 1.75c-.656 1.094-.656 2.438 0 3.5A3.44 3.44 0 0 0 16.516 19m-.125-5.594a.53.53 0 0 1 .718 0l1.75 1.75a.53.53 0 0 1 0 .719l-1.75 1.75a.53.53 0 0 1-.718 0 .53.53 0 0 1 0-.719l.906-.906h-2.781a.494.494 0 0 1-.5-.5c0-.25.218-.5.5-.5h2.78l-.905-.875a.53.53 0 0 1 0-.719",
        clipRule: "evenodd"
      }
    )
  }
), _6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M7 4.54a3.975 3.975 0 0 1 4.671.495c.351.318.644.694.864 1.107A3.9 3.9 0 0 1 13 7.982a4 4 0 0 1-.807 2.406A4.1 4.1 0 0 1 11 11.456a4.04 4.04 0 0 1-2.261.532A3.9 3.9 0 0 1 7 11.456c-1.25-.72-2-2.034-2-3.474A3.97 3.97 0 0 1 7 4.54m.748 1.302.007-.004.007-.004a2.48 2.48 0 0 1 2.483.004c.779.463 1.255 1.295 1.255 2.144 0 .888-.482 1.716-1.255 2.176a2.48 2.48 0 0 1-2.483.004l-.007-.004-.007-.004A2.48 2.48 0 0 1 6.5 7.982c0-.87.462-1.688 1.248-2.14",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M13.449 5.746a.1.1 0 0 1 .032-.13 4.3 4.3 0 0 1 .681-.362 3.7 3.7 0 0 1 .62-.197 3.3 3.3 0 0 1 .718-.079c1.906 0 3.5 1.596 3.5 3.505a3.517 3.517 0 0 1-4.72 3.295 3.6 3.6 0 0 1-1.215-.731.1.1 0 0 1-.013-.132c.266-.372.484-.78.643-1.214.03-.082.146-.095.198-.025.273.368.67.64 1.13.752l-.002.005q.23.053.479.053c1.105 0 2-.897 2-2.003a2.001 2.001 0 0 0-3.41-1.42c-.062.061-.174.031-.192-.054a5 5 0 0 0-.45-1.263Z" }),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M2 19.092c0-3.098 2.469-5.601 5.563-5.601h2.843a5.58 5.58 0 0 1 3.68 1.38A5.59 5.59 0 0 1 16 19.092a.86.86 0 0 1-.121.44.96.96 0 0 1-.816.468H2.905A.91.91 0 0 1 2 19.092m12.457-.594H3.543a4.056 4.056 0 0 1 4.02-3.505h2.844a4.09 4.09 0 0 1 4.051 3.505Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M16.067 15.493c-.291-.471-.64-.9-1.036-1.273l-.018-.017c-.067-.064-.023-.181.07-.182.614-.006 1.239-.03 1.854-.03 2.782 0 5.063 2.285 5.063 5.07 0 .532-.438.939-.969.939H16.89c-.077 0-.125-.082-.093-.151a2.04 2.04 0 0 0 .204-.85v-.25q0-.127-.005-.251h3.46a3.6 3.6 0 0 0-2.634-2.892c-.472-.123-1.183-.113-1.755-.113" })
    ]
  }
), O6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M5 8c0-1.406.75-2.719 2-3.438a3.98 3.98 0 0 1 4 0c1.219.72 2 2.032 2 3.438 0 1.438-.781 2.75-2 3.469a3.98 3.98 0 0 1-4 0A3.98 3.98 0 0 1 5 8M2 19.094C2 16 4.469 13.5 7.563 13.5h2.843C13.5 13.5 16 16 16 19.094c0 .5-.438.906-.938.906H2.906A.907.907 0 0 1 2 19.094M21.031 20H16.72c.156-.281.281-.625.281-1v-.25c0-1.875-.875-3.594-2.188-4.719.063 0 .126-.031.22-.031h1.905C19.72 14 22 16.281 22 19.063c0 .53-.438.937-.969.937M15.5 12a3.6 3.6 0 0 1-2.5-1c.625-.844 1-1.875 1-3 0-.813-.219-1.625-.594-2.313C14 5.282 14.72 5 15.5 5 17.406 5 19 6.594 19 8.5c0 1.938-1.594 3.5-3.5 3.5" })
  }
), U6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M5.75 17.496c-.69 0-1.25-.56-1.25-1.25v-.96a.75.75 0 0 0-1.5 0v.96a2.75 2.75 0 0 0 2.75 2.75h1.183a.75.75 0 0 0 0-1.5zm-1.25-6.48a.75.75 0 0 0-1.5 0v1.917a.75.75 0 0 0 1.5 0v-1.918Zm0-2.355v-.959c0-.69.56-1.25 1.25-1.25h1.183a.75.75 0 1 0 0-1.5H5.75A2.75 2.75 0 0 0 3 7.702v.959a.75.75 0 1 0 1.5 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l.jsx("path", { d: "M19.1 17.496c.69 0 1.25-.56 1.25-1.25v-.959a.75.75 0 0 1 1.5 0v.959a2.75 2.75 0 0 1-2.75 2.75l-.957.004a.75.75 0 1 1-.007-1.5zm1.25-6.481a.75.75 0 0 1 1.5 0v1.918a.75.75 0 0 1-1.5 0zm0-2.354v-.959c0-.69-.56-1.25-1.25-1.25l-.957.005a.75.75 0 1 1-.007-1.5l.964-.005a2.75 2.75 0 0 1 2.75 2.75v.959a.75.75 0 0 1-1.5 0M9.43 17.5a.75.75 0 0 0 0 1.5h1.855a.75.75 0 0 0 0-1.5zm4.35 0a.75.75 0 0 0 0 1.5h1.855a.75.75 0 0 0 0-1.5zM11.285 6.457a.75.75 0 0 0 0-1.5H9.43a.75.75 0 1 0 0 1.5zm1.745-.75a.75.75 0 0 1 .75-.75h1.85a.75.75 0 0 1 0 1.5h-1.85a.75.75 0 0 1-.75-.75M9.023 8.738s1.947-.484 2.52-.375c.575.108 1.05 1.537 1.254 2.469q.766-1.133 1.156-1.586.524-.61.86-.789a1.5 1.5 0 0 1 .726-.187q.43 0 .656.234.235.234.235.633a.85.85 0 0 1-.235.617.76.76 0 0 1-.57.234 2.3 2.3 0 0 1-.578-.086 2 2 0 0 0-.445-.093 1 1 0 0 0-.625.234q-.407.321-1 1.367.663 2.344 1.062 2.86.234.304.477.304a.6.6 0 0 0 .351-.101q.227-.165.695-.82l.282.163q-.688 1.11-1.344 1.563-.5.351-.984.351-.5 0-.836-.218-.329-.227-.586-.727-.258-.507-.61-1.617-.914 1.164-1.437 1.703-.516.531-.86.695a1.7 1.7 0 0 1-.734.164q-.405 0-.64-.234a.8.8 0 0 1-.243-.61q0-.398.258-.655a.9.9 0 0 1 .656-.258q.212 0 .477.125.39.187.562.187a.87.87 0 0 0 .407-.094q.234-.117.593-.507.22-.243.805-1.032-.75-2.78-1.172-3.328-.265-.351-.672-.351-.21 0-.515.062z" })
    ]
  }
), q6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M2.75 5.125a.385.385 0 0 0-.375.375v6c0 .21.164.375.375.375h6a.385.385 0 0 0 .375-.375v-6a.4.4 0 0 0-.375-.375zm-1.5.375c0-.82.656-1.5 1.5-1.5h6c.82 0 1.5.68 1.5 1.5v6c0 .844-.68 1.5-1.5 1.5h-6a1.48 1.48 0 0 1-1.5-1.5zm12.375 5.531V5.992L11 7.164V5.945l2.438-1.101c.117-.047.234-.094.374-.094a.94.94 0 0 1 .938.938v5.648a.92.92 0 0 1-.938.914 1 1 0 0 1-.374-.07L11 11.078V9.836z" })
  }
), I6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "currentColor",
    viewBox: "0 0 64 64",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx("path", { d: "M7.5 14.5C5.531 14.5 4 16.14 4 18v28c0 1.969 1.531 3.5 3.5 3.5h28c1.86 0 3.5-1.531 3.5-3.5V18c0-1.86-1.64-3.5-3.5-3.5zM.5 18c0-3.828 3.063-7 7-7h28c3.828 0 7 3.172 7 7v28c0 3.938-3.172 7-7 7h-28c-3.938 0-7-3.063-7-7zm56.766 31.063L46 42.828v-4.047L58.906 46c.11 0 .219.11.328.11a.75.75 0 0 0 .766-.766V18.766a.75.75 0 0 0-.766-.766c-.109 0-.218.11-.328.11L46 25.327V21.28l11.266-6.234c.656-.328 1.312-.547 1.968-.547 2.297 0 4.266 1.969 4.266 4.266v26.578c0 2.297-1.969 4.156-4.266 4.156-.656 0-1.312-.11-1.968-.438Z" }),
      /* @__PURE__ */ l.jsx("path", { d: "m22.443 21.5 8.021 8.02a1.546 1.546 0 0 1 0 2.257 1.546 1.546 0 0 1-2.256 0l-5.263-5.264v15.34c0 .902-.752 1.604-1.605 1.604a1.584 1.584 0 0 1-1.604-1.604v-15.34l-5.314 5.264a1.546 1.546 0 0 1-2.255 0 1.546 1.546 0 0 1 0-2.256l8.02-8.021a1.546 1.546 0 0 1 2.256 0" })
    ]
  }
), W6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M15.531 17.125 6.375 7.969A6.55 6.55 0 0 0 5 12c0 3.594 2.906 6.5 6.5 6.5 1.5 0 2.906-.5 4.031-1.375m1.063-1.063A6.6 6.6 0 0 0 18 12c0-3.563-2.938-6.5-6.5-6.5a6.6 6.6 0 0 0-4.063 1.406zM3.5 12a7.94 7.94 0 0 1 4-6.906c2.469-1.438 5.5-1.438 8 0 2.469 1.437 4 4.062 4 6.906a8.02 8.02 0 0 1-4 6.938c-2.5 1.437-5.531 1.437-8 0A7.95 7.95 0 0 1 3.5 12" })
  }
), $6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#FCCACA",
          d: "M8.012 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6 6.01 6.01 0 0 1 5.203-3 6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6 5.96 5.96 0 0 1-5.18 3m0-9a.555.555 0 0 0-.563.563v2.625c0 .328.235.562.563.562a.555.555 0 0 0 .562-.563V5.563A.57.57 0 0 0 8.012 5m-.75 5.25c0 .422.328.75.75.75.398 0 .75-.328.75-.75a.77.77 0 0 0-.75-.75.755.755 0 0 0-.75.75"
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#E31C1C",
          d: "M8.012 9.5c.398 0 .75.352.75.75 0 .422-.352.75-.75.75a.74.74 0 0 1-.75-.75c0-.398.328-.75.75-.75m0-4.5a.57.57 0 0 1 .562.563v2.625a.555.555 0 0 1-.562.562.54.54 0 0 1-.563-.563V5.563c0-.305.235-.563.563-.563"
        }
      )
    ]
  }
), Y6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "#FCCACA",
            d: "M8 0C3.562 0 0 3.594 0 8c0 4.438 3.563 8 8 8 4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8m-.75 4.75A.74.74 0 0 1 8 4a.76.76 0 0 1 .75.75v4A.74.74 0 0 1 8 9.5a.72.72 0 0 1-.75-.75zM8 12.5a.98.98 0 0 1-1-.969.98.98 0 0 1 1-.969c.531 0 .969.438.969.97A.974.974 0 0 1 8 12.5"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "#E31C1C",
            d: "M8 9.5a.74.74 0 0 0 .75-.75v-4A.76.76 0 0 0 8 4a.74.74 0 0 0-.75.75v4c0 .438.313.75.75.75m0 1.063a.98.98 0 0 0-1 .968.98.98 0 0 0 1 .969.974.974 0 0 0 .969-.969.974.974 0 0 0-.969-.969Z"
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
    ]
  }
), G6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M7.25 3.875h-4.5a.385.385 0 0 0-.375.375V6.5c0 .21.164.375.375.375h4.5a.385.385 0 0 0 .375-.375V4.25a.4.4 0 0 0-.375-.375M2.75 2.75h4.5c.82 0 1.5.68 1.5 1.5V6.5c0 .844-.68 1.5-1.5 1.5h-4.5a1.48 1.48 0 0 1-1.5-1.5V4.25c0-.82.656-1.5 1.5-1.5m10.5 1.125h-1.5a.385.385 0 0 0-.375.375V9.5c0 .21.164.375.375.375h1.5a.385.385 0 0 0 .375-.375V4.25a.4.4 0 0 0-.375-.375m-1.5-1.125h1.5c.82 0 1.5.68 1.5 1.5V9.5c0 .844-.68 1.5-1.5 1.5h-1.5a1.48 1.48 0 0 1-1.5-1.5V4.25c0-.82.656-1.5 1.5-1.5m-7.5 7.5a.385.385 0 0 0-.375.375v1.125c0 .21.164.375.375.375h3.375A.385.385 0 0 0 8 11.75v-1.125a.4.4 0 0 0-.375-.375zm-1.5.375c0-.82.656-1.5 1.5-1.5h3.375c.82 0 1.5.68 1.5 1.5v1.125c0 .844-.68 1.5-1.5 1.5H4.25a1.48 1.48 0 0 1-1.5-1.5z" })
  }
), N6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11 6.5H5c-.281 0-.5.25-.5.5v3c0 .281.219.5.5.5h6c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5M5 5h6c1.094 0 2 .906 2 2v3c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2m14 1.5h-2c-.281 0-.5.25-.5.5v7c0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5M17 5h2c1.094 0 2 .906 2 2v7c0 1.125-.906 2-2 2h-2c-1.125 0-2-.875-2-2V7c0-1.094.875-2 2-2M7 15c-.281 0-.5.25-.5.5V17c0 .281.219.5.5.5h4.5c.25 0 .5-.219.5-.5v-1.5c0-.25-.25-.5-.5-.5zm-2 .5c0-1.094.875-2 2-2h4.5c1.094 0 2 .906 2 2V17c0 1.125-.906 2-2 2H7c-1.125 0-2-.875-2-2z" })
  }
), J6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "m10.313 5.344.437-1.188c.031-.093.125-.156.25-.156.094 0 .188.063.219.156l.437 1.188 1.188.437A.235.235 0 0 1 13 6c0 .125-.063.219-.156.25l-1.188.438-.437 1.156A.235.235 0 0 1 11 8c-.125 0-.219-.063-.25-.156l-.438-1.157-1.156-.437C9.062 6.219 9 6.125 9 6c0-.094.063-.188.156-.219zM4.436 16.375 16.345 4.469a1.49 1.49 0 0 1 2.125 0l1.06 1.061a1.49 1.49 0 0 1 0 2.125L7.625 19.563a1.49 1.49 0 0 1-2.125 0L4.437 18.5a1.49 1.49 0 0 1 0-2.125Zm13.688-9.781-.719-.719-3.281 3.281.719.719zM3.219 7.687 5 7l.656-1.75C5.688 5.094 5.844 5 6 5c.125 0 .281.094.313.25L7 7l1.75.688c.156.03.25.187.25.312 0 .156-.094.313-.25.344L7 9l-.688 1.781c-.03.125-.187.219-.312.219-.156 0-.313-.094-.344-.219L5 9l-1.781-.656C3.094 8.313 3 8.156 3 8c0-.125.094-.281.219-.313m11 8L16 15l.656-1.75c.032-.156.188-.25.344-.25.125 0 .281.094.313.25L18 15l1.75.688c.156.03.25.187.25.312 0 .156-.094.313-.25.344L18 17l-.688 1.781c-.03.125-.187.219-.312.219-.156 0-.313-.094-.344-.219L16 17l-1.781-.656C14.094 16.312 14 16.156 14 16c0-.125.094-.281.219-.313" })
  }
), K6 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M11.586 5.21 8.773 8.024l2.79 2.79a.513.513 0 0 1 0 .773.513.513 0 0 1-.774 0l-2.812-2.79-2.79 2.79a.513.513 0 0 1-.773 0c-.234-.211-.234-.563 0-.797L7.204 8l-2.79-2.79c-.234-.21-.234-.562 0-.796.211-.21.563-.21.797 0L8 7.227l2.79-2.79c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .774Z" })
  }
), Q6 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M12 20c-2.875 0-5.5-1.5-6.938-4-1.437-2.469-1.437-5.5 0-8A8.02 8.02 0 0 1 12 4c2.844 0 5.469 1.531 6.906 4 1.438 2.5 1.438 5.531 0 8A7.94 7.94 0 0 1 12 20M9.469 9.469c-.313.312-.313.781 0 1.062L10.938 12l-1.47 1.469c-.312.312-.312.781 0 1.062a.684.684 0 0 0 1.032 0l1.469-1.469 1.469 1.47c.312.312.78.312 1.062 0 .313-.282.313-.75 0-1.063L13.031 12l1.469-1.469c.313-.281.313-.75 0-1.062-.281-.281-.75-.281-1.063 0l-1.468 1.469-1.469-1.47a.736.736 0 0 0-1.031 0Z",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M10.531 9.469 12 10.938l1.469-1.47a.736.736 0 0 1 1.031 0c.313.313.313.782 0 1.063L13.031 12l1.469 1.469c.313.312.313.781 0 1.062a.684.684 0 0 1-1.031 0L12 13.062l-1.469 1.47c-.312.312-.781.312-1.062 0-.313-.282-.313-.75 0-1.063L10.938 12l-1.47-1.469c-.312-.281-.312-.75 0-1.062.282-.281.75-.281 1.063 0"
        }
      )
    ]
  }
), l8 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsxs("g", { fill: "#000", fillOpacity: 0.25, clipPath: "url(#a)", children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M12 24c-4.313 0-8.25-2.25-10.406-6-2.157-3.703-2.157-8.25 0-12C3.75 2.297 7.687 0 12 0c4.266 0 8.203 2.297 10.36 6 2.156 3.75 2.156 8.297 0 12A11.91 11.91 0 0 1 12 24M8.203 8.203c-.469.469-.469 1.172 0 1.594L10.406 12l-2.203 2.203c-.469.469-.469 1.172 0 1.594a1.027 1.027 0 0 0 1.547 0l2.203-2.203 2.203 2.203c.469.469 1.172.469 1.594 0 .469-.422.469-1.125 0-1.594L13.547 12l2.203-2.203c.469-.422.469-1.125 0-1.594-.422-.422-1.125-.422-1.594 0l-2.203 2.203L9.75 8.203a1.104 1.104 0 0 0-1.547 0",
            opacity: 0.25
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M9.797 8.203 12 10.406l2.203-2.203a1.104 1.104 0 0 1 1.547 0c.469.469.469 1.172 0 1.594L13.547 12l2.203 2.203c.469.469.469 1.172 0 1.594a1.027 1.027 0 0 1-1.547 0L12 13.594l-2.203 2.203c-.469.469-1.172.469-1.594 0-.469-.422-.469-1.125 0-1.594L10.406 12 8.203 9.797c-.469-.422-.469-1.125 0-1.594.422-.422 1.125-.422 1.594 0" })
      ] }),
      /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "a", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
), c8 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14M6.102 6.102c-.235.234-.235.585 0 .796L7.203 8 6.102 9.102c-.235.234-.235.585 0 .796.21.235.562.235.773 0l1.102-1.101 1.101 1.101c.235.235.586.235.797 0 .234-.21.234-.562 0-.796L8.773 8l1.102-1.102c.234-.21.234-.562 0-.796-.21-.211-.563-.211-.797 0L7.977 7.203 6.875 6.102a.55.55 0 0 0-.773 0" })
  }
), a8 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M4 12c0-4.406 3.563-8 8-8 4.406 0 8 3.594 8 8 0 4.438-3.594 8-8 8-4.438 0-8-3.563-8-8m5.469-1.469L10.938 12l-1.47 1.469c-.312.312-.312.781 0 1.062a.684.684 0 0 0 1.032 0l1.469-1.469 1.5 1.47a.684.684 0 0 0 1.031 0c.313-.282.313-.75 0-1.063L13.031 12l1.469-1.469c.313-.281.313-.75 0-1.062a.736.736 0 0 0-1.031 0l-1.5 1.5-1.469-1.5a.736.736 0 0 0-1.031 0c-.313.312-.313.781 0 1.062" })
  }
), t8 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillRule: "evenodd",
          d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m3.527-3.464a.723.723 0 0 0 0-1.055l-2.46-2.46 2.46-2.485a.723.723 0 0 0 0-1.055.723.723 0 0 0-1.054 0L8.012 6.942l-2.485-2.46a.723.723 0 0 0-1.054 0 .723.723 0 0 0 0 1.054l2.46 2.461-2.46 2.484a.723.723 0 0 0 0 1.055c.14.14.328.211.539.211.187 0 .375-.07.515-.21l2.485-2.462 2.46 2.461c.141.14.329.211.54.211.187 0 .375-.07.515-.21Z",
          clipRule: "evenodd",
          opacity: 0.05
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M11.527 10.481a.723.723 0 0 1 0 1.055.73.73 0 0 1-.515.211.74.74 0 0 1-.54-.21l-2.46-2.462-2.485 2.461a.73.73 0 0 1-.515.211.74.74 0 0 1-.54-.21.723.723 0 0 1 0-1.056l2.462-2.484-2.461-2.46a.723.723 0 0 1 0-1.056.723.723 0 0 1 1.054 0l2.485 2.461 2.46-2.46a.723.723 0 0 1 1.055 0 .723.723 0 0 1 0 1.054l-2.46 2.485z"
        }
      )
    ]
  }
), h8 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M8 14a5.97 5.97 0 0 1-5.203-3 5.97 5.97 0 0 1 0-6A6.01 6.01 0 0 1 8 2a6 6 0 0 1 5.18 3 5.97 5.97 0 0 1 0 6A5.96 5.96 0 0 1 8 14M6.102 6.102c-.235.234-.235.585 0 .796L7.203 8 6.102 9.102c-.235.234-.235.585 0 .796.21.235.562.235.773 0l1.102-1.101 1.101 1.101c.235.235.586.235.797 0 .234-.21.234-.562 0-.796L8.773 8l1.102-1.102c.234-.21.234-.562 0-.796-.21-.211-.563-.211-.797 0L7.977 7.203 6.875 6.102a.55.55 0 0 0-.773 0",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.25,
          d: "M6.898 6.102 8 7.203l1.102-1.101a.55.55 0 0 1 .773 0c.234.234.234.585 0 .796L8.773 8l1.102 1.102c.234.234.234.585 0 .796a.513.513 0 0 1-.773 0L8 8.797 6.898 9.898c-.234.235-.585.235-.796 0-.235-.21-.235-.562 0-.796L7.203 8 6.102 6.898c-.235-.21-.235-.562 0-.796.21-.211.562-.211.796 0"
        }
      )
    ]
  }
), e8 = (c) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.55,
          d: "M12.5 22.625c-3.773 0-7.219-1.969-9.105-5.25-1.887-3.24-1.887-7.219 0-10.5a10.52 10.52 0 0 1 9.105-5.25c3.732 0 7.178 2.01 9.064 5.25 1.887 3.281 1.887 7.26 0 10.5a10.42 10.42 0 0 1-9.064 5.25",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "#000",
          fillOpacity: 0.55,
          d: "m16.016 10.04-2.461 2.46 2.46 2.484a.723.723 0 0 1 0 1.055.723.723 0 0 1-1.054 0L12.5 13.58l-2.484 2.46a.723.723 0 0 1-1.055 0 .723.723 0 0 1 0-1.055l2.46-2.484-2.46-2.46a.723.723 0 0 1 0-1.056.723.723 0 0 1 1.055 0l2.484 2.461 2.46-2.46a.723.723 0 0 1 1.056 0 .723.723 0 0 1 0 1.054"
        }
      )
    ]
  }
), r8 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M3.71 2.914 8 7.227l4.29-4.29c.21-.234.562-.234.796 0a.55.55 0 0 1 0 .774L8.773 8.023l4.29 4.29a.513.513 0 0 1 0 .773.513.513 0 0 1-.774 0l-4.312-4.29-4.29 4.29a.513.513 0 0 1-.773 0c-.234-.211-.234-.563 0-.797L7.204 8l-4.29-4.29c-.234-.21-.234-.562 0-.796.211-.21.563-.21.797 0Z" })
  }
), i8 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M6.5 6.5c-.281 0-.5.25-.5.5v10c0 .281.219.5.5.5h10c.25 0 .5-.219.5-.5V7c0-.25-.25-.5-.5-.5zm-2 .5c0-1.094.875-2 2-2h10c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2h-10c-1.125 0-2-.875-2-2zm4.469 2.469a.736.736 0 0 1 1.031 0l1.469 1.469 1.469-1.47c.312-.28.78-.28 1.062 0 .313.313.313.782 0 1.063L12.531 12 14 13.469c.313.312.313.781 0 1.062-.281.313-.75.313-1.063 0l-1.468-1.469L10 14.533a.684.684 0 0 1-1.031 0c-.313-.282-.313-.75 0-1.063L10.438 12l-1.47-1.469c-.312-.281-.312-.75 0-1.062Z" })
  }
), s8 = (c) => /* @__PURE__ */ l.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l.jsx("path", { d: "M.875 7.5v-3l.013-.126a.625.625 0 0 1 .612-.499h3a.625.625 0 1 1 0 1.25H2.125V7.5a.625.625 0 1 1-1.25 0m22.25 9v3l-.013.126a.625.625 0 0 1-.612.499h-3a.625.625 0 1 1 0-1.25h2.375V16.5a.625.625 0 1 1 1.25 0M19.5 3.875h3l.126.013c.285.058.499.31.499.612v3a.625.625 0 1 1-1.25 0V5.125H19.5a.625.625 0 1 1 0-1.25m-15 16.25h-3l-.126-.013a.625.625 0 0 1-.499-.612v-3a.625.625 0 1 1 1.25 0v2.375H4.5a.625.625 0 1 1 0 1.25M16.75 12A4.75 4.75 0 1 0 12 16.75V18a6 6 0 1 1 0-12 6 6 0 0 1 0 12v-1.25A4.75 4.75 0 0 0 16.75 12" })
  }
), B1 = {
  "address-24x24": g5,
  "adjust-16x16": m5,
  "adjust-24x24": p5,
  "advanced-settings-24x24": u5,
  "advanced-settings-duotone-24x24": f5,
  "advanced-settings-fill-24x24": j5,
  "advanced-settings-large-24x24": M5,
  "alert-24x24": C5,
  "angle-24x24": A5,
  "annotation-16x16": V5,
  "annotation-24x24": z5,
  "approve-24x24": H5,
  "approve-duotone-24x24": B5,
  "area-duotone-24x24": L5,
  "arrow-expand-24x24": X5,
  "arrow-left-24x24": R5,
  "arrow-resume-24x24": y5,
  "arrow-right-16x16": Z5,
  "arrow-right-24x24": E5,
  "arrow-rotate-right-24x24": b5,
  "arrow-to-line-down-to-bottom-24x24": F5,
  "arrow-to-line-right-large-24x24": k5,
  "arrow-to-line-top-16x16": D5,
  "arrow-to-line-up-to-top-24x24": S5,
  "bell-24x24": P5,
  "bell-unread-24x24": T5,
  "book-demo-duotone-24x24": _5,
  "broken-file-30x30": O5,
  "bulb-on-24x24": U5,
  "bundle-24x24": q5,
  "calendar-16x16": I5,
  "calendar-24x24": W5,
  "calibrate-2-24x24": $5,
  "calibrate-24x24": Y5,
  "camera-24x24": G5,
  "caution-circle-duotone-16x16": N5,
  "caution-circle-large-duotone-16x16": J5,
  "chart-line-up-24x24": K5,
  "check-circle-16x16": Q5,
  "check-circle-24x24": l0,
  "check-circle-fill-16x16": c0,
  "check-circle-fill-24x24": a0,
  "check-mark-16x16": t0,
  "check-mark-24x24": h0,
  "chevron-down-16x16": e0,
  "chevron-down-24x24": r0,
  "chevron-down-duotone-16x16": i0,
  "chevron-down-duotone-24x24": s0,
  "chevron-down-small-16x12": o0,
  "chevron-large-left-24x16": n0,
  "chevron-left-16x10": v0,
  "chevron-left-24x12": w0,
  "chevron-left-duotone-24x24": x0,
  "chevron-right-16x10": d0,
  "chevron-right-24x12": g0,
  "chevron-right-duotone-24x24": m0,
  "chevron-up-16x16": p0,
  "chevron-up-24x24": u0,
  "chevron-up-down-16x16": f0,
  "chevron-up-down-24x24": j0,
  "chevron-up-duotone-16x16": M0,
  "chevron-up-duotone-24x24": C0,
  "chevrons-down-16x16": A0,
  "chevrons-up-16x16": V0,
  "circle-play-30x30": z0,
  "close-24x24": H0,
  "close-duotone-30x30": B0,
  "close-fill-24x24": L0,
  "close-large-24x24": X0,
  "cloud-down-24x24": R0,
  "code-24x24": y0,
  "collaborate-16x16": Z0,
  "collaborate-24x24": E0,
  "columns-16x16": b0,
  "columns-24x24": F0,
  "comment-up-24x24": k0,
  "comment-up-fill-24x24": D0,
  "community-24x24": S0,
  "company-16x16": P0,
  "company-24x24": T0,
  "company-fill-24x24": _0,
  "convert-16x16": O0,
  "copy-16x16": U0,
  "copy-24x24": q0,
  "cost-16x16": I0,
  "cube-3d-24x24": W0,
  "deselect-16x16": $0,
  "deselect-24x24": Y0,
  "diagram-project-24x24": G0,
  "diagram-subtask-24x24": N0,
  "download-16x16": J0,
  "download-24x24": K0,
  "download-duotone-24x24": Q0,
  "download-fill-24x24": l2,
  "drawing-24x24": c2,
  "duplicate-24x24": a2,
  "duplicate-large-24x24": t2,
  "edit-16x16": h2,
  "edit-24x24": e2,
  "edit-background-24x24": r2,
  "edit-pen-16x16": i2,
  "edit-pen-24x24": s2,
  "email-24x24": o2,
  "email-duotone-24x24": n2,
  "eraser-16x16": v2,
  "eraser-24x24": w2,
  "exclamation-24x24": x2,
  "exclamation-circle-duotone-16x16": d2,
  "exclamation-circle-fill-16x16": g2,
  "exclamation-circle-large-duotone-16x16": m2,
  "exclamation-duotone-16x16": p2,
  "exclamation-duotone-2-24x24": u2,
  "exclamation-duotone-24x24": f2,
  "exclamation-triangle-24x24": j2,
  "exclamation-triangle-fill-16x16": M2,
  "exclamation-triangle-fill-24x24": C2,
  "exit-full-screen-fill-24x24": A2,
  "export-16x16": V2,
  "export-multi-drawing-24x24": z2,
  "eye-20x20": H2,
  "eye-24x24": B2,
  "eye-30x30": L2,
  "eye-large-24x24": X2,
  "eye-slash-16x16": R2,
  "eye-slash-20x20": y2,
  "eye-slash-24x24": Z2,
  "eye-slash-30x30": E2,
  "facebook-fill-24x24": b2,
  "fast-forward-fill-24x24": F2,
  "file-24x24": k2,
  "file-export-24x24": D2,
  "file-export-large-24x24": S2,
  "file-pdf-solid-16x16": P2,
  "files-24x24": T2,
  "filter-16x16": _2,
  "filter-24x24": O2,
  "flip-24x24": U2,
  "flip-Bold-24x24": q2,
  "flip-s-24x24": I2,
  "floorplan-outline-24x24": W2,
  "floppy-disk-check-fill-16x16": $2,
  "folder-16x16": Y2,
  "folder-24x24": G2,
  "folder-badge-16x16": N2,
  "folder-open-24x24": J2,
  "folder-user-16x16": K2,
  "folder-user-24x24": Q2,
  "for-you-card-24x24": l4,
  "forms-and-templates-fill-24x24": c4,
  "full-screen-fill-24x24": a4,
  "fullscreen-24x24": t4,
  "globe-16x16": h4,
  "globe-24x24": e4,
  "go-back-fill-24x24": r4,
  "grid-24x24": i4,
  "grip-16x16": s4,
  "grip-24x24": o4,
  "grip-dots-16x16": n4,
  "grip-dots-24x24": v4,
  "handshake-24x24": w4,
  "header-footer-16x16": x4,
  "help-circle-24x24": d4,
  "help-question-mark-24x24": g4,
  "hide-right-corner-24x24": m4,
  "history-24x24": p4,
  "home-24x24": u4,
  "home-large-24x24": f4,
  "hourglass-16x16": j4,
  "hourglass-end-24x24": M4,
  "image-16x16": C4,
  "image-24x24": A4,
  "import-16x16": V4,
  "import-24x24": z4,
  "info-24x24": H4,
  "info-circle-16x16": B4,
  "info-duotone-16x16": L4,
  "info-duotone-24x24": X4,
  "input-24x24": R4,
  "intergration-24x24": y4,
  "intergration-fill-24x24": Z4,
  "layers-24x24": E4,
  "layers-large-24x24": b4,
  "layout-24x24": F4,
  "library-fill-24x24": k4,
  "link-24x24": D4,
  "linked-16x16": S4,
  "linked-Indicator-16x16": P4,
  "list-24x24": T4,
  "list-check-24x24": _4,
  "list-tree-24x24": O4,
  "loading-16x16": U4,
  "loading-24x24": q4,
  "lock-24x24": I4,
  "lock-fill-16x16": W4,
  "lock-open-24x24": $4,
  "logout-24x24": Y4,
  "logout-fill-24x24": G4,
  "magnet-24x24": N4,
  "magnet-large-24x24": J4,
  "measure-dimension-styles-large-24x24": K4,
  "media-24x24": Q4,
  "media-duotone-24x24": l3,
  "menu-hamburger-24x24": c3,
  "minus-16x16": a3,
  "minus-24x24": t3,
  "minus-circle-24x24": h3,
  "minus-circle-duotone-24x24": e3,
  "mirror-24x24": r3,
  "mirror-Bold-24x24": i3,
  "mirror-large-24x24": s3,
  "modified-16x16": o3,
  "money-bag-duotone-24x24": n3,
  "more-16x16": v3,
  "more-24x24": w3,
  "more-circle-24x24": x3,
  "more-circle-duotone-24x24": d3,
  "more-vertical-24x24": g3,
  "move-16x16": m3,
  "move-24x24": p3,
  "muted-fill-24x24": u3,
  "new-section-24x24": f3,
  "new-widget-24x24": j3,
  "news-24x24": M3,
  "next-fill-24x24": C3,
  "on-cloud-24x24": A3,
  "order-16x16": V3,
  "order-alphabet-a-to-z-24x24": z3,
  "order-alphabet-z-to-a-24x24": H3,
  "order-down-16x16": B3,
  "order-manual-24x24": L3,
  "order-up-16x16": X3,
  "page-setting-24x24": R3,
  "pause-fill-24x24": y3,
  "payment-arcsite-payment-24x24": Z3,
  "payment-card-duotone-24x24": E3,
  "payment-card-fill-24x24": b3,
  "payment-check-24x24": F3,
  "payment-diners-club-fill-24x24": k3,
  "payment-discover-fill-24x24": D3,
  "payment-jcb-fill-24x24": S3,
  "payment-mastercard-fill-24x24": P3,
  "payment-setting-24x24": T3,
  "payment-visa-fill-24x24": _3,
  "pdf-24x24": O3,
  "pdf-fill-24x24": U3,
  "pdf-large-24x24": q3,
  "pen-autofill-24x24": I3,
  "pending-hourglass-24x24": W3,
  "perimeter-24x24": $3,
  "photo-upload-64x64": Y3,
  "pinned-circle-filled-24x24": G3,
  "playback-fill-24x24": N3,
  "plus-16x16": J3,
  "plus-24x24": K3,
  "plus-circle-24x24": Q3,
  "plus-circle-fill-24x24": l7,
  "preview-16x16": c7,
  "preview-24x24": a7,
  "product-group-16x16": t7,
  "product-group-24x24": h7,
  "product-group-badge-16x16": e7,
  "product-tags-24x24": r7,
  "proposal-16x16": i7,
  "proposal-solid-16x16": s7,
  "protate-90-fill-24x24": o7,
  "qr-code-24x24": n7,
  "quantity-24x24": v7,
  "question-circle-16x16": w7,
  "real-time-dimension-24x24": x7,
  "redo-24x24": d7,
  "redo2-24x24": g7,
  "redo2-large-24x24": m7,
  "remove-16x16": p7,
  "remove-24x24": u7,
  "replay-fill-24x24": f7,
  "reports-duotone-24x24": j7,
  "rewind-fill-24x24": M7,
  "rotate-90-16x16": C7,
  "rotate-90-2-24x24": A7,
  "rotate-90-24x24": V7,
  "route-24x24": z7,
  "save-24x24": H7,
  "save-as-24x24": B7,
  "save-large-24x24": L7,
  "saved-24x24": X7,
  "saved-duotone-24x24": R7,
  "scan-24x24": y7,
  "screenshot-24x24": Z7,
  "search-16x16": E7,
  "search-24x24": b7,
  "section-break-24x24": F7,
  "select-all-24x24": k7,
  "send-24x24": D7,
  "send-duotone-24x24": S7,
  "setting-16x16": P7,
  "setting-24x24": T7,
  "shape-16x16": _7,
  "shapes-24x24": O7,
  "share-24x24": U7,
  "share-large-24x24": q7,
  "sign-proposal-24x24": I7,
  "signature-24x24": W7,
  "signature-duotone-24x24": $7,
  "snapping-point-24x24": Y7,
  "sort-16x16": G7,
  "sort-ascend-24x24": N7,
  "sort-decend-24x24": J7,
  "spreadsheet-24x24": K7,
  "square-arrow-up-right-24x24": Q7,
  "star-24x24": l6,
  "star-favorite-duotone-24x24": c6,
  "star-fill-16x16": a6,
  "star-fill-24x24": t6,
  "support-24x24": h6,
  "table-24x24": e6,
  "tag-16x16": r6,
  "tag-24x24": i6,
  "tag-badge-16x16": s6,
  "tags-fill-24x24": o6,
  "takeoff-estimate-24x24": n6,
  "takeoff-estimate-duotone-24x24": v6,
  "takeoff-estimate-large-24x24": w6,
  "template-24x24": x6,
  "template-large-24x24": d6,
  "trace-settings-large-24x24": g6,
  "triangle-down-16x16": m6,
  "triangle-large-down-16x16": p6,
  "triangle-large-left-16x16": u6,
  "triangle-large-right-16x16": f6,
  "triangle-large-up-16x16": j6,
  "triangle-left-16x16": M6,
  "triangle-right-16x16": C6,
  "triangle-up-16x16": A6,
  "tutorial-bulb-24x24": V6,
  "twitter-fill-24x24": z6,
  "undo-24x24": H6,
  "undo2-24x24": B6,
  "undo2-large-24x24": L6,
  "unmuted-fill-24x24": X6,
  "unread-16x16": R6,
  "unread-24x16": y6,
  "unstar-24x24": Z6,
  "update-sync-24x24": E6,
  "upload-16x16": b6,
  "upload-24x24": F6,
  "user-24x24": k6,
  "user-circle-16x16": D6,
  "user-circle-24x24": S6,
  "user-fill-24x24": P6,
  "user-identity-24x24": T6,
  "users-24x24": _6,
  "users-fill-24x24": O6,
  "variable-24x24": U6,
  "video-16x16": q6,
  "video-upload-64x64": I6,
  "void-24x24": W6,
  "warning-circle-duotone-16x16": $6,
  "warning-circle-large-duotone-16x16": Y6,
  "widget-16x16": G6,
  "widget-24x24": N6,
  "wizard-fill-24x24": J6,
  "xmark-16x16": K6,
  "xmark-circle-duotone-24x24": Q6,
  "xmark-circle-duotone-large-24x24": l8,
  "xmark-circle-fill-16x16": c8,
  "xmark-circle-fill-24x24": a8,
  "xmark-clear-duotone-16x16": t8,
  "xmark-duotone-16x16": h8,
  "xmark-filter-24x24": e8,
  "xmark-large-16x16": r8,
  "xmark-square-24x24": i8,
  "zoom-to-fit-large-24x24": s8
};
function n8({ name: c, ...j }) {
  const z = B1[c];
  if (!z)
    throw new Error(
      `Icon "${c}" not found. Available icons: ${Object.keys(B1).join(", ")}`
    );
  return /* @__PURE__ */ l.jsx(z, { ...j });
}
export {
  n8 as Icon
};
